import { p as T3, c as Te, g as Fe, j as F3 } from "./jsx-runtime.js";
import { c as nt, a as I3 } from "./emotion-css.esm.js";
import { Y as Ye, F as l, m as s, J as se, K as ne, $ as A, Z as G, o as B, r as Ie, I as We, W as he, l as Af, U as ze, Q as In, a as Bf } from "./index4.js";
import { o as Df } from "./index3.js";
import * as c from "react";
import w, { useLayoutEffect as Vf, useRef as ln, useCallback as _n, useEffect as Dn, useState as Ue, useMemo as En, createContext as Tf, useContext as Ff, forwardRef as _3 } from "react";
import { _ as If, c as Ve, m as u1 } from "./polished.esm.js";
import { a as _f, l as Gf, V as Uf, o as f1 } from "./index8.js";
import { h as Wf, c as Yf, E as Xf } from "./index9.js";
import { h as y, v as Ae, p as Q, z as fe, y as G3, a as _e, M as o1, S as qf, d as en, I as U3, C as W3, E as Kf, B as Jf, k as Gn, F as qn, G as Y3, A as X3, O as q3, R as Nn, J as Qf } from "./index2.js";
import { v as be, e as Xe, l as ye, a as sn } from "./index5.js";
import { useChatbotContext as e4 } from "./useChatbotContext.js";
var K3 = {}, ot = { exports: {} }, de = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var d1;
function n4() {
  if (d1)
    return de;
  d1 = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, u = e ? Symbol.for("react.strict_mode") : 60108, d = e ? Symbol.for("react.profiler") : 60114, p = e ? Symbol.for("react.provider") : 60109, v = e ? Symbol.for("react.context") : 60110, g = e ? Symbol.for("react.async_mode") : 60111, m = e ? Symbol.for("react.concurrent_mode") : 60111, h = e ? Symbol.for("react.forward_ref") : 60112, b = e ? Symbol.for("react.suspense") : 60113, E = e ? Symbol.for("react.suspense_list") : 60120, k = e ? Symbol.for("react.memo") : 60115, L = e ? Symbol.for("react.lazy") : 60116, P = e ? Symbol.for("react.block") : 60121, R = e ? Symbol.for("react.fundamental") : 60117, Y = e ? Symbol.for("react.responder") : 60118, M = e ? Symbol.for("react.scope") : 60119;
  function a(o) {
    if (typeof o == "object" && o !== null) {
      var f = o.$$typeof;
      switch (f) {
        case t:
          switch (o = o.type, o) {
            case g:
            case m:
            case r:
            case d:
            case u:
            case b:
              return o;
            default:
              switch (o = o && o.$$typeof, o) {
                case v:
                case h:
                case L:
                case k:
                case p:
                  return o;
                default:
                  return f;
              }
          }
        case n:
          return f;
      }
    }
  }
  function i(o) {
    return a(o) === m;
  }
  return de.AsyncMode = g, de.ConcurrentMode = m, de.ContextConsumer = v, de.ContextProvider = p, de.Element = t, de.ForwardRef = h, de.Fragment = r, de.Lazy = L, de.Memo = k, de.Portal = n, de.Profiler = d, de.StrictMode = u, de.Suspense = b, de.isAsyncMode = function(o) {
    return i(o) || a(o) === g;
  }, de.isConcurrentMode = i, de.isContextConsumer = function(o) {
    return a(o) === v;
  }, de.isContextProvider = function(o) {
    return a(o) === p;
  }, de.isElement = function(o) {
    return typeof o == "object" && o !== null && o.$$typeof === t;
  }, de.isForwardRef = function(o) {
    return a(o) === h;
  }, de.isFragment = function(o) {
    return a(o) === r;
  }, de.isLazy = function(o) {
    return a(o) === L;
  }, de.isMemo = function(o) {
    return a(o) === k;
  }, de.isPortal = function(o) {
    return a(o) === n;
  }, de.isProfiler = function(o) {
    return a(o) === d;
  }, de.isStrictMode = function(o) {
    return a(o) === u;
  }, de.isSuspense = function(o) {
    return a(o) === b;
  }, de.isValidElementType = function(o) {
    return typeof o == "string" || typeof o == "function" || o === r || o === m || o === d || o === u || o === b || o === E || typeof o == "object" && o !== null && (o.$$typeof === L || o.$$typeof === k || o.$$typeof === p || o.$$typeof === v || o.$$typeof === h || o.$$typeof === R || o.$$typeof === Y || o.$$typeof === M || o.$$typeof === P);
  }, de.typeOf = a, de;
}
var ge = {}, g1;
function t4() {
  return g1 || (g1 = 1, T3.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, u = e ? Symbol.for("react.strict_mode") : 60108, d = e ? Symbol.for("react.profiler") : 60114, p = e ? Symbol.for("react.provider") : 60109, v = e ? Symbol.for("react.context") : 60110, g = e ? Symbol.for("react.async_mode") : 60111, m = e ? Symbol.for("react.concurrent_mode") : 60111, h = e ? Symbol.for("react.forward_ref") : 60112, b = e ? Symbol.for("react.suspense") : 60113, E = e ? Symbol.for("react.suspense_list") : 60120, k = e ? Symbol.for("react.memo") : 60115, L = e ? Symbol.for("react.lazy") : 60116, P = e ? Symbol.for("react.block") : 60121, R = e ? Symbol.for("react.fundamental") : 60117, Y = e ? Symbol.for("react.responder") : 60118, M = e ? Symbol.for("react.scope") : 60119;
    function a(_) {
      return typeof _ == "string" || typeof _ == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      _ === r || _ === m || _ === d || _ === u || _ === b || _ === E || typeof _ == "object" && _ !== null && (_.$$typeof === L || _.$$typeof === k || _.$$typeof === p || _.$$typeof === v || _.$$typeof === h || _.$$typeof === R || _.$$typeof === Y || _.$$typeof === M || _.$$typeof === P);
    }
    function i(_) {
      if (typeof _ == "object" && _ !== null) {
        var ue = _.$$typeof;
        switch (ue) {
          case t:
            var ve = _.type;
            switch (ve) {
              case g:
              case m:
              case r:
              case d:
              case u:
              case b:
                return ve;
              default:
                var je = ve && ve.$$typeof;
                switch (je) {
                  case v:
                  case h:
                  case L:
                  case k:
                  case p:
                    return je;
                  default:
                    return ue;
                }
            }
          case n:
            return ue;
        }
      }
    }
    var o = g, f = m, j = v, x = p, Z = t, N = h, O = r, $ = L, H = k, z = n, ie = d, X = u, ee = b, re = !1;
    function I(_) {
      return re || (re = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), q(_) || i(_) === g;
    }
    function q(_) {
      return i(_) === m;
    }
    function K(_) {
      return i(_) === v;
    }
    function J(_) {
      return i(_) === p;
    }
    function W(_) {
      return typeof _ == "object" && _ !== null && _.$$typeof === t;
    }
    function un(_) {
      return i(_) === h;
    }
    function Be(_) {
      return i(_) === r;
    }
    function Je(_) {
      return i(_) === L;
    }
    function nn(_) {
      return i(_) === k;
    }
    function fn(_) {
      return i(_) === n;
    }
    function tn(_) {
      return i(_) === d;
    }
    function bn(_) {
      return i(_) === u;
    }
    function dn(_) {
      return i(_) === b;
    }
    ge.AsyncMode = o, ge.ConcurrentMode = f, ge.ContextConsumer = j, ge.ContextProvider = x, ge.Element = Z, ge.ForwardRef = N, ge.Fragment = O, ge.Lazy = $, ge.Memo = H, ge.Portal = z, ge.Profiler = ie, ge.StrictMode = X, ge.Suspense = ee, ge.isAsyncMode = I, ge.isConcurrentMode = q, ge.isContextConsumer = K, ge.isContextProvider = J, ge.isElement = W, ge.isForwardRef = un, ge.isFragment = Be, ge.isLazy = Je, ge.isMemo = nn, ge.isPortal = fn, ge.isProfiler = tn, ge.isStrictMode = bn, ge.isSuspense = dn, ge.isValidElementType = a, ge.typeOf = i;
  }()), ge;
}
T3.env.NODE_ENV === "production" ? ot.exports = n4() : ot.exports = t4();
var r4 = ot.exports;
Object.defineProperty(K3, "__esModule", { value: !0 });
var tt = w, a4 = r4;
function J3(e, t, n) {
  return t === void 0 && (t = 0), n === void 0 && (n = []), tt.Children.toArray(e).reduce(function(r, u, d) {
    return a4.isFragment(u) ? r.push.apply(r, J3(u.props.children, t + 1, n.concat(u.key || d))) : tt.isValidElement(u) ? r.push(tt.cloneElement(u, {
      key: n.concat(String(u.key)).join(".")
    })) : (typeof u == "string" || typeof u == "number") && r.push(u), r;
  }, []);
}
var o4 = K3.default = J3, l4 = Vf, i4 = function(t) {
  var n = c.useRef(t);
  return l4(function() {
    n.current = t;
  }), n;
}, h1 = function(t, n) {
  if (typeof t == "function") {
    t(n);
    return;
  }
  t.current = n;
}, c4 = function(t, n) {
  var r = ln();
  return _n(function(u) {
    t.current = u, r.current && h1(r.current, null), r.current = n, n && h1(n, u);
  }, [n]);
}, p1 = {
  "min-height": "0",
  "max-height": "none",
  height: "0",
  visibility: "hidden",
  overflow: "hidden",
  position: "absolute",
  "z-index": "-1000",
  top: "0",
  right: "0"
}, s4 = function(t) {
  Object.keys(p1).forEach(function(n) {
    t.style.setProperty(n, p1[n], "important");
  });
}, v1 = s4, ke = null, m1 = function(t, n) {
  var r = t.scrollHeight;
  return n.sizingStyle.boxSizing === "border-box" ? r + n.borderSize : r - n.paddingSize;
};
function u4(e, t, n, r) {
  n === void 0 && (n = 1), r === void 0 && (r = 1 / 0), ke || (ke = document.createElement("textarea"), ke.setAttribute("tabindex", "-1"), ke.setAttribute("aria-hidden", "true"), v1(ke)), ke.parentNode === null && document.body.appendChild(ke);
  var u = e.paddingSize, d = e.borderSize, p = e.sizingStyle, v = p.boxSizing;
  Object.keys(p).forEach(function(E) {
    var k = E;
    ke.style[k] = p[k];
  }), v1(ke), ke.value = t;
  var g = m1(ke, e);
  ke.value = t, g = m1(ke, e), ke.value = "x";
  var m = ke.scrollHeight - u, h = m * n;
  v === "border-box" && (h = h + u + d), g = Math.max(h, g);
  var b = m * r;
  return v === "border-box" && (b = b + u + d), g = Math.min(b, g), [g, m];
}
var b1 = function() {
}, f4 = function(t, n) {
  return t.reduce(function(r, u) {
    return r[u] = n[u], r;
  }, {});
}, d4 = [
  "borderBottomWidth",
  "borderLeftWidth",
  "borderRightWidth",
  "borderTopWidth",
  "boxSizing",
  "fontFamily",
  "fontSize",
  "fontStyle",
  "fontWeight",
  "letterSpacing",
  "lineHeight",
  "paddingBottom",
  "paddingLeft",
  "paddingRight",
  "paddingTop",
  // non-standard
  "tabSize",
  "textIndent",
  // non-standard
  "textRendering",
  "textTransform",
  "width",
  "wordBreak"
], g4 = !!document.documentElement.currentStyle, h4 = function(t) {
  var n = window.getComputedStyle(t);
  if (n === null)
    return null;
  var r = f4(d4, n), u = r.boxSizing;
  if (u === "")
    return null;
  g4 && u === "border-box" && (r.width = parseFloat(r.width) + parseFloat(r.borderRightWidth) + parseFloat(r.borderLeftWidth) + parseFloat(r.paddingRight) + parseFloat(r.paddingLeft) + "px");
  var d = parseFloat(r.paddingBottom) + parseFloat(r.paddingTop), p = parseFloat(r.borderBottomWidth) + parseFloat(r.borderTopWidth);
  return {
    sizingStyle: r,
    paddingSize: d,
    borderSize: p
  };
}, p4 = h4;
function Q3(e, t, n) {
  var r = i4(n);
  c.useLayoutEffect(function() {
    var u = function(p) {
      return r.current(p);
    };
    if (e)
      return e.addEventListener(t, u), function() {
        return e.removeEventListener(t, u);
      };
  }, []);
}
var v4 = function(t) {
  Q3(window, "resize", t);
}, m4 = function(t) {
  Q3(document.fonts, "loadingdone", t);
}, b4 = ["cacheMeasurements", "maxRows", "minRows", "onChange", "onHeightChange"], y4 = function(t, n) {
  var r = t.cacheMeasurements, u = t.maxRows, d = t.minRows, p = t.onChange, v = p === void 0 ? b1 : p, g = t.onHeightChange, m = g === void 0 ? b1 : g, h = _f(t, b4), b = h.value !== void 0, E = c.useRef(null), k = c4(E, n), L = c.useRef(0), P = c.useRef(), R = function() {
    var a = E.current, i = r && P.current ? P.current : p4(a);
    if (i) {
      P.current = i;
      var o = u4(i, a.value || a.placeholder || "x", d, u), f = o[0], j = o[1];
      L.current !== f && (L.current = f, a.style.setProperty("height", f + "px", "important"), m(f, {
        rowHeight: j
      }));
    }
  }, Y = function(a) {
    b || R(), v(a);
  };
  return c.useLayoutEffect(R), v4(R), m4(R), /* @__PURE__ */ c.createElement("textarea", If({}, h, {
    onChange: Y,
    ref: k
  }));
}, w4 = /* @__PURE__ */ c.forwardRef(y4), rt = Ye.slower, on = function() {
  var e, t;
  if (typeof window < "u") {
    var n = { setRippleListener: !1, registeredRippleElements: /* @__PURE__ */ new WeakMap() };
    return (t = (e = window).__LEAFYGREEN_UTILS__) !== null && t !== void 0 || (e.__LEAFYGREEN_UTILS__ = { modules: {} }), window.__LEAFYGREEN_UTILS__.modules["@leafygreen-ui/ripple"] = n, window.__LEAFYGREEN_UTILS__.modules["@leafygreen-ui/ripple"];
  }
}();
function O4(e) {
  on != null && on.registeredRippleElements.has(e.target) && function(t) {
    var n = t.target, r = on == null ? void 0 : on.registeredRippleElements.get(n);
    if (!(!n || !r)) {
      var u = r.backgroundColor, d = n.getBoundingClientRect(), p = document.createElement("span");
      p.className = "lg-ui-ripple", p.style.height = p.style.width = Math.max(d.width, d.height) + "px", n.appendChild(p);
      var v = t.pageY - d.top - p.offsetHeight / 2 - document.body.scrollTop, g = t.pageX - d.left - p.offsetWidth / 2 - document.body.scrollLeft;
      p.style.top = v + "px", p.style.left = g + "px", p.style.background = u, setTimeout(function() {
        p.remove();
      }, 750);
    }
  }(e);
}
function x4(e, t) {
  if (on) {
    if (on.registeredRippleElements.set(e, t), !on.setRippleListener) {
      document.addEventListener("click", O4, { passive: !0 });
      var n = document.createElement("style");
      n.innerHTML = j4, document.head.append(n), on.setRippleListener = !0;
    }
    return function() {
      on.registeredRippleElements.delete(e);
    };
  }
}
var j4 = `
  @-webkit-keyframes lg-ui-ripple {
    from {
      opacity:1;
    }
    to {
      transform: scale(2);
      transition: opacity `.concat(rt, `ms;
      opacity: 0;
    }
  }

  @-moz-keyframes lg-ui-ripple {
    from {
      opacity:1;
    }
    to {
      transform: scale(2);
      transition: opacity `).concat(rt, `ms;
      opacity: 0;
    }
  }

  @keyframes lg-ui-ripple {
    from {
      opacity:1;
    }
    to {
      transform: scale(2);
      transition: opacity `).concat(rt, `ms;
      opacity: 0;
    }
  }

  .lg-ui-ripple {
    position: absolute;
    border-radius: 100%;
    transform: scale(0.2);
    opacity: 0;
    pointer-events: none;
    // Ensures that text is shown above ripple effect
    z-index: -1;
    -webkit-animation: lg-ui-ripple .75s ease-out;
    -moz-animation: lg-ui-ripple .75s ease-out;
    animation: lg-ui-ripple .75s ease-out;
  }

  @media (prefers-reduced-motion: reduce) {
    .lg-ui-ripple {
      animation: none;
      transform: none;
    }
  }
`);
function y1(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(u) {
      return Object.getOwnPropertyDescriptor(e, u).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Un(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? y1(Object(n), !0).forEach(function(r) {
      C(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : y1(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function $4(e) {
  var t = function(n, r) {
    if (typeof n != "object" || !n)
      return n;
    var u = n[Symbol.toPrimitive];
    if (u !== void 0) {
      var d = u.call(n, r || "default");
      if (typeof d != "object")
        return d;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (r === "string" ? String : Number)(n);
  }(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function C(e, t, n) {
  return (t = $4(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Hn() {
  return Hn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Hn.apply(this, arguments);
}
function E4(e, t) {
  if (e == null)
    return {};
  var n, r, u = function(p, v) {
    if (p == null)
      return {};
    var g, m, h = {}, b = Object.keys(p);
    for (m = 0; m < b.length; m++)
      g = b[m], v.indexOf(g) >= 0 || (h[g] = p[g]);
    return h;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(e);
    for (r = 0; r < d.length; r++)
      n = d[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (u[n] = e[n]);
  }
  return u;
}
function S(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
var w1, O1, x1, j1, $1, E1, C1, k1, M1, L1, Z1, P1, S1, N1, z1, H1, R1, A1, B1, D1, V1, T1, F1, I1, _1, G1, U1, W1, Y1, X1, q1, K1, J1, Q1, eo, no, to, ro, ao, oo, lo, io, co, so, D = { Default: "default", Primary: "primary", PrimaryOutline: "primaryOutline", Danger: "danger", DangerOutline: "dangerOutline", BaseGreen: "baseGreen" }, Ee = { XSmall: "xsmall", Small: "small", Default: "default", Large: "large" }, Vn = 0.76, C4 = C(C({}, y.Light, C(C(C(C(C(C({}, D.Default, l.gray.light2), D.Primary, l.green.dark1), D.PrimaryOutline, Ve(Vn, l.green.base)), D.Danger, l.red.light1), D.DangerOutline, Ve(Vn, l.red.base)), D.BaseGreen, l.green.light1)), y.Dark, C(C(C(C(C(C({}, D.Default, l.gray.base), D.Primary, l.green.dark1), D.PrimaryOutline, Ve(Vn, l.green.base)), D.Danger, l.red.dark2), D.DangerOutline, Ve(Vn, l.red.light1)), D.BaseGreen, l.green.dark1)), k4 = s(w1 || (w1 = S([`
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 5px;
`]))), M4 = s(O1 || (O1 = S([`
  justify-content: space-between;
`]))), ef = s(x1 || (x1 = S([`
  display: grid;
  grid-auto-flow: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  position: relative;
  user-select: none;
  z-index: 0;
  transition: all `, ` ease-in-out;
`])), Ye.default), nf = C(C(C(C({}, Ee.XSmall, s(j1 || (j1 = S([`
    padding: 0 7px; // 8px - 1px border
    gap: 6px;
  `])))), Ee.Small, s($1 || ($1 = S([`
    padding: 0 11px; // 12px - 1px border
    gap: 6px;
  `])))), Ee.Default, s(E1 || (E1 = S([`
    padding: 0 11px; // 12px - 1px border
    gap: 6px;
  `])))), Ee.Large, s(C1 || (C1 = S([`
    padding: 0 15px; // 16px - 1px border
    gap: 8px;
  `])))), L4 = s(k1 || (k1 = S([`
  position: absolute;
`]))), Z4 = s(M1 || (M1 = S([`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`]))), P4 = C(C(C(C({}, Ee.XSmall, 16), Ee.Small, 16), Ee.Default, 16), Ee.Large, 20), S4 = C(C({}, y.Dark, l.gray.light1), y.Light, l.gray.dark1), N4 = s(L1 || (L1 = S([`
  visibility: hidden;
`]))), z4 = s(Z1 || (Z1 = S([`
  justify-self: right;
`]))), H4 = s(P1 || (P1 = S([`
  justify-self: left;
`]))), tf = Ae("button"), R4 = C(C({}, y.Light, C(C(C(C(C(C({}, D.Default, s(S1 || (S1 = S([`
      color: `, `;
    `])), l.gray.base)), D.Primary, s(N1 || (N1 = S([`
      color: `, `;
    `])), l.green.light2)), D.PrimaryOutline, s(z1 || (z1 = S([`
      color: `, `;
    `])), l.green.dark2)), D.Danger, s(H1 || (H1 = S([`
      color: `, `;
    `])), l.red.light3)), D.DangerOutline, s(R1 || (R1 = S([`
      color: `, `;
    `])), l.red.light1)), D.BaseGreen, s(A1 || (A1 = S([`
      color: `, `;
    `])), l.green.dark2))), y.Dark, C(C(C(C(C(C({}, D.Default, s(B1 || (B1 = S([`
      color: `, `;
    `])), l.gray.light2)), D.Primary, s(D1 || (D1 = S([`
      color: `, `;
    `])), l.green.light2)), D.PrimaryOutline, s(V1 || (V1 = S([`
      color: `, `;
    `])), l.green.base)), D.Danger, s(T1 || (T1 = S([`
      color: `, `;
    `])), l.red.light2)), D.DangerOutline, s(F1 || (F1 = S([`
      color: `, `;
    `])), l.red.light1)), D.BaseGreen, s(I1 || (I1 = S([`
      color: `, `;
    `])), l.green.dark2))), A4 = C(C({}, y.Light, C(C(C(C(C(C({}, D.Default, s(_1 || (_1 = S([`
      color: `, `;
    `])), l.black)), D.Primary, s(G1 || (G1 = S([`
      color: `, `;
    `])), l.white)), D.PrimaryOutline, s(U1 || (U1 = S([`
      color: `, `;
    `])), l.green.dark2)), D.Danger, s(W1 || (W1 = S([`
      color: `, `;
    `])), l.white)), D.DangerOutline, s(Y1 || (Y1 = S([`
      color: `, `;
    `])), l.red.base)), D.BaseGreen, s(X1 || (X1 = S([`
      color: `, `;
    `])), l.green.dark3))), y.Dark, C(C(C(C(C(C({}, D.Default, s(q1 || (q1 = S([`
      color: `, `;
    `])), l.white)), D.Primary, s(K1 || (K1 = S([`
      color: `, `;
    `])), l.white)), D.PrimaryOutline, s(J1 || (J1 = S([`
      color: `, `;
    `])), l.green.base)), D.Danger, s(Q1 || (Q1 = S([`
      color: `, `;
    `])), l.white)), D.DangerOutline, s(eo || (eo = S([`
      color: `, `;
    `])), l.red.light1)), D.BaseGreen, s(no || (no = S([`
      color: `, `;
    `])), l.green.dark3))), B4 = s(to || (to = S([`
  .`, ` {
    &:hover,
    &:active {
      color: currentColor;
    }
  }
`])), tf), D4 = C(C(C(C({}, Ee.XSmall, s(ro || (ro = S([`
    height: 14px;
    width: 14px;
  `])))), Ee.Small, s(ao || (ao = S([`
    height: 16px;
    width: 16px;
  `])))), Ee.Default, s(oo || (oo = S([`
    height: 16px;
    width: 16px;
  `])))), Ee.Large, s(lo || (lo = S([`
    height: 20px;
    width: 20px;
  `])))), V4 = C(C({}, y.Light, s(io || (io = S([`
    color: `, `;
  `])), l.gray.base)), y.Dark, s(co || (co = S([`
    color: `, `;
  `])), l.gray.dark1)), T4 = s(so || (so = S([`
  color: `, `;
`])), l.gray.dark1);
function lt(e) {
  var t = e.glyph, n = e.variant, r = e.size, u = e.darkMode, d = e.disabled, p = e.isIconOnlyButton, v = e.className, g = !p && { "aria-hidden": !0, role: "presentation" }, m = G3(u), h = p ? A4 : R4;
  return w.cloneElement(t, Un({ className: B(h[m][n], D4[r], C(C(C({}, B4, p), V4[m], d), T4, d && p && u), v) }, g));
}
lt.displayName = "ButtonIcon";
var uo, fo, go, ho, po, vo, mo, bo, yo, wo, Oo, xo, jo, $o, Eo, Co, ko, Mo, Lo, Zo, Po, So, No, zo, Ho, Ro, Ao, Bo, Do, Vo, To, Fo, Io, _o = function(e) {
  var t, n = e.leftGlyph, r = e.rightGlyph, u = e.className, d = e.children, p = e.variant, v = e.size, g = e.darkMode, m = { variant: p, size: v, darkMode: g, disabled: e.disabled, isIconOnlyButton: (t = (n || r) && !d) !== null && t !== void 0 && t };
  return w.createElement("div", { className: B(ef, nf[v], C({}, M4, !!r && g), u) }, n && w.createElement(lt, Hn({ glyph: n, className: z4 }, m)), d, r && w.createElement(lt, Hn({ glyph: r, className: H4 }, m)));
}, F4 = function(e) {
  var t, n = e.darkMode, r = e.disabled, u = e.variant, d = e.size, p = e.isLoading, v = e.loadingText, g = e.loadingIndicator, m = e.className, h = Q(n), b = h.darkMode, E = h.theme, k = ln(null);
  Dn(function() {
    var P, R = C4[E][u];
    return k.current == null || r || (P = x4(k.current, { backgroundColor: R })), P;
  }, [k, u, b, r, E]);
  var L = g && w.cloneElement(g, Un(Un({}, g.props), {}, C({ className: B(C({}, Z4, !v), (t = g.props) === null || t === void 0 ? void 0 : t.className), sizeOverride: P4[d], colorOverride: S4[E] }, "data-testid", "lg-button-spinner")));
  return p ? w.createElement(w.Fragment, null, w.createElement("div", { className: B(ef, nf[d], C({}, L4, !v)) }, L, v), !v && w.createElement(_o, Hn({}, e, { className: B(N4, m) }))) : w.createElement(w.Fragment, null, w.createElement("div", { className: k4, ref: k }), w.createElement(_o, e));
}, I4 = "lg-button", pe = '&:focus-visible, &[data-focus="true"]', Le = '&:hover, &[data-hover="true"]', Me = '&:active, &[data-active="true"]', Ze = function(e) {
  return `
    0 0 0 2px `.concat(e, `, 
    0 0 0 4px `).concat(l.blue.light1, `;
`);
}, _4 = s(uo || (uo = S([`
  // unset browser default
  appearance: none;
  padding: 0;
  margin: 0;
  background-color: transparent;
  border: 1px solid transparent;
  display: inline-flex;
  align-items: stretch;
  transition: all `, `ms ease-in-out;
  position: relative;
  text-decoration: none;
  cursor: pointer;
  z-index: 0;
  font-family: `, `;
  border-radius: 6px;

  `, ` {
    outline: none;
  }

  `, `,
  &:focus,
  &:hover {
    text-decoration: none;
  }
`])), Ye.default, se.default, pe, Me), G4 = C(C({}, y.Light, C(C(C(C(C(C({}, D.Default, s(fo || (fo = S([`
      background-color: `, `;
      border-color: `, `;
      color: `, `;

      // needed to override any global button styles
      `, ` {
        color: `, `;
      }

      `, `,
      `, ` {
        color: `, `;
        background-color: `, `;
        box-shadow: 0 0 0 3px `, `;
      }
    `])), l.gray.light3, l.gray.base, l.black, pe, l.black, Le, Me, l.black, l.white, l.gray.light2)), D.Primary, s(go || (go = S([`
      background-color: `, `;
      border-color: `, `;
      color: `, `;

      `, ` {
        color: `, `;
      }

      `, `,
      `, ` {
        color: `, `;
        background-color: #00593f; // Not quite dark3
        border-color: #00593f; // Not quite dark3
        box-shadow: 0 0 0 3px `, `;
      }
    `])), l.green.dark2, l.green.dark2, l.white, pe, l.white, Le, Me, l.white, l.green.light2)), D.PrimaryOutline, s(ho || (ho = S([`
      background-color: transparent;
      border-color: `, `;
      color: `, `;

      `, ` {
        color: `, `;
      }

      `, `,
      `, ` {
        color: `, `;
        background-color: `, `;
        box-shadow: 0px 0px 0px 3px `, `;
      }
    `])), l.green.dark2, l.green.dark2, pe, l.green.dark2, Le, Me, l.green.dark2, Ve(0.96, l.green.base), l.green.light2)), D.Danger, s(po || (po = S([`
      background-color: `, `;
      border-color: `, `;
      color: `, `;

      `, ` {
        color: `, `;
      }

      `, `,
      `, ` {
        color: `, `;
        background-color: #c82222; // not quite dark1
        border-color: #c82222; // not quite dark1
        box-shadow: 0px 0px 0px 3px `, `;
      }
    `])), l.red.base, l.red.base, l.white, pe, l.white, Le, Me, l.white, l.red.light3)), D.DangerOutline, s(vo || (vo = S([`
      background-color: transparent;
      border-color: `, `;
      color: `, `;

      `, ` {
        color: `, `;
      }

      `, `,
      `, ` {
        color: `, `;
        background-color: `, `;
        border-color: `, `;
        box-shadow: 0px 0px 0px 3px `, `;
      }
    `])), l.red.light1, l.red.base, pe, l.red.base, Le, Me, l.red.dark2, Ve(0.96, l.red.base), l.red.base, l.red.light3)), D.BaseGreen, s(mo || (mo = S([`
      background-color: `, `;
      border-color: `, `;
      color: `, `;

      `, ` {
        color: `, `;
      }

      `, `,
      `, ` {
        color: `, `;
        background-color: `, `;
        box-shadow: 0px 0px 0px 3px `, `;
      }
    `])), l.green.base, l.green.dark2, l.green.dark3, pe, l.green.dark3, Le, Me, l.green.dark3, u1(0.96, l.green.base, l.green.dark3), l.green.light2))), y.Dark, C(C(C(C(C(C({}, D.Default, s(bo || (bo = S([`
      background-color: `, `;
      border-color: `, `;
      color: `, `;

      `, ` {
        color: `, `;
      }

      `, `,
      `, ` {
        background-color: `, `;
        border-color: `, `;
        color: `, `;
        box-shadow: 0px 0px 0px 3px `, `;
      }
    `])), l.gray.dark2, l.gray.base, l.white, pe, l.white, Le, Me, l.gray.dark1, l.gray.base, l.white, l.gray.dark2)), D.Primary, s(yo || (yo = S([`
      background-color: `, `;
      border: 1px solid `, `;
      color: `, `;

      `, ` {
        color: `, `;
      }

      `, `,
      `, ` {
        color: `, `;
        background-color: #00593f; // Off palette
        box-shadow: 0 0 0 3px `, `;
      }
    `])), l.green.dark2, l.green.base, l.white, pe, l.white, Le, Me, l.white, l.green.dark3)), D.PrimaryOutline, s(wo || (wo = S([`
      background-color: transparent;
      border-color: `, `;
      color: `, `;

      `, ` {
        color: `, `;
      }

      `, `,
      `, ` {
        color: `, `;
        background-color: `, `;
        border-color: `, `;
        box-shadow: 0px 0px 0px 3px `, `;
      }
    `])), l.green.base, l.green.base, pe, l.green.base, Le, Me, l.green.base, Ve(0.96, l.green.base), l.green.base, l.green.dark3)), D.Danger, s(Oo || (Oo = S([`
      background-color: `, `;
      border-color: `, `;
      color: `, `;

      `, ` {
        color: `, `;
      }

      `, `,
      `, ` {
        border-color: `, `;
        color: `, `;
        background-color: #c82222; // Off palette
        box-shadow: 0px 0px 0px 3px `, `; // yes, yellow
      }
    `])), l.red.base, l.red.light1, l.white, pe, l.white, Le, Me, l.red.light1, l.white, l.yellow.dark3)), D.DangerOutline, s(xo || (xo = S([`
      border-color: `, `;
      color: `, `;

      `, ` {
        color: `, `;
      }

      `, `,
      `, ` {
        color: `, `;
        background-color: `, `;
        box-shadow: 0px 0px 0px 3px `, `; // yes, yellow
      }
    `])), l.red.light1, l.red.light1, pe, l.red.light1, Le, Me, l.red.light1, Ve(0.96, l.red.base), l.yellow.dark3)), D.BaseGreen, s(jo || (jo = S([`
      background-color: `, `;
      border-color: `, `;
      color: `, `;

      `, ` {
        color: `, `;
      }

      `, `,
      `, ` {
        color: `, `;
        background-color: `, `;
        border-color: `, `;
        box-shadow: 0px 0px 0px 3px `, `;
      }
    `])), l.green.base, l.green.dark2, l.green.dark3, pe, l.green.dark3, Le, Me, l.green.dark3, u1(0.96, l.green.base, l.green.light3), l.green.dark2, l.green.dark3))), U4 = C(C({}, y.Light, C(C(C(C(C(C({}, D.Default, s($o || ($o = S([`
      `, ` {
        background-color: `, `;
        box-shadow: `, `;
      }
    `])), pe, l.white, Ze(l.white))), D.Primary, s(Eo || (Eo = S([`
      `, ` {
        color: `, `;
        background-color: #00593f; // Not quite dark3
        box-shadow: `, `;
      }
    `])), pe, l.white, Ze(l.white))), D.PrimaryOutline, s(Co || (Co = S([`
      `, ` {
        background-color: `, `;
        box-shadow: `, `;
      }
    `])), pe, Ve(0.96, l.green.base), Ze(l.white))), D.Danger, s(ko || (ko = S([`
      `, ` {
        color: `, `;
        background-color: #c82222; // not quite dark1
        box-shadow: `, `;
      }
    `])), pe, l.white, Ze(l.white))), D.DangerOutline, s(Mo || (Mo = S([`
      `, ` {
        color: `, `;
        box-shadow: `, `;
      }
    `])), pe, l.red.dark2, Ze(l.white))), D.BaseGreen, s(Lo || (Lo = S([`
      `, ` {
        box-shadow: `, `;
      }
    `])), pe, Ze(l.white)))), y.Dark, C(C(C(C(C(C({}, D.Default, s(Zo || (Zo = S([`
      `, ` {
        background-color: `, `;
        box-shadow: `, `;
      }
    `])), pe, l.gray.dark1, Ze(l.black))), D.Primary, s(Po || (Po = S([`
      `, ` {
        background-color: #00593f; // Off palette
        box-shadow: `, `;
      }
    `])), pe, Ze(l.black))), D.PrimaryOutline, s(So || (So = S([`
      `, ` {
        background-color: `, `;
        border-color: `, `;
        box-shadow: `, `;
      }
    `])), pe, Ve(0.96, l.green.base), l.green.base, Ze(l.black))), D.Danger, s(No || (No = S([`
      `, ` {
        background-color: #c82222; // Off palette
        box-shadow: `, `;
      }
    `])), pe, Ze(l.black))), D.DangerOutline, s(zo || (zo = S([`
      `, ` {
        background-color: `, `;
        border-color: `, `;
        box-shadow: `, `;
      }
    `])), pe, Ve(0.96, l.red.base), l.red.light1, Ze(l.black))), D.BaseGreen, s(Ho || (Ho = S([`
      `, ` {
        background-color: `, `;
        box-shadow: `, `;
      }
    `])), pe, l.green.base, Ze(l.black)))), W4 = C(C({}, y.Light, s(Ro || (Ro = S([`
    &,
    `, ", ", ` {
      background-color: `, `;
      border-color: `, `;
      color: `, `;
      box-shadow: none;
      cursor: not-allowed;
    }

    `, ` {
      color: `, `;
      box-shadow: `, `;
    }
  `])), Le, Me, l.gray.light2, l.gray.light1, l.gray.base, pe, l.gray.base, Ze(l.white))), y.Dark, s(Ao || (Ao = S([`
    &,
    `, ", ", ` {
      background-color: `, `;
      border-color: `, `;
      color: `, `;
      box-shadow: none;
      cursor: not-allowed;
    }

    `, ` {
      color: `, `;
      box-shadow: `, `;
    }
  `])), Le, Me, l.gray.dark3, l.gray.dark2, l.gray.dark1, pe, l.gray.dark1, Ze(l.black))), Y4 = C(C(C(C({}, Ee.XSmall, s(Bo || (Bo = S([`
    height: 22px;
    text-transform: uppercase;
    font-size: 12px;
    line-height: 1em;
    font-weight: `, `;
    letter-spacing: 0.4px;
  `])), ne.bold)), Ee.Small, s(Do || (Do = S([`
    height: 28px;
  `])))), Ee.Default, s(Vo || (Vo = S([`
    height: 36px;
  `])))), Ee.Large, s(To || (To = S([`
    height: 48px;
    font-size: 18px;
    line-height: 24px;
  `])))), X4 = C(C({}, G.Body1, s(Fo || (Fo = S([`
    font-size: `, `px;
    line-height: `, `px;
    font-weight: `, `;
  `])), A.body1.fontSize, A.body1.lineHeight, ne.medium)), G.Body2, s(Io || (Io = S([`
    font-size: `, `px;
    line-height: `, `px;
    // Pixel pushing for optical alignment purposes
    transform: translateY(1px);
    font-weight: `, `;
  `])), A.body2.fontSize, A.body2.lineHeight, ne.medium)), q4 = ["variant", "size", "darkMode", "data-lgid", "baseFontSize", "disabled", "onClick", "leftGlyph", "rightGlyph", "children", "className", "as", "type", "isLoading", "loadingIndicator", "loadingText"], it = w.forwardRef(function(e, t) {
  var n = e.variant, r = n === void 0 ? D.Default : n, u = e.size, d = u === void 0 ? Ee.Default : u, p = e.darkMode, v = e["data-lgid"], g = v === void 0 ? I4 : v, m = e.baseFontSize, h = m === void 0 ? G.Body1 : m, b = e.disabled, E = b !== void 0 && b, k = e.onClick, L = e.leftGlyph, P = e.rightGlyph, R = e.children, Y = e.className, M = e.as, a = e.type, i = e.isLoading, o = i !== void 0 && i, f = e.loadingIndicator, j = e.loadingText, x = E4(e, q4), Z = Q(p).darkMode, N = !(!x.href && M !== "a" || E), O = !(E || o), $ = function(ie) {
    var X = ie.variant, ee = ie.size, re = ie.darkMode, I = ie.baseFontSize, q = ie.disabled, K = G3(re), J = G4[K][X], W = U4[K][X], un = Y4[ee], Be = X4[I];
    return B(_4, J, Be, un, C({}, W, !q), C({}, W4[K], q));
  }({ variant: r, size: d, darkMode: Z, baseFontSize: h, disabled: !O }), H = Un({ "data-lgid": g, type: N ? void 0 : a || "button", className: B(tf, $, Y), ref: t, as: M || (N ? "a" : "button"), "aria-disabled": !O, onClick: O ? k : function(ie) {
    return ie.preventDefault();
  }, href: O ? x.href : void 0 }, x), z = { rightGlyph: P, leftGlyph: L, darkMode: Z, disabled: E, variant: r, size: d, isLoading: o, loadingIndicator: f, loadingText: j };
  return w.createElement(Gf, H, w.createElement(F4, z, R));
});
it.displayName = "Button", it.propTypes = { variant: fe.oneOf(Object.values(D)), baseFontSize: fe.oneOf(Object.values(G)), size: fe.oneOf(Object.values(Ee)), darkMode: fe.bool, disabled: fe.bool, leftGlyph: fe.element, rightGlyph: fe.element, href: fe.string, isLoading: fe.bool, loadingText: fe.string, loadingIndicator: fe.element };
var rf = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(w, _e, Ie);
  })(Te, function(n, r, u) {
    function d(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function p(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var i = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(o) {
        if (o !== "default") {
          var f = Object.getOwnPropertyDescriptor(a, o);
          Object.defineProperty(i, o, f.get ? f : { enumerable: !0, get: function() {
            return a[o];
          } });
        }
      }), i.default = a, Object.freeze(i);
    }
    var v = p(n), g = d(r);
    function m(a) {
      var i = function(o, f) {
        if (typeof o != "object" || !o)
          return o;
        var j = o[Symbol.toPrimitive];
        if (j !== void 0) {
          var x = j.call(o, f || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (f === "string" ? String : Number)(o);
      }(a, "string");
      return typeof i == "symbol" ? i : i + "";
    }
    function h(a, i, o) {
      return (i = m(i)) in a ? Object.defineProperty(a, i, { value: o, enumerable: !0, configurable: !0, writable: !0 }) : a[i] = o, a;
    }
    function b() {
      return b = Object.assign ? Object.assign.bind() : function(a) {
        for (var i = 1; i < arguments.length; i++) {
          var o = arguments[i];
          for (var f in o)
            Object.prototype.hasOwnProperty.call(o, f) && (a[f] = o[f]);
        }
        return a;
      }, b.apply(this, arguments);
    }
    function E(a, i) {
      if (a == null)
        return {};
      var o, f, j = function(Z, N) {
        if (Z == null)
          return {};
        var O, $, H = {}, z = Object.keys(Z);
        for ($ = 0; $ < z.length; $++)
          O = z[$], N.indexOf(O) >= 0 || (H[O] = Z[O]);
        return H;
      }(a, i);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (f = 0; f < x.length; f++)
          o = x[f], i.indexOf(o) >= 0 || Object.prototype.propertyIsEnumerable.call(a, o) && (j[o] = a[o]);
      }
      return j;
    }
    function k(a, i) {
      return i || (i = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(i) } }));
    }
    var L, P, R = { small: 14, default: 16, large: 20, xlarge: 24 }, Y = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], M = function(a) {
      var i = a.className, o = a.size, f = o === void 0 ? 16 : o, j = a.title, x = a["aria-label"], Z = a["aria-labelledby"], N = a.fill, O = a.role, $ = O === void 0 ? "img" : O, H = E(a, Y), z = u.css(L || (L = k([`
        color: `, `;
      `])), N), ie = u.css(P || (P = k([`
        flex-shrink: 0;
      `]))), X = function(ee, re, I) {
        var q, K = I["aria-label"], J = I["aria-labelledby"], W = I.title;
        switch (ee) {
          case "img":
            return K || J || W ? h(h(h({}, "aria-labelledby", J), "aria-label", K), "title", W) : { "aria-label": (q = re, "".concat(q.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }($, "MagnifyingGlass", h(h({ title: j }, "aria-label", x), "aria-labelledby", Z));
      return v.createElement("svg", b({ className: u.cx(h({}, z, N != null), ie, i), height: typeof f == "number" ? f : R[f], width: typeof f == "number" ? f : R[f], role: $ }, X, H, { viewBox: "0 0 16 16" }), v.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.3234 9.81874C4.07618 11.5715 6.75062 11.8398 8.78588 10.6244L12.93 14.7685C13.4377 15.2762 14.2608 15.2762 14.7685 14.7685C15.2762 14.2608 15.2762 13.4377 14.7685 12.93L10.6244 8.78588C11.8398 6.75062 11.5715 4.07619 9.81873 2.32341C7.74896 0.253628 4.39318 0.253628 2.3234 2.32341C0.253624 4.39319 0.253624 7.74896 2.3234 9.81874ZM7.98026 4.16188C9.03467 5.2163 9.03467 6.92585 7.98026 7.98026C6.92584 9.03468 5.2163 9.03468 4.16188 7.98026C3.10746 6.92585 3.10746 5.2163 4.16188 4.16188C5.2163 3.10747 6.92584 3.10747 7.98026 4.16188Z", fill: "currentColor" }));
    };
    return M.displayName = "MagnifyingGlass", M.isGlyph = !0, M.propTypes = { fill: g.default.string, size: g.default.oneOfType([g.default.number, g.default.string]), className: g.default.string }, M;
  });
})(rf);
var K4 = rf.exports;
const J4 = /* @__PURE__ */ Fe(K4);
var af = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(w, _e, Ie);
  })(Te, function(n, r, u) {
    function d(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function p(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var i = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(o) {
        if (o !== "default") {
          var f = Object.getOwnPropertyDescriptor(a, o);
          Object.defineProperty(i, o, f.get ? f : { enumerable: !0, get: function() {
            return a[o];
          } });
        }
      }), i.default = a, Object.freeze(i);
    }
    var v = p(n), g = d(r);
    function m(a) {
      var i = function(o, f) {
        if (typeof o != "object" || !o)
          return o;
        var j = o[Symbol.toPrimitive];
        if (j !== void 0) {
          var x = j.call(o, f || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (f === "string" ? String : Number)(o);
      }(a, "string");
      return typeof i == "symbol" ? i : i + "";
    }
    function h(a, i, o) {
      return (i = m(i)) in a ? Object.defineProperty(a, i, { value: o, enumerable: !0, configurable: !0, writable: !0 }) : a[i] = o, a;
    }
    function b() {
      return b = Object.assign ? Object.assign.bind() : function(a) {
        for (var i = 1; i < arguments.length; i++) {
          var o = arguments[i];
          for (var f in o)
            Object.prototype.hasOwnProperty.call(o, f) && (a[f] = o[f]);
        }
        return a;
      }, b.apply(this, arguments);
    }
    function E(a, i) {
      if (a == null)
        return {};
      var o, f, j = function(Z, N) {
        if (Z == null)
          return {};
        var O, $, H = {}, z = Object.keys(Z);
        for ($ = 0; $ < z.length; $++)
          O = z[$], N.indexOf(O) >= 0 || (H[O] = Z[O]);
        return H;
      }(a, i);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (f = 0; f < x.length; f++)
          o = x[f], i.indexOf(o) >= 0 || Object.prototype.propertyIsEnumerable.call(a, o) && (j[o] = a[o]);
      }
      return j;
    }
    function k(a, i) {
      return i || (i = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(i) } }));
    }
    var L, P, R = { small: 14, default: 16, large: 20, xlarge: 24 }, Y = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], M = function(a) {
      var i = a.className, o = a.size, f = o === void 0 ? 16 : o, j = a.title, x = a["aria-label"], Z = a["aria-labelledby"], N = a.fill, O = a.role, $ = O === void 0 ? "img" : O, H = E(a, Y), z = u.css(L || (L = k([`
        color: `, `;
      `])), N), ie = u.css(P || (P = k([`
        flex-shrink: 0;
      `]))), X = function(ee, re, I) {
        var q, K = I["aria-label"], J = I["aria-labelledby"], W = I.title;
        switch (ee) {
          case "img":
            return K || J || W ? h(h(h({}, "aria-labelledby", J), "aria-label", K), "title", W) : { "aria-label": (q = re, "".concat(q.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }($, "XWithCircle", h(h({ title: j }, "aria-label", x), "aria-labelledby", Z));
      return v.createElement("svg", b({ className: u.cx(h({}, z, N != null), ie, i), height: typeof f == "number" ? f : R[f], width: typeof f == "number" ? f : R[f], role: $ }, X, H, { viewBox: "0 0 16 16" }), v.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM9.41421 5.17157C9.80474 4.78105 10.4379 4.78105 10.8284 5.17157C11.219 5.5621 11.219 6.19526 10.8284 6.58579L9.41421 8L10.8284 9.41421C11.219 9.80474 11.219 10.4379 10.8284 10.8284C10.4379 11.219 9.80474 11.219 9.41421 10.8284L8 9.41421L6.58579 10.8284C6.19526 11.219 5.5621 11.219 5.17157 10.8284C4.78105 10.4379 4.78105 9.80474 5.17157 9.41421L6.58579 8L5.17157 6.58579C4.78105 6.19526 4.78105 5.5621 5.17157 5.17157C5.5621 4.78105 6.19526 4.78105 6.58579 5.17157L8 6.58579L9.41421 5.17157Z", fill: "currentColor" }));
    };
    return M.displayName = "XWithCircle", M.isGlyph = !0, M.propTypes = { fill: g.default.string, size: g.default.oneOfType([g.default.number, g.default.string]), className: g.default.string }, M;
  });
})(af);
var Q4 = af.exports;
const ed = /* @__PURE__ */ Fe(Q4);
var of = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(w, _e, Ie);
  })(Te, function(n, r, u) {
    function d(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function p(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var i = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(o) {
        if (o !== "default") {
          var f = Object.getOwnPropertyDescriptor(a, o);
          Object.defineProperty(i, o, f.get ? f : { enumerable: !0, get: function() {
            return a[o];
          } });
        }
      }), i.default = a, Object.freeze(i);
    }
    var v = p(n), g = d(r);
    function m(a) {
      var i = function(o, f) {
        if (typeof o != "object" || !o)
          return o;
        var j = o[Symbol.toPrimitive];
        if (j !== void 0) {
          var x = j.call(o, f || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (f === "string" ? String : Number)(o);
      }(a, "string");
      return typeof i == "symbol" ? i : i + "";
    }
    function h(a, i, o) {
      return (i = m(i)) in a ? Object.defineProperty(a, i, { value: o, enumerable: !0, configurable: !0, writable: !0 }) : a[i] = o, a;
    }
    function b() {
      return b = Object.assign ? Object.assign.bind() : function(a) {
        for (var i = 1; i < arguments.length; i++) {
          var o = arguments[i];
          for (var f in o)
            Object.prototype.hasOwnProperty.call(o, f) && (a[f] = o[f]);
        }
        return a;
      }, b.apply(this, arguments);
    }
    function E(a, i) {
      if (a == null)
        return {};
      var o, f, j = function(Z, N) {
        if (Z == null)
          return {};
        var O, $, H = {}, z = Object.keys(Z);
        for ($ = 0; $ < z.length; $++)
          O = z[$], N.indexOf(O) >= 0 || (H[O] = Z[O]);
        return H;
      }(a, i);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (f = 0; f < x.length; f++)
          o = x[f], i.indexOf(o) >= 0 || Object.prototype.propertyIsEnumerable.call(a, o) && (j[o] = a[o]);
      }
      return j;
    }
    function k(a, i) {
      return i || (i = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(i) } }));
    }
    var L, P, R = { small: 14, default: 16, large: 20, xlarge: 24 }, Y = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], M = function(a) {
      var i = a.className, o = a.size, f = o === void 0 ? 16 : o, j = a.title, x = a["aria-label"], Z = a["aria-labelledby"], N = a.fill, O = a.role, $ = O === void 0 ? "img" : O, H = E(a, Y), z = u.css(L || (L = k([`
        color: `, `;
      `])), N), ie = u.css(P || (P = k([`
        flex-shrink: 0;
      `]))), X = function(ee, re, I) {
        var q, K = I["aria-label"], J = I["aria-labelledby"], W = I.title;
        switch (ee) {
          case "img":
            return K || J || W ? h(h(h({}, "aria-labelledby", J), "aria-label", K), "title", W) : { "aria-label": (q = re, "".concat(q.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }($, "ArrowLeft", h(h({ title: j }, "aria-label", x), "aria-labelledby", Z));
      return v.createElement("svg", b({ className: u.cx(h({}, z, N != null), ie, i), height: typeof f == "number" ? f : R[f], width: typeof f == "number" ? f : R[f], role: $ }, X, H, { viewBox: "0 0 16 16" }), v.createElement("path", { d: "M13 6.83212L6.05559 6.83212L7.59059 5.29711C7.98112 4.90659 7.98112 4.27342 7.59059 3.8829L7.35168 3.64398C6.96115 3.25346 6.32799 3.25345 5.93746 3.64398L2.55483 7.02661C2.5456 7.03518 2.5365 7.04395 2.52752 7.05292L2.2886 7.29184C1.89808 7.68237 1.89808 8.31553 2.2886 8.70605L5.93975 12.3572C6.33028 12.7477 6.96344 12.7477 7.35397 12.3572L7.59288 12.1183C7.98341 11.7278 7.98341 11.0946 7.59288 10.7041L6.0588 9.17L13 9.17C13.5523 9.17 14 8.72228 14 8.17V7.83212C14 7.27983 13.5523 6.83212 13 6.83212Z", fill: "currentColor" }));
    };
    return M.displayName = "ArrowLeft", M.isGlyph = !0, M.propTypes = { fill: g.default.string, size: g.default.oneOfType([g.default.number, g.default.string]), className: g.default.string }, M;
  });
})(of);
var nd = of.exports;
const td = /* @__PURE__ */ Fe(nd);
var lf = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(w, _e, Ie);
  })(Te, function(n, r, u) {
    function d(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function p(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var i = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(o) {
        if (o !== "default") {
          var f = Object.getOwnPropertyDescriptor(a, o);
          Object.defineProperty(i, o, f.get ? f : { enumerable: !0, get: function() {
            return a[o];
          } });
        }
      }), i.default = a, Object.freeze(i);
    }
    var v = p(n), g = d(r);
    function m(a) {
      var i = function(o, f) {
        if (typeof o != "object" || !o)
          return o;
        var j = o[Symbol.toPrimitive];
        if (j !== void 0) {
          var x = j.call(o, f || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (f === "string" ? String : Number)(o);
      }(a, "string");
      return typeof i == "symbol" ? i : i + "";
    }
    function h(a, i, o) {
      return (i = m(i)) in a ? Object.defineProperty(a, i, { value: o, enumerable: !0, configurable: !0, writable: !0 }) : a[i] = o, a;
    }
    function b() {
      return b = Object.assign ? Object.assign.bind() : function(a) {
        for (var i = 1; i < arguments.length; i++) {
          var o = arguments[i];
          for (var f in o)
            Object.prototype.hasOwnProperty.call(o, f) && (a[f] = o[f]);
        }
        return a;
      }, b.apply(this, arguments);
    }
    function E(a, i) {
      if (a == null)
        return {};
      var o, f, j = function(Z, N) {
        if (Z == null)
          return {};
        var O, $, H = {}, z = Object.keys(Z);
        for ($ = 0; $ < z.length; $++)
          O = z[$], N.indexOf(O) >= 0 || (H[O] = Z[O]);
        return H;
      }(a, i);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (f = 0; f < x.length; f++)
          o = x[f], i.indexOf(o) >= 0 || Object.prototype.propertyIsEnumerable.call(a, o) && (j[o] = a[o]);
      }
      return j;
    }
    function k(a, i) {
      return i || (i = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(i) } }));
    }
    var L, P, R = { small: 14, default: 16, large: 20, xlarge: 24 }, Y = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], M = function(a) {
      var i = a.className, o = a.size, f = o === void 0 ? 16 : o, j = a.title, x = a["aria-label"], Z = a["aria-labelledby"], N = a.fill, O = a.role, $ = O === void 0 ? "img" : O, H = E(a, Y), z = u.css(L || (L = k([`
        color: `, `;
      `])), N), ie = u.css(P || (P = k([`
        flex-shrink: 0;
      `]))), X = function(ee, re, I) {
        var q, K = I["aria-label"], J = I["aria-labelledby"], W = I.title;
        switch (ee) {
          case "img":
            return K || J || W ? h(h(h({}, "aria-labelledby", J), "aria-label", K), "title", W) : { "aria-label": (q = re, "".concat(q.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }($, "ArrowRight", h(h({ title: j }, "aria-label", x), "aria-labelledby", Z));
      return v.createElement("svg", b({ className: u.cx(h({}, z, N != null), ie, i), height: typeof f == "number" ? f : R[f], width: typeof f == "number" ? f : R[f], role: $ }, X, H, { viewBox: "0 0 16 16" }), v.createElement("path", { d: "M3 6.83212L9.94442 6.83212L8.40941 5.29711C8.01888 4.90659 8.01889 4.27342 8.40941 3.8829L8.64833 3.64398C9.03885 3.25346 9.67201 3.25345 10.0625 3.64398L13.4452 7.02661C13.4544 7.03518 13.4635 7.04395 13.4725 7.05292L13.7114 7.29184C14.1019 7.68237 14.1019 8.31553 13.7114 8.70605L10.0602 12.3572C9.66972 12.7477 9.03656 12.7477 8.64603 12.3572L8.40712 12.1183C8.01659 11.7278 8.01659 11.0946 8.40712 10.7041L9.9412 9.17L3 9.17C2.44771 9.17 2 8.72228 2 8.17L2 7.83212C2 7.27983 2.44772 6.83212 3 6.83212Z", fill: "currentColor" }));
    };
    return M.displayName = "ArrowRight", M.isGlyph = !0, M.propTypes = { fill: g.default.string, size: g.default.oneOfType([g.default.number, g.default.string]), className: g.default.string }, M;
  });
})(lf);
var rd = lf.exports;
const ad = /* @__PURE__ */ Fe(rd);
var cf = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(w, _e, Ie);
  })(Te, function(n, r, u) {
    function d(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function p(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var i = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(o) {
        if (o !== "default") {
          var f = Object.getOwnPropertyDescriptor(a, o);
          Object.defineProperty(i, o, f.get ? f : { enumerable: !0, get: function() {
            return a[o];
          } });
        }
      }), i.default = a, Object.freeze(i);
    }
    var v = p(n), g = d(r);
    function m(a) {
      var i = function(o, f) {
        if (typeof o != "object" || !o)
          return o;
        var j = o[Symbol.toPrimitive];
        if (j !== void 0) {
          var x = j.call(o, f || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (f === "string" ? String : Number)(o);
      }(a, "string");
      return typeof i == "symbol" ? i : i + "";
    }
    function h(a, i, o) {
      return (i = m(i)) in a ? Object.defineProperty(a, i, { value: o, enumerable: !0, configurable: !0, writable: !0 }) : a[i] = o, a;
    }
    function b() {
      return b = Object.assign ? Object.assign.bind() : function(a) {
        for (var i = 1; i < arguments.length; i++) {
          var o = arguments[i];
          for (var f in o)
            Object.prototype.hasOwnProperty.call(o, f) && (a[f] = o[f]);
        }
        return a;
      }, b.apply(this, arguments);
    }
    function E(a, i) {
      if (a == null)
        return {};
      var o, f, j = function(Z, N) {
        if (Z == null)
          return {};
        var O, $, H = {}, z = Object.keys(Z);
        for ($ = 0; $ < z.length; $++)
          O = z[$], N.indexOf(O) >= 0 || (H[O] = Z[O]);
        return H;
      }(a, i);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (f = 0; f < x.length; f++)
          o = x[f], i.indexOf(o) >= 0 || Object.prototype.propertyIsEnumerable.call(a, o) && (j[o] = a[o]);
      }
      return j;
    }
    function k(a, i) {
      return i || (i = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(i) } }));
    }
    var L, P, R = { small: 14, default: 16, large: 20, xlarge: 24 }, Y = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], M = function(a) {
      var i = a.className, o = a.size, f = o === void 0 ? 16 : o, j = a.title, x = a["aria-label"], Z = a["aria-labelledby"], N = a.fill, O = a.role, $ = O === void 0 ? "img" : O, H = E(a, Y), z = u.css(L || (L = k([`
        color: `, `;
      `])), N), ie = u.css(P || (P = k([`
        flex-shrink: 0;
      `]))), X = function(ee, re, I) {
        var q, K = I["aria-label"], J = I["aria-labelledby"], W = I.title;
        switch (ee) {
          case "img":
            return K || J || W ? h(h(h({}, "aria-labelledby", J), "aria-label", K), "title", W) : { "aria-label": (q = re, "".concat(q.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }($, "OpenNewTab", h(h({ title: j }, "aria-label", x), "aria-labelledby", Z));
      return v.createElement("svg", b({ className: u.cx(h({}, z, N != null), ie, i), height: typeof f == "number" ? f : R[f], width: typeof f == "number" ? f : R[f], role: $ }, X, H, { viewBox: "0 0 16 16" }), v.createElement("path", { d: "M13.823 2.4491C13.8201 2.30008 13.6999 2.17994 13.5509 2.17704L9.5062 2.09836C9.25654 2.09351 9.12821 2.39519 9.30482 2.5718L10.3856 3.65257L7.93433 6.10383C7.87964 6.15852 7.83047 6.21665 7.78683 6.27752L5.99909 8.06525C5.46457 8.59977 5.46457 9.4664 5.99909 10.0009C6.53361 10.5354 7.40023 10.5354 7.93475 10.0009L9.72249 8.21317C9.78336 8.16953 9.84148 8.12037 9.89618 8.06567L12.3474 5.61441L13.4282 6.69518C13.6048 6.87179 13.9065 6.74347 13.9016 6.4938L13.823 2.4491Z", fill: "currentColor" }), v.createElement("path", { d: "M7.25 3.12893C7.66421 3.12893 8 3.46472 8 3.87893C8 4.29315 7.66421 4.62893 7.25 4.62893H4C3.72386 4.62893 3.5 4.85279 3.5 5.12893V11.9929C3.5 12.2691 3.72386 12.4929 4 12.4929H10.864C11.1401 12.4929 11.364 12.2691 11.364 11.9929V8.75C11.364 8.33579 11.6998 8 12.114 8C12.5282 8 12.864 8.33579 12.864 8.75V11.9929C12.864 13.0975 11.9686 13.9929 10.864 13.9929H4C2.89543 13.9929 2 13.0975 2 11.9929V5.12893C2 4.02436 2.89543 3.12893 4 3.12893H7.25Z", fill: "currentColor" }));
    };
    return M.displayName = "OpenNewTab", M.isGlyph = !0, M.propTypes = { fill: g.default.string, size: g.default.oneOfType([g.default.number, g.default.string]), className: g.default.string }, M;
  });
})(cf);
var od = cf.exports;
const ld = /* @__PURE__ */ Fe(od);
function id(e) {
  var t = function(n, r) {
    if (typeof n != "object" || !n)
      return n;
    var u = n[Symbol.toPrimitive];
    if (u !== void 0) {
      var d = u.call(n, r || "default");
      if (typeof d != "object")
        return d;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (r === "string" ? String : Number)(n);
  }(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function te(e, t, n) {
  return (t = id(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Pe() {
  return Pe = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Pe.apply(this, arguments);
}
function Ge(e, t) {
  if (e == null)
    return {};
  var n, r, u = function(p, v) {
    if (p == null)
      return {};
    var g, m, h = {}, b = Object.keys(p);
    for (m = 0; m < b.length; m++)
      g = b[m], v.indexOf(g) >= 0 || (h[g] = p[g]);
    return h;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(e);
    for (r = 0; r < d.length; r++)
      n = d[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (u[n] = e[n]);
  }
  return u;
}
function V(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
function cd(e, t) {
  return function(n) {
    if (Array.isArray(n))
      return n;
  }(e) || function(n, r) {
    var u = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
    if (u != null) {
      var d, p, v, g, m = [], h = !0, b = !1;
      try {
        if (v = (u = u.call(n)).next, r === 0) {
          if (Object(u) !== u)
            return;
          h = !1;
        } else
          for (; !(h = (d = v.call(u)).done) && (m.push(d.value), m.length !== r); h = !0)
            ;
      } catch (E) {
        b = !0, p = E;
      } finally {
        try {
          if (!h && u.return != null && (g = u.return(), Object(g) !== g))
            return;
        } finally {
          if (b)
            throw p;
        }
      }
      return m;
    }
  }(e, t) || function(n, r) {
    if (n) {
      if (typeof n == "string")
        return Go(n, r);
      var u = Object.prototype.toString.call(n).slice(8, -1);
      if (u === "Object" && n.constructor && (u = n.constructor.name), u === "Map" || u === "Set")
        return Array.from(n);
      if (u === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(u))
        return Go(n, r);
    }
  }(e, t) || function() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function Go(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var Uo, Wo, Yo, Xo, qo, Ko, Jo, Qo, Cn = s(Uo || (Uo = V([`
  margin: unset;
  font-family: `, `;
  color: `, `;
`])), se.default, l.black), sf = te(te({}, G.Body1, s(Wo || (Wo = V([`
    font-size: `, `px;
    line-height: `, `px;
  `])), A.body1.fontSize, A.body1.lineHeight)), G.Body2, s(Yo || (Yo = V([`
    font-size: `, `px;
    line-height: `, `px;
  `])), A.body2.fontSize, A.body2.lineHeight)), sd = te(te({}, G.Body1, s(Xo || (Xo = V([`
    font-size: `, `px;
    line-height: `, `px;
  `])), A.code1.fontSize, A.code1.lineHeight)), G.Body2, s(qo || (qo = V([`
    font-size: `, `px;
    line-height: `, `px;
  `])), A.code2.fontSize, A.code2.lineHeight)), Kn = te(te({}, y.Light, s(Ko || (Ko = V([`
    color: `, `;
  `])), l.black)), y.Dark, s(Jo || (Jo = V([`
    color: `, `;
  `])), l.gray.light2)), mn = function(e) {
  var t = o1();
  return e ? e === 16 ? G.Body2 : G.Body1 : t === 16 ? G.Body2 : G.Body1;
}, ud = ["baseFontSize", "darkMode", "className", "weight", "as"], fd = be(function(e) {
  var t = e.baseFontSize, n = e.darkMode, r = e.className, u = e.weight, d = u === void 0 ? "regular" : u, p = e.as, v = p === void 0 ? "p" : p, g = Ge(e, ud), m = Q(n).theme, h = mn(t), b = ye(v).Component, E = s(Qo || (Qo = V([`
      font-weight: `, `;
      strong,
      b {
        font-weight: `, `;
      }
    `])), ne[d], ne.bold);
  return w.createElement(b, Pe({ className: B(Cn, sf[h], Kn[m], E, r) }, g));
});
fd.displayName = "Body";
var el, nl, tl, rl, al, ol, ll, il, cl, sl, uf = { label: "lg-label", description: "lg-description" }, dd = s(el || (el = V([`
  font-family: `, `;
  font-weight: `, `;
  margin-top: 0;
  margin-bottom: 0;
`])), se.default, ne.regular), gd = te(te({}, y.Light, s(nl || (nl = V([`
    color: `, `;
  `])), l.gray.dark1)), y.Dark, s(tl || (tl = V([`
    color: `, `;
  `])), l.gray.light1)), hd = te(te({}, y.Light, s(rl || (rl = V([`
    color: `, `;
  `])), l.gray.base)), y.Dark, s(al || (al = V([`
    color: `, `;
  `])), l.gray.dark1)), pd = te(te({}, G.Body1, s(ol || (ol = V([`
    font-size: `, `px;
    line-height: `, `px;
  `])), A.body1.fontSize, A.body1.lineHeight)), G.Body2, s(ll || (ll = V([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), A.body2.fontSize)), vd = ["baseFontSize", "data-lgid", "darkMode", "disabled", "children", "className"], ff = function(e) {
  var t = e.baseFontSize, n = e["data-lgid"], r = n === void 0 ? uf.description : n, u = e.darkMode, d = e.disabled, p = d !== void 0 && d, v = e.children, g = e.className, m = Ge(e, vd), h = Q(u).theme, b = mn(t);
  return w.createElement("p", Pe({ "data-lgid": r, className: B(dd, gd[h], pd[b], te({}, hd[h], p), g) }, m), v);
};
ff.displayName = "Description";
var ul, fl, dl, gl, hl;
te(te({}, y.Light, s(il || (il = V([`
    color: `, `;
  `])), l.gray.dark1)), y.Dark, s(cl || (cl = V([`
    color: `, `;
  `])), l.gray.light1));
s(sl || (sl = V([`
  display: block;
  font-size: 11px;
  line-height: 16px;
  letter-spacing: 0.2px;
`])));
var pl, vl, ml, bl, yl, wl, md = s(ul || (ul = V([`
  font-family: `, `;
  font-weight: `, `;
  font-size: inherit;
  line-height: inherit;

  // Unsets browser default margins
  margin-block-start: 0;
  margin-block-end: 0;
`])), se.default, ne.regular), bd = te(te({}, y.Light, s(fl || (fl = V([`
    color: `, `;
  `])), l.red.base)), y.Dark, s(dl || (dl = V([`
    color: `, `;
  `])), l.red.light1)), yd = te(te({}, G.Body1, s(gl || (gl = V([`
    font-size: `, `px;
    line-height: `, `px;
  `])), A.body1.fontSize, A.body1.lineHeight)), G.Body2, s(hl || (hl = V([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), A.body2.fontSize)), wd = ["as", "darkMode", "children", "className"];
be(function(e) {
  var t = e.as, n = t === void 0 ? "p" : t, r = e.darkMode, u = e.children, d = e.className, p = Ge(e, wd), v = Q(r).theme, g = mn(), m = ye(n).Component;
  return w.createElement(m, Pe({}, p, { className: B(md, bd[v], yd[g], d) }), u);
});
var Od = s(pl || (pl = V([`
  font-weight: `, `;
  font-size: 48px;
  line-height: 62px;
  font-family: `, `;
`])), ne.regular, se.serif), xd = te(te({}, y.Light, s(vl || (vl = V([`
    color: `, `;
  `])), l.green.dark2)), y.Dark, s(ml || (ml = V([`
    color: `, `;
  `])), l.gray.light2)), jd = ["darkMode", "className", "as"], $d = be(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, u = r === void 0 ? "h1" : r, d = Ge(e, jd), p = Q(t).theme, v = ye(u).Component;
  return w.createElement(v, Pe({ className: B(Cn, Od, xd[p], n) }, d));
});
$d.displayName = "H1";
var Ol, Ed = s(bl || (bl = V([`
  font-size: 32px;
  line-height: 40px;
  font-weight: `, `;
  font-family: `, `;
`])), ne.regular, se.serif), Cd = te(te({}, y.Light, s(yl || (yl = V([`
    color: `, `;
  `])), l.green.dark2)), y.Dark, s(wl || (wl = V([`
    color: `, `;
  `])), l.gray.light2)), kd = ["darkMode", "className", "as"], Md = be(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, u = r === void 0 ? "h2" : r, d = Ge(e, kd), p = Q(t).theme, v = ye(u).Component;
  return w.createElement(v, Pe({ className: B(Cn, Ed, Cd[p], n) }, d));
});
Md.displayName = "H2";
var xl, jl, $l, El, Cl, kl, Ml, Ll, Zl, Pl, Ld = s(Ol || (Ol = V([`
  font-size: 24px;
  line-height: 32px;
  font-weight: `, `;
`])), ne.medium), Zd = ["darkMode", "className", "as"], Pd = be(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, u = r === void 0 ? "h3" : r, d = Ge(e, Zd), p = Q(t).theme, v = ye(u).Component;
  return w.createElement(v, Pe({ className: B(Cn, Ld, Kn[p], n) }, d));
});
Pd.displayName = "H3";
var Sl, Nl, zl, On = Ae(), Sd = s(xl || (xl = V([`
  display: inline;
  transition: all 0.15s ease-in-out;
  border-radius: 3px;
  font-family: `, `;
  line-height: 20px;

  .`, `:hover > & {
    text-decoration: none;
  }
`])), se.code, On), Nd = te(te({}, y.Light, s(jl || (jl = V([`
    background-color: `, `;
    border: 1px solid `, `;
    color: `, `;

    .`, `:hover > & {
      box-shadow: 0 0 0 3px `, `;
      border: 1px solid `, `;
    }
  `])), l.gray.light3, l.gray.light2, l.gray.dark3, On, l.gray.light2, l.gray.light1)), y.Dark, s($l || ($l = V([`
    background-color: transparent;
    border: 1px solid `, `;
    color: `, `;

    .`, `:hover > & {
      box-shadow: 0 0 0 3px `, `;
      border: 1px solid `, `;
    }
  `])), l.gray.dark2, l.gray.light1, On, l.gray.dark2, l.gray.dark1)), zd = te(te({}, y.Light, s(El || (El = V([`
    .`, `:focus-visible > & {
      box-shadow: `, `;
      border: 1px solid `, `;
    }
  `])), On, We[y.Light].default, l.blue.base)), y.Dark, s(Cl || (Cl = V([`
    .`, `:focus-visible > & {
      box-shadow: `, `;
      border: 1px solid `, `;
    }
  `])), On, We[y.Dark].default, l.blue.base)), Hd = te(te({}, y.Light, s(kl || (kl = V([`
    color: `, `;
  `])), l.blue.base)), y.Dark, s(Ml || (Ml = V([`
    color: `, `;
  `])), l.blue.light1)), Rd = s(Ll || (Ll = V([`
  text-decoration: none;
  margin: 0;
  padding: 0;
  line-height: 20px;

  &:focus {
    outline: none;
  }
`]))), Ad = s(Zl || (Zl = V([`
  white-space: nowrap;
`]))), Bd = s(Pl || (Pl = V([`
  white-space: normal;
`]))), Dd = ["children", "className", "darkMode", "baseFontSize", "as"], Hl = Xe(function(e, t) {
  var n, r, u = e.children, d = e.className, p = e.darkMode, v = e.baseFontSize, g = e.as, m = Ge(e, Dd), h = Q(p).theme, b = mn(v), E = sn(g, m, "code").Component, k = ((n = typeof u == "string" && ((r = u.match(/(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g)) === null || r === void 0 ? void 0 : r.length)) !== null && n !== void 0 ? n : 0) <= 30 ? Ad : Bd, L = E !== "code", P = w.createElement("code", { ref: t, className: B(sd[b], Sd, Nd[h], zd[h], k, te({}, Hd[h], L), d) }, u);
  return L ? w.createElement(E, Pe({ className: B(On, Rd, d) }, m), P) : w.cloneElement(P, m);
});
Hl.displayName = "InlineCode", Hl.propTypes = { children: fe.node, className: fe.string, darkMode: fe.bool, baseFontSize: fe.oneOf(Object.values(G)) };
var Rl, Al, Bl, Dl, Vl, Tl, Fl;
s(Sl || (Sl = V([`
  font-family: `, `;
  border: 1px solid;
  border-radius: 3px;
  padding-left: 5px;
  padding-right: 5px;
`])), se.code);
te(te({}, y.Light, s(Nl || (Nl = V([`
    color: `, `;
    border-color: `, `;
    background-color: `, `;
  `])), l.black, l.gray.dark3, l.white)), y.Dark, s(zl || (zl = V([`
    color: `, `;
    border-color: `, `;
    background-color: `, `;
  `])), l.gray.light2, l.gray.base, l.gray.dark3));
var Il, _l, Gl, Vd = s(Rl || (Rl = V([`
  font-family: `, `;
  font-weight: `, `;
`])), se.default, ne.bold), Td = te(te({}, y.Light, s(Al || (Al = V([`
    color: `, `;
  `])), l.black)), y.Dark, s(Bl || (Bl = V([`
    color: `, `;
  `])), l.gray.light2)), Fd = te(te({}, y.Light, s(Dl || (Dl = V([`
    color: `, `;
  `])), l.gray.base)), y.Dark, s(Vl || (Vl = V([`
    color: `, `;
  `])), l.gray.dark1)), Id = te(te({}, G.Body1, s(Tl || (Tl = V([`
    font-size: `, `px;
    line-height: `, `px;
  `])), A.body1.fontSize, A.body1.lineHeight)), G.Body2, s(Fl || (Fl = V([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), A.body2.fontSize)), _d = ["baseFontSize", "darkMode", "className", "children", "disabled", "as", "data-lgid"], Gd = be(function(e) {
  var t = e.baseFontSize, n = e.darkMode, r = e.className, u = e.children, d = e.disabled, p = d !== void 0 && d, v = e.as, g = v === void 0 ? "label" : v, m = e["data-lgid"], h = m === void 0 ? uf.label : m, b = Ge(e, _d), E = Q(n).theme, k = mn(t), L = ye(g).Component;
  return w.createElement(L, Pe({ "data-lgid": h, className: B(Vd, Td[E], Id[k], te({}, Fd[E], p), r) }, b), u);
});
Gd.displayName = "Label";
var Ul, Wl, Yl, Xl, ql, Kl, Wn = Ae(), df = s(Il || (Il = V([`
  font-family: `, `;
  display: inline;
  align-items: center;
  text-decoration: none;
  text-decoration-color: transparent;
  cursor: pointer;
  font-size: inherit;
  line-height: inherit;
  appearance: none;
  background: none;
  border: none;
  padding: 0;

  &:hover,
  &[data-hover='true'],
  &:focus,
  &[data-focus='true'] {
    text-decoration: underline;
    transition: text-decoration `, `ms ease-in-out;
    text-underline-offset: 4px;
    text-decoration-thickness: 2px;
  }

  &:focus {
    outline: none;
  }
`])), se.default, Ye.default), gf = te(te({}, y.Light, s(_l || (_l = V([`
    color: `, `;
    font-weight: `, `;

    &:hover,
    &[data-hover='true'] {
      text-decoration-color: `, `;
    }

    &:focus,
    &[data-focus='true'] {
      text-decoration-color: `, `;
    }
  `])), l.blue.base, ne.regular, l.gray.light2, l.blue.base)), y.Dark, s(Gl || (Gl = V([`
    color: `, `;
    font-weight: `, `;

    &:hover,
    &[data-hover='true'] {
      text-decoration-color: `, `;
    }

    &:focus,
    &[data-focus='true'] {
      text-decoration-color: `, `;
    }
  `])), l.blue.light1, ne.bold, l.gray.dark2, l.blue.base)), hf = function(e) {
  if (e)
    return sf[e];
}, Ud = s(Ul || (Ul = V([`
  gap: `, `px;
  display: inline-flex;
`])), he[100]), Wd = ["children", "className", "baseFontSize", "darkMode", "as"];
Xe(function(e, t) {
  var n = e.children, r = e.className, u = e.baseFontSize, d = e.darkMode, p = e.as, v = Ge(e, Wd), g = Q(d).theme, m = mn(u), h = sn(p, v, "span").Component;
  return w.createElement(h, Pe({ className: B(Wn, df, hf(m), gf[g], Ud, r), ref: t }, v), w.createElement(td, { role: "presentation" }), n);
});
var Yd = s(Wl || (Wl = V([`
  transform: translate3d(3px, 0, 0);
  top: 1px;
  position: relative;
`]))), Xd = s(Yl || (Yl = V([`
  opacity: 0;
  transform: translate3d(-3px, 0, 0);
  transition: 100ms ease-in;
  transition-property: opacity, transform;
  top: 1px;
  position: relative;

  .`, ":hover &, .", `[data-hover='true'] & {
    opacity: 1;
    transform: translate3d(3px, 0, 0);
  }
`])), Wn, Wn), qd = s(Xl || (Xl = V([`
  position: relative;
  bottom: 2px;
  left: -1px;
  height: 12px;
`]))), Kd = "hover", Jd = "persist", Jl = "none", Qd = ["children", "className", "arrowAppearance", "hideExternalIcon", "baseFontSize", "darkMode", "as"];
Xe(function(e, t) {
  var n = e.children, r = e.className, u = e.arrowAppearance, d = u === void 0 ? Jl : u, p = e.hideExternalIcon, v = p !== void 0 && p, g = e.baseFontSize, m = e.darkMode, h = e.as, b = Ge(e, Qd), E = cd(Ue(""), 2), k = E[0], L = E[1];
  Dn(function() {
    L(window.location.hostname);
  }, []);
  var P, R = Q(m).theme, Y = mn(g), M = sn(h, b, "span").Component, a = En(function() {
    if (b.href !== void 0)
      return /^http(s)?:\/\//.test(b.href) ? new URL(b.href).hostname : k;
  }, [b, k]), i = { target: void 0, rel: void 0 };
  return b.target || b.rel ? (i.target = b.target, i.rel = b.rel) : M === "a" && (a === k ? i.target = "_self" : (i.target = "_blank", i.rel = "noopener noreferrer")), i.target !== "_blank" || v ? d !== Jl && (P = w.createElement(ad, { role: "presentation", size: 12, className: B(te(te({}, Xd, d === Kd), Yd, d === Jd)) })) : P = w.createElement(ld, { role: "presentation", className: qd }), w.createElement(M, Pe({ className: B(Wn, df, hf(Y), gf[R], r), ref: t }, i, b), w.createElement("span", null, n), P);
});
var eg = s(ql || (ql = V([`
  font-size: 12px;
  font-weight: `, `;
  text-transform: uppercase;
  line-height: 20px;
  letter-spacing: 0.4px;
`])), ne.bold), ng = ["darkMode", "className", "as"], tg = be(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, u = r === void 0 ? "div" : r, d = Ge(e, ng), p = Q(t).theme, v = ye(u).Component;
  return w.createElement(v, Pe({ className: B(Cn, eg, Kn[p], n) }, d));
});
tg.displayName = "Overline";
var rg = s(Kl || (Kl = V([`
  font-size: 18px;
  line-height: 24px;
  font-weight: `, `;
`])), ne.bold), ag = ["darkMode", "className", "as"], og = be(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, u = r === void 0 ? "h6" : r, d = Ge(e, ag), p = Q(t).theme, v = ye(u).Component;
  return w.createElement(v, Pe({ className: B(Cn, rg, Kn[p], n) }, d));
});
og.displayName = "Subtitle";
var Ql;
s(Ql || (Ql = V([`
  flex: 1;
  min-width: 0;
  max-width: 100%;

  white-space: inherit;
  overflow: inherit;
  text-overflow: inherit;
`])));
function lg(e) {
  var t = function(n, r) {
    if (typeof n != "object" || !n)
      return n;
    var u = n[Symbol.toPrimitive];
    if (u !== void 0) {
      var d = u.call(n, r || "default");
      if (typeof d != "object")
        return d;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (r === "string" ? String : Number)(n);
  }(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function Ne(e, t, n) {
  return (t = lg(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function ct() {
  return ct = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ct.apply(this, arguments);
}
function ig(e, t) {
  if (e == null)
    return {};
  var n, r, u = function(p, v) {
    if (p == null)
      return {};
    var g, m, h = {}, b = Object.keys(p);
    for (m = 0; m < b.length; m++)
      g = b[m], v.indexOf(g) >= 0 || (h[g] = p[g]);
    return h;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(e);
    for (r = 0; r < d.length; r++)
      n = d[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (u[n] = e[n]);
  }
  return u;
}
function Ce(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
var e0, n0, t0, r0, a0, o0, l0, i0, c0, s0, u0, f0, d0, g0, h0, p0, v0, pf = Ae("input-option-title"), st = Ae("input-option-description"), cg = s(e0 || (e0 = Ce([`
  position: relative;
  list-style: none;
  outline: none;
  border: unset;
  margin: 0;
  text-align: left;
  text-decoration: none;
  cursor: pointer;

  font-size: `, `px;
  line-height: `, `px;
  font-family: `, `;
  padding: `, "px ", `px;

  transition: background-color `, `ms ease-in-out;

  &:focus,
  &:focus-visible {
    outline: none;
    border: unset;
  }
`])), A.body1.fontSize, A.body1.lineHeight, se.default, he[2], he[2] + he[1], Ye.default), sg = s(n0 || (n0 = Ce([`
  .`, ` {
    font-weight: bold;
  }
`])), pf), ug = Ne(Ne({}, y.Light, s(t0 || (t0 = Ce([`
    color: `, `;
  `])), l.black)), y.Dark, s(r0 || (r0 = Ce([`
    color: `, `;
  `])), l.gray.light2)), fg = Ne(Ne({}, y.Light, s(a0 || (a0 = Ce([`
    &:hover {
      outline: none;
      background-color: `, `;
    }
  `])), l.gray.light2)), y.Dark, s(o0 || (o0 = Ce([`
    &:hover {
      outline: none;
      background-color: `, `;
    }
  `])), l.gray.dark4)), dg = he[1], gg = he[2], hg = s(l0 || (l0 = Ce([`
  // Left wedge
  &:before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    width: `, `px;
    height: calc(100% - `, `px);
    min-height: `, `px;
    background-color: rgba(255, 255, 255, 0);
    border-radius: 0 6px 6px 0;
    transform: scale3d(0, 0.3, 0) translateY(-50%);
    transform-origin: 0%; // 0% since we use translateY
    transition: `, `ms ease-in-out;
    transition-property: transform, background-color;
  }
`])), dg, 2 * gg, he[3], Ye.default), pg = Ne(Ne({}, y.Light, s(i0 || (i0 = Ce([`
    outline: none;
    background-color: `, `;
    color: `, `;

    &:before {
      transform: scaleY(1) translateY(-50%);
      background-color: `, `;
    }
  `])), l.blue.light3, l.blue.dark2, l.blue.base)), y.Dark, s(c0 || (c0 = Ce([`
    outline: none;
    background-color: `, `;
    color: `, `;

    &:before {
      transform: scaleY(1) translateY(-50%);
      background-color: `, `;
    }
  `])), l.blue.dark3, l.blue.light3, l.blue.light1)), vg = Ne(Ne({}, y.Light, s(s0 || (s0 = Ce([`
    cursor: not-allowed;

    &,
    & .`, ` {
      color: `, `;
    }

    &:hover {
      background-color: inherit;
    }

    &:before {
      content: unset;
    }
  `])), st, l.gray.light1)), y.Dark, s(u0 || (u0 = Ce([`
    cursor: not-allowed;

    &,
    & .`, ` {
      color: `, `;
    }

    &:hover {
      background-color: inherit;
    }

    &:before {
      content: unset;
    }
  `])), st, l.gray.dark1)), mg = ["as", "children", "disabled", "highlighted", "selected", "darkMode", "showWedge", "isInteractive", "className"], kn = be(function(e, t) {
  var n = e.as, r = n === void 0 ? "li" : n, u = e.children, d = e.disabled, p = e.highlighted, v = e.selected, g = e.darkMode, m = e.showWedge, h = m === void 0 || m, b = e.isInteractive, E = b === void 0 || b, k = e.className, L = ig(e, mg), P = ye(r).Component, R = Q(g).theme;
  return w.createElement(P, ct({ ref: t, role: "option", "aria-selected": p, "aria-disabled": d, tabIndex: -1, className: B(cg, ug[R], Ne(Ne(Ne(Ne(Ne({}, hg, h), fg[R], E), pg[R], E && (v || p)), vg[R], d), sg, v), k) }, L), u);
});
kn.displayName = "InputOption";
var bg = Ae("input-option-left-glyph"), yg = s(f0 || (f0 = Ce([`
  overflow-wrap: anywhere;
`]))), wg = s(d0 || (d0 = Ce([`
  max-height: `, `px;
  overflow: hidden;
  font-size: inherit;
  text-overflow: ellipsis;
`])), 3 * he[3]), Og = s(g0 || (g0 = Ce([`
  display: grid;
  grid-template-columns: `, `px 1fr;
  gap: `, `px;
  align-items: center;
  width: 100%;
`])), he[3], he[2]), xg = s(h0 || (h0 = Ce([`
  grid-column: 2;
`]))), m0 = s(p0 || (p0 = Ce([`
  display: flex;
  height: 20px;
  align-items: center;
`]))), jg = s(v0 || (v0 = Ce([`
  width: `, `px;
  grid-column: 3;
  grid-row: 1;
`])), he[3]), $g = function(e) {
  var t = e.children, n = e.description, r = e.leftGlyph, u = e.rightGlyph;
  return w.createElement("div", { className: Og }, r && w.createElement("div", { className: B(bg, m0) }, r), w.createElement("div", { className: xg }, w.createElement("div", { className: B(pf, yg) }, t), n && w.createElement(ff, { className: B(st, wg) }, n)), u && w.createElement("div", { className: B(m0, jg) }, u));
};
$g.displayName = "InputOptionContent";
var vf = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(w, _e, Ie);
  })(Te, function(n, r, u) {
    function d(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function p(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var i = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(o) {
        if (o !== "default") {
          var f = Object.getOwnPropertyDescriptor(a, o);
          Object.defineProperty(i, o, f.get ? f : { enumerable: !0, get: function() {
            return a[o];
          } });
        }
      }), i.default = a, Object.freeze(i);
    }
    var v = p(n), g = d(r);
    function m(a) {
      var i = function(o, f) {
        if (typeof o != "object" || !o)
          return o;
        var j = o[Symbol.toPrimitive];
        if (j !== void 0) {
          var x = j.call(o, f || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (f === "string" ? String : Number)(o);
      }(a, "string");
      return typeof i == "symbol" ? i : i + "";
    }
    function h(a, i, o) {
      return (i = m(i)) in a ? Object.defineProperty(a, i, { value: o, enumerable: !0, configurable: !0, writable: !0 }) : a[i] = o, a;
    }
    function b() {
      return b = Object.assign ? Object.assign.bind() : function(a) {
        for (var i = 1; i < arguments.length; i++) {
          var o = arguments[i];
          for (var f in o)
            Object.prototype.hasOwnProperty.call(o, f) && (a[f] = o[f]);
        }
        return a;
      }, b.apply(this, arguments);
    }
    function E(a, i) {
      if (a == null)
        return {};
      var o, f, j = function(Z, N) {
        if (Z == null)
          return {};
        var O, $, H = {}, z = Object.keys(Z);
        for ($ = 0; $ < z.length; $++)
          O = z[$], N.indexOf(O) >= 0 || (H[O] = Z[O]);
        return H;
      }(a, i);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (f = 0; f < x.length; f++)
          o = x[f], i.indexOf(o) >= 0 || Object.prototype.propertyIsEnumerable.call(a, o) && (j[o] = a[o]);
      }
      return j;
    }
    function k(a, i) {
      return i || (i = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(i) } }));
    }
    var L, P, R = { small: 14, default: 16, large: 20, xlarge: 24 }, Y = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], M = function(a) {
      var i = a.className, o = a.size, f = o === void 0 ? 16 : o, j = a.title, x = a["aria-label"], Z = a["aria-labelledby"], N = a.fill, O = a.role, $ = O === void 0 ? "img" : O, H = E(a, Y), z = u.css(L || (L = k([`
        color: `, `;
      `])), N), ie = u.css(P || (P = k([`
        flex-shrink: 0;
      `]))), X = function(ee, re, I) {
        var q, K = I["aria-label"], J = I["aria-labelledby"], W = I.title;
        switch (ee) {
          case "img":
            return K || J || W ? h(h(h({}, "aria-labelledby", J), "aria-label", K), "title", W) : { "aria-label": (q = re, "".concat(q.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }($, "Refresh", h(h({ title: j }, "aria-label", x), "aria-labelledby", Z));
      return v.createElement("svg", b({ className: u.cx(h({}, z, N != null), ie, i), height: typeof f == "number" ? f : R[f], width: typeof f == "number" ? f : R[f], role: $ }, X, H, { viewBox: "0 0 16 16" }), v.createElement("path", { d: "M8.03289 2C10.7318 2 12.9831 3.71776 13.5 6L14.9144 6C15.4555 6 15.7061 6.67202 15.297 7.02629L12.8153 9.17546C12.5957 9.36566 12.2697 9.36566 12.0501 9.17545L9.56844 7.02629C9.15937 6.67202 9.40991 6 9.95107 6H11.3977C10.929 4.91456 9.7172 4 8.03289 4C7.00662 4 6.15578 4.33954 5.54157 4.85039C5.29859 5.05248 4.92429 5.0527 4.72549 4.80702L4.11499 4.05254C3.95543 3.85535 3.96725 3.56792 4.1591 3.40197C5.16255 2.53394 6.52815 2 8.03289 2Z", fill: "currentColor" }), v.createElement("path", { d: "M3.94991 6.84265C3.73028 6.65245 3.40429 6.65245 3.18466 6.84265L0.703017 8.99182C0.293944 9.34608 0.544489 10.0181 1.08564 10.0181H2.50411C3.02878 12.2913 5.27531 14 7.96711 14C9.47186 14 10.8375 13.4661 11.8409 12.598C12.0327 12.4321 12.0446 12.1447 11.885 11.9475L11.2745 11.193C11.0757 10.9473 10.7014 10.9475 10.4584 11.1496C9.84422 11.6605 8.99338 12 7.96711 12C6.29218 12 5.08453 11.0956 4.6102 10.0181H6.04893C6.59009 10.0181 6.84063 9.34608 6.43156 8.99182L3.94991 6.84265Z", fill: "currentColor" }));
    };
    return M.displayName = "Refresh", M.isGlyph = !0, M.propTypes = { fill: g.default.string, size: g.default.oneOfType([g.default.number, g.default.string]), className: g.default.string }, M;
  });
})(vf);
var Eg = vf.exports;
const Cg = /* @__PURE__ */ Fe(Eg);
var mf = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(w, _e, Ie);
  })(Te, function(n, r, u) {
    function d(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function p(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var i = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(o) {
        if (o !== "default") {
          var f = Object.getOwnPropertyDescriptor(a, o);
          Object.defineProperty(i, o, f.get ? f : { enumerable: !0, get: function() {
            return a[o];
          } });
        }
      }), i.default = a, Object.freeze(i);
    }
    var v = p(n), g = d(r);
    function m(a) {
      var i = function(o, f) {
        if (typeof o != "object" || !o)
          return o;
        var j = o[Symbol.toPrimitive];
        if (j !== void 0) {
          var x = j.call(o, f || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (f === "string" ? String : Number)(o);
      }(a, "string");
      return typeof i == "symbol" ? i : i + "";
    }
    function h(a, i, o) {
      return (i = m(i)) in a ? Object.defineProperty(a, i, { value: o, enumerable: !0, configurable: !0, writable: !0 }) : a[i] = o, a;
    }
    function b() {
      return b = Object.assign ? Object.assign.bind() : function(a) {
        for (var i = 1; i < arguments.length; i++) {
          var o = arguments[i];
          for (var f in o)
            Object.prototype.hasOwnProperty.call(o, f) && (a[f] = o[f]);
        }
        return a;
      }, b.apply(this, arguments);
    }
    function E(a, i) {
      if (a == null)
        return {};
      var o, f, j = function(Z, N) {
        if (Z == null)
          return {};
        var O, $, H = {}, z = Object.keys(Z);
        for ($ = 0; $ < z.length; $++)
          O = z[$], N.indexOf(O) >= 0 || (H[O] = Z[O]);
        return H;
      }(a, i);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (f = 0; f < x.length; f++)
          o = x[f], i.indexOf(o) >= 0 || Object.prototype.propertyIsEnumerable.call(a, o) && (j[o] = a[o]);
      }
      return j;
    }
    function k(a, i) {
      return i || (i = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(i) } }));
    }
    var L, P, R = { small: 14, default: 16, large: 20, xlarge: 24 }, Y = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], M = function(a) {
      var i = a.className, o = a.size, f = o === void 0 ? 16 : o, j = a.title, x = a["aria-label"], Z = a["aria-labelledby"], N = a.fill, O = a.role, $ = O === void 0 ? "img" : O, H = E(a, Y), z = u.css(L || (L = k([`
        color: `, `;
      `])), N), ie = u.css(P || (P = k([`
        flex-shrink: 0;
      `]))), X = function(ee, re, I) {
        var q, K = I["aria-label"], J = I["aria-labelledby"], W = I.title;
        switch (ee) {
          case "img":
            return K || J || W ? h(h(h({}, "aria-labelledby", J), "aria-label", K), "title", W) : { "aria-label": (q = re, "".concat(q.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }($, "ArrowLeft", h(h({ title: j }, "aria-label", x), "aria-labelledby", Z));
      return v.createElement("svg", b({ className: u.cx(h({}, z, N != null), ie, i), height: typeof f == "number" ? f : R[f], width: typeof f == "number" ? f : R[f], role: $ }, X, H, { viewBox: "0 0 16 16" }), v.createElement("path", { d: "M13 6.83212L6.05559 6.83212L7.59059 5.29711C7.98112 4.90659 7.98112 4.27342 7.59059 3.8829L7.35168 3.64398C6.96115 3.25346 6.32799 3.25345 5.93746 3.64398L2.55483 7.02661C2.5456 7.03518 2.5365 7.04395 2.52752 7.05292L2.2886 7.29184C1.89808 7.68237 1.89808 8.31553 2.2886 8.70605L5.93975 12.3572C6.33028 12.7477 6.96344 12.7477 7.35397 12.3572L7.59288 12.1183C7.98341 11.7278 7.98341 11.0946 7.59288 10.7041L6.0588 9.17L13 9.17C13.5523 9.17 14 8.72228 14 8.17V7.83212C14 7.27983 13.5523 6.83212 13 6.83212Z", fill: "currentColor" }));
    };
    return M.displayName = "ArrowLeft", M.isGlyph = !0, M.propTypes = { fill: g.default.string, size: g.default.oneOfType([g.default.number, g.default.string]), className: g.default.string }, M;
  });
})(mf);
var kg = mf.exports;
const Mg = /* @__PURE__ */ Fe(kg);
var bf = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(w, _e, Ie);
  })(Te, function(n, r, u) {
    function d(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function p(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var i = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(o) {
        if (o !== "default") {
          var f = Object.getOwnPropertyDescriptor(a, o);
          Object.defineProperty(i, o, f.get ? f : { enumerable: !0, get: function() {
            return a[o];
          } });
        }
      }), i.default = a, Object.freeze(i);
    }
    var v = p(n), g = d(r);
    function m(a) {
      var i = function(o, f) {
        if (typeof o != "object" || !o)
          return o;
        var j = o[Symbol.toPrimitive];
        if (j !== void 0) {
          var x = j.call(o, f || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (f === "string" ? String : Number)(o);
      }(a, "string");
      return typeof i == "symbol" ? i : i + "";
    }
    function h(a, i, o) {
      return (i = m(i)) in a ? Object.defineProperty(a, i, { value: o, enumerable: !0, configurable: !0, writable: !0 }) : a[i] = o, a;
    }
    function b() {
      return b = Object.assign ? Object.assign.bind() : function(a) {
        for (var i = 1; i < arguments.length; i++) {
          var o = arguments[i];
          for (var f in o)
            Object.prototype.hasOwnProperty.call(o, f) && (a[f] = o[f]);
        }
        return a;
      }, b.apply(this, arguments);
    }
    function E(a, i) {
      if (a == null)
        return {};
      var o, f, j = function(Z, N) {
        if (Z == null)
          return {};
        var O, $, H = {}, z = Object.keys(Z);
        for ($ = 0; $ < z.length; $++)
          O = z[$], N.indexOf(O) >= 0 || (H[O] = Z[O]);
        return H;
      }(a, i);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (f = 0; f < x.length; f++)
          o = x[f], i.indexOf(o) >= 0 || Object.prototype.propertyIsEnumerable.call(a, o) && (j[o] = a[o]);
      }
      return j;
    }
    function k(a, i) {
      return i || (i = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(i) } }));
    }
    var L, P, R = { small: 14, default: 16, large: 20, xlarge: 24 }, Y = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], M = function(a) {
      var i = a.className, o = a.size, f = o === void 0 ? 16 : o, j = a.title, x = a["aria-label"], Z = a["aria-labelledby"], N = a.fill, O = a.role, $ = O === void 0 ? "img" : O, H = E(a, Y), z = u.css(L || (L = k([`
        color: `, `;
      `])), N), ie = u.css(P || (P = k([`
        flex-shrink: 0;
      `]))), X = function(ee, re, I) {
        var q, K = I["aria-label"], J = I["aria-labelledby"], W = I.title;
        switch (ee) {
          case "img":
            return K || J || W ? h(h(h({}, "aria-labelledby", J), "aria-label", K), "title", W) : { "aria-label": (q = re, "".concat(q.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }($, "ArrowRight", h(h({ title: j }, "aria-label", x), "aria-labelledby", Z));
      return v.createElement("svg", b({ className: u.cx(h({}, z, N != null), ie, i), height: typeof f == "number" ? f : R[f], width: typeof f == "number" ? f : R[f], role: $ }, X, H, { viewBox: "0 0 16 16" }), v.createElement("path", { d: "M3 6.83212L9.94442 6.83212L8.40941 5.29711C8.01888 4.90659 8.01889 4.27342 8.40941 3.8829L8.64833 3.64398C9.03885 3.25346 9.67201 3.25345 10.0625 3.64398L13.4452 7.02661C13.4544 7.03518 13.4635 7.04395 13.4725 7.05292L13.7114 7.29184C14.1019 7.68237 14.1019 8.31553 13.7114 8.70605L10.0602 12.3572C9.66972 12.7477 9.03656 12.7477 8.64603 12.3572L8.40712 12.1183C8.01659 11.7278 8.01659 11.0946 8.40712 10.7041L9.9412 9.17L3 9.17C2.44771 9.17 2 8.72228 2 8.17L2 7.83212C2 7.27983 2.44772 6.83212 3 6.83212Z", fill: "currentColor" }));
    };
    return M.displayName = "ArrowRight", M.isGlyph = !0, M.propTypes = { fill: g.default.string, size: g.default.oneOfType([g.default.number, g.default.string]), className: g.default.string }, M;
  });
})(bf);
var Lg = bf.exports;
const Zg = /* @__PURE__ */ Fe(Lg);
var yf = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(w, _e, Ie);
  })(Te, function(n, r, u) {
    function d(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function p(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var i = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(o) {
        if (o !== "default") {
          var f = Object.getOwnPropertyDescriptor(a, o);
          Object.defineProperty(i, o, f.get ? f : { enumerable: !0, get: function() {
            return a[o];
          } });
        }
      }), i.default = a, Object.freeze(i);
    }
    var v = p(n), g = d(r);
    function m(a) {
      var i = function(o, f) {
        if (typeof o != "object" || !o)
          return o;
        var j = o[Symbol.toPrimitive];
        if (j !== void 0) {
          var x = j.call(o, f || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (f === "string" ? String : Number)(o);
      }(a, "string");
      return typeof i == "symbol" ? i : i + "";
    }
    function h(a, i, o) {
      return (i = m(i)) in a ? Object.defineProperty(a, i, { value: o, enumerable: !0, configurable: !0, writable: !0 }) : a[i] = o, a;
    }
    function b() {
      return b = Object.assign ? Object.assign.bind() : function(a) {
        for (var i = 1; i < arguments.length; i++) {
          var o = arguments[i];
          for (var f in o)
            Object.prototype.hasOwnProperty.call(o, f) && (a[f] = o[f]);
        }
        return a;
      }, b.apply(this, arguments);
    }
    function E(a, i) {
      if (a == null)
        return {};
      var o, f, j = function(Z, N) {
        if (Z == null)
          return {};
        var O, $, H = {}, z = Object.keys(Z);
        for ($ = 0; $ < z.length; $++)
          O = z[$], N.indexOf(O) >= 0 || (H[O] = Z[O]);
        return H;
      }(a, i);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (f = 0; f < x.length; f++)
          o = x[f], i.indexOf(o) >= 0 || Object.prototype.propertyIsEnumerable.call(a, o) && (j[o] = a[o]);
      }
      return j;
    }
    function k(a, i) {
      return i || (i = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(i) } }));
    }
    var L, P, R = { small: 14, default: 16, large: 20, xlarge: 24 }, Y = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], M = function(a) {
      var i = a.className, o = a.size, f = o === void 0 ? 16 : o, j = a.title, x = a["aria-label"], Z = a["aria-labelledby"], N = a.fill, O = a.role, $ = O === void 0 ? "img" : O, H = E(a, Y), z = u.css(L || (L = k([`
        color: `, `;
      `])), N), ie = u.css(P || (P = k([`
        flex-shrink: 0;
      `]))), X = function(ee, re, I) {
        var q, K = I["aria-label"], J = I["aria-labelledby"], W = I.title;
        switch (ee) {
          case "img":
            return K || J || W ? h(h(h({}, "aria-labelledby", J), "aria-label", K), "title", W) : { "aria-label": (q = re, "".concat(q.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }($, "OpenNewTab", h(h({ title: j }, "aria-label", x), "aria-labelledby", Z));
      return v.createElement("svg", b({ className: u.cx(h({}, z, N != null), ie, i), height: typeof f == "number" ? f : R[f], width: typeof f == "number" ? f : R[f], role: $ }, X, H, { viewBox: "0 0 16 16" }), v.createElement("path", { d: "M13.823 2.4491C13.8201 2.30008 13.6999 2.17994 13.5509 2.17704L9.5062 2.09836C9.25654 2.09351 9.12821 2.39519 9.30482 2.5718L10.3856 3.65257L7.93433 6.10383C7.87964 6.15852 7.83047 6.21665 7.78683 6.27752L5.99909 8.06525C5.46457 8.59977 5.46457 9.4664 5.99909 10.0009C6.53361 10.5354 7.40023 10.5354 7.93475 10.0009L9.72249 8.21317C9.78336 8.16953 9.84148 8.12037 9.89618 8.06567L12.3474 5.61441L13.4282 6.69518C13.6048 6.87179 13.9065 6.74347 13.9016 6.4938L13.823 2.4491Z", fill: "currentColor" }), v.createElement("path", { d: "M7.25 3.12893C7.66421 3.12893 8 3.46472 8 3.87893C8 4.29315 7.66421 4.62893 7.25 4.62893H4C3.72386 4.62893 3.5 4.85279 3.5 5.12893V11.9929C3.5 12.2691 3.72386 12.4929 4 12.4929H10.864C11.1401 12.4929 11.364 12.2691 11.364 11.9929V8.75C11.364 8.33579 11.6998 8 12.114 8C12.5282 8 12.864 8.33579 12.864 8.75V11.9929C12.864 13.0975 11.9686 13.9929 10.864 13.9929H4C2.89543 13.9929 2 13.0975 2 11.9929V5.12893C2 4.02436 2.89543 3.12893 4 3.12893H7.25Z", fill: "currentColor" }));
    };
    return M.displayName = "OpenNewTab", M.isGlyph = !0, M.propTypes = { fill: g.default.string, size: g.default.oneOfType([g.default.number, g.default.string]), className: g.default.string }, M;
  });
})(yf);
var Pg = yf.exports;
const Sg = /* @__PURE__ */ Fe(Pg);
function Ng(e) {
  var t = function(n, r) {
    if (typeof n != "object" || !n)
      return n;
    var u = n[Symbol.toPrimitive];
    if (u !== void 0) {
      var d = u.call(n, r || "default");
      if (typeof d != "object")
        return d;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (r === "string" ? String : Number)(n);
  }(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function oe(e, t, n) {
  return (t = Ng(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function He() {
  return He = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, He.apply(this, arguments);
}
function qe(e, t) {
  if (e == null)
    return {};
  var n, r, u = function(p, v) {
    if (p == null)
      return {};
    var g, m, h = {}, b = Object.keys(p);
    for (m = 0; m < b.length; m++)
      g = b[m], v.indexOf(g) >= 0 || (h[g] = p[g]);
    return h;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(e);
    for (r = 0; r < d.length; r++)
      n = d[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (u[n] = e[n]);
  }
  return u;
}
function T(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
function zg(e, t) {
  return function(n) {
    if (Array.isArray(n))
      return n;
  }(e) || function(n, r) {
    var u = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
    if (u != null) {
      var d, p, v, g, m = [], h = !0, b = !1;
      try {
        if (v = (u = u.call(n)).next, r === 0) {
          if (Object(u) !== u)
            return;
          h = !1;
        } else
          for (; !(h = (d = v.call(u)).done) && (m.push(d.value), m.length !== r); h = !0)
            ;
      } catch (E) {
        b = !0, p = E;
      } finally {
        try {
          if (!h && u.return != null && (g = u.return(), Object(g) !== g))
            return;
        } finally {
          if (b)
            throw p;
        }
      }
      return m;
    }
  }(e, t) || function(n, r) {
    if (n) {
      if (typeof n == "string")
        return b0(n, r);
      var u = Object.prototype.toString.call(n).slice(8, -1);
      if (u === "Object" && n.constructor && (u = n.constructor.name), u === "Map" || u === "Set")
        return Array.from(n);
      if (u === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(u))
        return b0(n, r);
    }
  }(e, t) || function() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function b0(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var y0, w0, O0, x0, j0, $0, E0, C0, Mn = s(y0 || (y0 = T([`
  margin: unset;
  font-family: `, `;
  color: `, `;
`])), se.default, l.black), wf = oe(oe({}, G.Body1, s(w0 || (w0 = T([`
    font-size: `, `px;
    line-height: `, `px;
  `])), A.body1.fontSize, A.body1.lineHeight)), G.Body2, s(O0 || (O0 = T([`
    font-size: `, `px;
    line-height: `, `px;
  `])), A.body2.fontSize, A.body2.lineHeight)), Hg = oe(oe({}, G.Body1, s(x0 || (x0 = T([`
    font-size: `, `px;
    line-height: `, `px;
  `])), A.code1.fontSize, A.code1.lineHeight)), G.Body2, s(j0 || (j0 = T([`
    font-size: `, `px;
    line-height: `, `px;
  `])), A.code2.fontSize, A.code2.lineHeight)), Jn = oe(oe({}, y.Light, s($0 || ($0 = T([`
    color: `, `;
  `])), l.black)), y.Dark, s(E0 || (E0 = T([`
    color: `, `;
  `])), l.gray.light2)), Ln = function(e) {
  var t = o1();
  return e ? e === 16 ? G.Body2 : G.Body1 : t === 16 ? G.Body2 : G.Body1;
}, Rg = ["baseFontSize", "darkMode", "className", "weight", "as"], Ag = be(function(e) {
  var t = e.baseFontSize, n = e.darkMode, r = e.className, u = e.weight, d = u === void 0 ? "regular" : u, p = e.as, v = p === void 0 ? "p" : p, g = qe(e, Rg), m = Q(n).theme, h = Ln(t), b = ye(v).Component, E = s(C0 || (C0 = T([`
      font-weight: `, `;
      strong,
      b {
        font-weight: `, `;
      }
    `])), ne[d], ne.bold);
  return w.createElement(b, He({ className: B(Mn, wf[h], Jn[m], E, r) }, g));
});
Ag.displayName = "Body";
var k0, M0, L0, Z0, P0, S0, N0, z0, H0, R0, Bg = { label: "lg-label", description: "lg-description" };
s(k0 || (k0 = T([`
  font-family: `, `;
  font-weight: `, `;
  margin-top: 0;
  margin-bottom: 0;
`])), se.default, ne.regular);
oe(oe({}, y.Light, s(M0 || (M0 = T([`
    color: `, `;
  `])), l.gray.dark1)), y.Dark, s(L0 || (L0 = T([`
    color: `, `;
  `])), l.gray.light1));
oe(oe({}, y.Light, s(Z0 || (Z0 = T([`
    color: `, `;
  `])), l.gray.base)), y.Dark, s(P0 || (P0 = T([`
    color: `, `;
  `])), l.gray.dark1));
oe(oe({}, G.Body1, s(S0 || (S0 = T([`
    font-size: `, `px;
    line-height: `, `px;
  `])), A.body1.fontSize, A.body1.lineHeight)), G.Body2, s(N0 || (N0 = T([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), A.body2.fontSize));
var A0, B0, D0, V0, T0;
oe(oe({}, y.Light, s(z0 || (z0 = T([`
    color: `, `;
  `])), l.gray.dark1)), y.Dark, s(H0 || (H0 = T([`
    color: `, `;
  `])), l.gray.light1));
s(R0 || (R0 = T([`
  display: block;
  font-size: 11px;
  line-height: 16px;
  letter-spacing: 0.2px;
`])));
var F0, I0, _0, G0, U0, W0, Dg = s(A0 || (A0 = T([`
  font-family: `, `;
  font-weight: `, `;
  font-size: inherit;
  line-height: inherit;

  // Unsets browser default margins
  margin-block-start: 0;
  margin-block-end: 0;
`])), se.default, ne.regular), Vg = oe(oe({}, y.Light, s(B0 || (B0 = T([`
    color: `, `;
  `])), l.red.base)), y.Dark, s(D0 || (D0 = T([`
    color: `, `;
  `])), l.red.light1)), Tg = oe(oe({}, G.Body1, s(V0 || (V0 = T([`
    font-size: `, `px;
    line-height: `, `px;
  `])), A.body1.fontSize, A.body1.lineHeight)), G.Body2, s(T0 || (T0 = T([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), A.body2.fontSize)), Fg = ["as", "darkMode", "children", "className"];
be(function(e) {
  var t = e.as, n = t === void 0 ? "p" : t, r = e.darkMode, u = e.children, d = e.className, p = qe(e, Fg), v = Q(r).theme, g = Ln(), m = ye(n).Component;
  return w.createElement(m, He({}, p, { className: B(Dg, Vg[v], Tg[g], d) }), u);
});
var Ig = s(F0 || (F0 = T([`
  font-weight: `, `;
  font-size: 48px;
  line-height: 62px;
  font-family: `, `;
`])), ne.regular, se.serif), _g = oe(oe({}, y.Light, s(I0 || (I0 = T([`
    color: `, `;
  `])), l.green.dark2)), y.Dark, s(_0 || (_0 = T([`
    color: `, `;
  `])), l.gray.light2)), Gg = ["darkMode", "className", "as"], Ug = be(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, u = r === void 0 ? "h1" : r, d = qe(e, Gg), p = Q(t).theme, v = ye(u).Component;
  return w.createElement(v, He({ className: B(Mn, Ig, _g[p], n) }, d));
});
Ug.displayName = "H1";
var Y0, Wg = s(G0 || (G0 = T([`
  font-size: 32px;
  line-height: 40px;
  font-weight: `, `;
  font-family: `, `;
`])), ne.regular, se.serif), Yg = oe(oe({}, y.Light, s(U0 || (U0 = T([`
    color: `, `;
  `])), l.green.dark2)), y.Dark, s(W0 || (W0 = T([`
    color: `, `;
  `])), l.gray.light2)), Xg = ["darkMode", "className", "as"], qg = be(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, u = r === void 0 ? "h2" : r, d = qe(e, Xg), p = Q(t).theme, v = ye(u).Component;
  return w.createElement(v, He({ className: B(Mn, Wg, Yg[p], n) }, d));
});
qg.displayName = "H2";
var X0, q0, K0, J0, Q0, ei, ni, ti, ri, ai, Kg = s(Y0 || (Y0 = T([`
  font-size: 24px;
  line-height: 32px;
  font-weight: `, `;
`])), ne.medium), Jg = ["darkMode", "className", "as"], Qg = be(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, u = r === void 0 ? "h3" : r, d = qe(e, Jg), p = Q(t).theme, v = ye(u).Component;
  return w.createElement(v, He({ className: B(Mn, Kg, Jn[p], n) }, d));
});
Qg.displayName = "H3";
var oi, li, ii, xn = Ae(), e6 = s(X0 || (X0 = T([`
  display: inline;
  transition: all 0.15s ease-in-out;
  border-radius: 3px;
  font-family: `, `;
  line-height: 20px;

  .`, `:hover > & {
    text-decoration: none;
  }
`])), se.code, xn), n6 = oe(oe({}, y.Light, s(q0 || (q0 = T([`
    background-color: `, `;
    border: 1px solid `, `;
    color: `, `;

    .`, `:hover > & {
      box-shadow: 0 0 0 3px `, `;
      border: 1px solid `, `;
    }
  `])), l.gray.light3, l.gray.light2, l.gray.dark3, xn, l.gray.light2, l.gray.light1)), y.Dark, s(K0 || (K0 = T([`
    background-color: transparent;
    border: 1px solid `, `;
    color: `, `;

    .`, `:hover > & {
      box-shadow: 0 0 0 3px `, `;
      border: 1px solid `, `;
    }
  `])), l.gray.dark2, l.gray.light1, xn, l.gray.dark2, l.gray.dark1)), t6 = oe(oe({}, y.Light, s(J0 || (J0 = T([`
    .`, `:focus-visible > & {
      box-shadow: `, `;
      border: 1px solid `, `;
    }
  `])), xn, We[y.Light].default, l.blue.base)), y.Dark, s(Q0 || (Q0 = T([`
    .`, `:focus-visible > & {
      box-shadow: `, `;
      border: 1px solid `, `;
    }
  `])), xn, We[y.Dark].default, l.blue.base)), r6 = oe(oe({}, y.Light, s(ei || (ei = T([`
    color: `, `;
  `])), l.blue.base)), y.Dark, s(ni || (ni = T([`
    color: `, `;
  `])), l.blue.light1)), a6 = s(ti || (ti = T([`
  text-decoration: none;
  margin: 0;
  padding: 0;
  line-height: 20px;

  &:focus {
    outline: none;
  }
`]))), o6 = s(ri || (ri = T([`
  white-space: nowrap;
`]))), l6 = s(ai || (ai = T([`
  white-space: normal;
`]))), i6 = ["children", "className", "darkMode", "baseFontSize", "as"], ci = Xe(function(e, t) {
  var n, r, u = e.children, d = e.className, p = e.darkMode, v = e.baseFontSize, g = e.as, m = qe(e, i6), h = Q(p).theme, b = Ln(v), E = sn(g, m, "code").Component, k = ((n = typeof u == "string" && ((r = u.match(/(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g)) === null || r === void 0 ? void 0 : r.length)) !== null && n !== void 0 ? n : 0) <= 30 ? o6 : l6, L = E !== "code", P = w.createElement("code", { ref: t, className: B(Hg[b], e6, n6[h], t6[h], k, oe({}, r6[h], L), d) }, u);
  return L ? w.createElement(E, He({ className: B(xn, a6, d) }, m), P) : w.cloneElement(P, m);
});
ci.displayName = "InlineCode", ci.propTypes = { children: fe.node, className: fe.string, darkMode: fe.bool, baseFontSize: fe.oneOf(Object.values(G)) };
var si, ui, fi, di, gi, hi, pi;
s(oi || (oi = T([`
  font-family: `, `;
  border: 1px solid;
  border-radius: 3px;
  padding-left: 5px;
  padding-right: 5px;
`])), se.code);
oe(oe({}, y.Light, s(li || (li = T([`
    color: `, `;
    border-color: `, `;
    background-color: `, `;
  `])), l.black, l.gray.dark3, l.white)), y.Dark, s(ii || (ii = T([`
    color: `, `;
    border-color: `, `;
    background-color: `, `;
  `])), l.gray.light2, l.gray.base, l.gray.dark3));
var vi, mi, bi, c6 = s(si || (si = T([`
  font-family: `, `;
  font-weight: `, `;
`])), se.default, ne.bold), s6 = oe(oe({}, y.Light, s(ui || (ui = T([`
    color: `, `;
  `])), l.black)), y.Dark, s(fi || (fi = T([`
    color: `, `;
  `])), l.gray.light2)), u6 = oe(oe({}, y.Light, s(di || (di = T([`
    color: `, `;
  `])), l.gray.base)), y.Dark, s(gi || (gi = T([`
    color: `, `;
  `])), l.gray.dark1)), f6 = oe(oe({}, G.Body1, s(hi || (hi = T([`
    font-size: `, `px;
    line-height: `, `px;
  `])), A.body1.fontSize, A.body1.lineHeight)), G.Body2, s(pi || (pi = T([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), A.body2.fontSize)), d6 = ["baseFontSize", "darkMode", "className", "children", "disabled", "as", "data-lgid"], g6 = be(function(e) {
  var t = e.baseFontSize, n = e.darkMode, r = e.className, u = e.children, d = e.disabled, p = d !== void 0 && d, v = e.as, g = v === void 0 ? "label" : v, m = e["data-lgid"], h = m === void 0 ? Bg.label : m, b = qe(e, d6), E = Q(n).theme, k = Ln(t), L = ye(g).Component;
  return w.createElement(L, He({ "data-lgid": h, className: B(c6, s6[E], f6[k], oe({}, u6[E], p), r) }, b), u);
});
g6.displayName = "Label";
var yi, wi, Oi, xi, ji, $i, Yn = Ae(), Of = s(vi || (vi = T([`
  font-family: `, `;
  display: inline;
  align-items: center;
  text-decoration: none;
  text-decoration-color: transparent;
  cursor: pointer;
  font-size: inherit;
  line-height: inherit;
  appearance: none;
  background: none;
  border: none;
  padding: 0;

  &:hover,
  &[data-hover='true'],
  &:focus,
  &[data-focus='true'] {
    text-decoration: underline;
    transition: text-decoration `, `ms ease-in-out;
    text-underline-offset: 4px;
    text-decoration-thickness: 2px;
  }

  &:focus {
    outline: none;
  }
`])), se.default, Ye.default), xf = oe(oe({}, y.Light, s(mi || (mi = T([`
    color: `, `;
    font-weight: `, `;

    &:hover,
    &[data-hover='true'] {
      text-decoration-color: `, `;
    }

    &:focus,
    &[data-focus='true'] {
      text-decoration-color: `, `;
    }
  `])), l.blue.base, ne.regular, l.gray.light2, l.blue.base)), y.Dark, s(bi || (bi = T([`
    color: `, `;
    font-weight: `, `;

    &:hover,
    &[data-hover='true'] {
      text-decoration-color: `, `;
    }

    &:focus,
    &[data-focus='true'] {
      text-decoration-color: `, `;
    }
  `])), l.blue.light1, ne.bold, l.gray.dark2, l.blue.base)), jf = function(e) {
  if (e)
    return wf[e];
}, h6 = s(yi || (yi = T([`
  gap: `, `px;
  display: inline-flex;
`])), he[100]), p6 = ["children", "className", "baseFontSize", "darkMode", "as"];
Xe(function(e, t) {
  var n = e.children, r = e.className, u = e.baseFontSize, d = e.darkMode, p = e.as, v = qe(e, p6), g = Q(d).theme, m = Ln(u), h = sn(p, v, "span").Component;
  return w.createElement(h, He({ className: B(Yn, Of, jf(m), xf[g], h6, r), ref: t }, v), w.createElement(Mg, { role: "presentation" }), n);
});
var v6 = s(wi || (wi = T([`
  transform: translate3d(3px, 0, 0);
  top: 1px;
  position: relative;
`]))), m6 = s(Oi || (Oi = T([`
  opacity: 0;
  transform: translate3d(-3px, 0, 0);
  transition: 100ms ease-in;
  transition-property: opacity, transform;
  top: 1px;
  position: relative;

  .`, ":hover &, .", `[data-hover='true'] & {
    opacity: 1;
    transform: translate3d(3px, 0, 0);
  }
`])), Yn, Yn), b6 = s(xi || (xi = T([`
  position: relative;
  bottom: 2px;
  left: -1px;
  height: 12px;
`]))), y6 = "hover", w6 = "persist", Ei = "none", O6 = ["children", "className", "arrowAppearance", "hideExternalIcon", "baseFontSize", "darkMode", "as"];
Xe(function(e, t) {
  var n = e.children, r = e.className, u = e.arrowAppearance, d = u === void 0 ? Ei : u, p = e.hideExternalIcon, v = p !== void 0 && p, g = e.baseFontSize, m = e.darkMode, h = e.as, b = qe(e, O6), E = zg(Ue(""), 2), k = E[0], L = E[1];
  Dn(function() {
    L(window.location.hostname);
  }, []);
  var P, R = Q(m).theme, Y = Ln(g), M = sn(h, b, "span").Component, a = En(function() {
    if (b.href !== void 0)
      return /^http(s)?:\/\//.test(b.href) ? new URL(b.href).hostname : k;
  }, [b, k]), i = { target: void 0, rel: void 0 };
  return b.target || b.rel ? (i.target = b.target, i.rel = b.rel) : M === "a" && (a === k ? i.target = "_self" : (i.target = "_blank", i.rel = "noopener noreferrer")), i.target !== "_blank" || v ? d !== Ei && (P = w.createElement(Zg, { role: "presentation", size: 12, className: B(oe(oe({}, m6, d === y6), v6, d === w6)) })) : P = w.createElement(Sg, { role: "presentation", className: b6 }), w.createElement(M, He({ className: B(Yn, Of, jf(Y), xf[R], r), ref: t }, i, b), w.createElement("span", null, n), P);
});
var x6 = s(ji || (ji = T([`
  font-size: 12px;
  font-weight: `, `;
  text-transform: uppercase;
  line-height: 20px;
  letter-spacing: 0.4px;
`])), ne.bold), j6 = ["darkMode", "className", "as"], $6 = be(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, u = r === void 0 ? "div" : r, d = qe(e, j6), p = Q(t).theme, v = ye(u).Component;
  return w.createElement(v, He({ className: B(Mn, x6, Jn[p], n) }, d));
});
$6.displayName = "Overline";
var E6 = s($i || ($i = T([`
  font-size: 18px;
  line-height: 24px;
  font-weight: `, `;
`])), ne.bold), C6 = ["darkMode", "className", "as"], k6 = be(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, u = r === void 0 ? "h6" : r, d = qe(e, C6), p = Q(t).theme, v = ye(u).Component;
  return w.createElement(v, He({ className: B(Mn, E6, Jn[p], n) }, d));
});
k6.displayName = "Subtitle";
var Ci;
s(Ci || (Ci = T([`
  flex: 1;
  min-width: 0;
  max-width: 100%;

  white-space: inherit;
  overflow: inherit;
  text-overflow: inherit;
`])));
function ki(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(u) {
      return Object.getOwnPropertyDescriptor(e, u).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Tn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ki(Object(n), !0).forEach(function(r) {
      ae(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ki(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function M6(e) {
  var t = function(n, r) {
    if (typeof n != "object" || !n)
      return n;
    var u = n[Symbol.toPrimitive];
    if (u !== void 0) {
      var d = u.call(n, r || "default");
      if (typeof d != "object")
        return d;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (r === "string" ? String : Number)(n);
  }(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function ae(e, t, n) {
  return (t = M6(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Rn() {
  return Rn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Rn.apply(this, arguments);
}
function Qn(e, t) {
  if (e == null)
    return {};
  var n, r, u = function(p, v) {
    if (p == null)
      return {};
    var g, m, h = {}, b = Object.keys(p);
    for (m = 0; m < b.length; m++)
      g = b[m], v.indexOf(g) >= 0 || (h[g] = p[g]);
    return h;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(e);
    for (r = 0; r < d.length; r++)
      n = d[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (u[n] = e[n]);
  }
  return u;
}
function U(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
function at(e, t) {
  return function(n) {
    if (Array.isArray(n))
      return n;
  }(e) || function(n, r) {
    var u = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
    if (u != null) {
      var d, p, v, g, m = [], h = !0, b = !1;
      try {
        if (v = (u = u.call(n)).next, r === 0) {
          if (Object(u) !== u)
            return;
          h = !1;
        } else
          for (; !(h = (d = v.call(u)).done) && (m.push(d.value), m.length !== r); h = !0)
            ;
      } catch (E) {
        b = !0, p = E;
      } finally {
        try {
          if (!h && u.return != null && (g = u.return(), Object(g) !== g))
            return;
        } finally {
          if (b)
            throw p;
        }
      }
      return m;
    }
  }(e, t) || function(n, r) {
    if (n) {
      if (typeof n == "string")
        return Mi(n, r);
      var u = Object.prototype.toString.call(n).slice(8, -1);
      if (u === "Object" && n.constructor && (u = n.constructor.name), u === "Map" || u === "Set")
        return Array.from(n);
      if (u === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(u))
        return Mi(n, r);
    }
  }(e, t) || function() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function Mi(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var Li, Zi, Pi, L6 = ["children"], $f = Tf({});
function Z6(e) {
  var t = e.children, n = Qn(e, L6);
  return w.createElement($f.Provider, { value: n }, t);
}
var Si, Ni, zi, Hi, Ri, Ai, Bi, Di, Vi, Ti, Fi, Ii, _i, Gi, Ui, Wi, Yi, Xi, qi, Ki, Ji, Qi, ec, nc, tc, rc, ac, oc, lc, ic, cc, sc, uc, fc, dc, gc, hc, pc, P6 = s(Li || (Li = U([`
  display: flex;
  align-items: center;
  gap: `, `px;
  font-style: italic;
  font-weight: 300;
  padding-block: `, `px;
`])), he[2], he[1]), S6 = ae(ae({}, y.Light, s(Zi || (Zi = U([`
    color: `, `;
  `])), l.gray.dark1)), y.Dark, s(Pi || (Pi = U([`
    color: `, `;
  `])), l.gray.light1)), N6 = function() {
  var e = Q().theme;
  return w.createElement(kn, { "aria-label": "No results found", isInteractive: !1, className: B(P6, S6[e]) }, w.createElement("span", null, "No results found"));
}, z6 = s(Si || (Si = U([`
  display: flex;
  align-items: center;
  gap: `, `px;
  padding-block: `, `px;
`])), he[2], he[1]), H6 = Af(Ni || (Ni = U([`
  from {
    transform: rotate(0deg);
  } 
  to {
    transform: rotate(360deg);
  }
`]))), R6 = s(zi || (zi = U([`
  height: 16px;
  width: 16px;
  animation: `, ` 1.5s linear infinite;
`])), H6), A6 = function() {
  var e = Q().darkMode;
  return w.createElement(kn, { "data-testid": "lg-search-input-loading-option", "aria-label": "Loading results", isInteractive: !1, className: z6 }, w.createElement(Cg, { color: e ? l.blue.light1 : l.blue.base, className: R6 }), w.createElement("span", null, "Loading results"));
}, B6 = s(Hi || (Hi = U([`
  box-shadow: 0px 4px 7px `, `;
  padding: 12px 0;
  border-radius: 12px;
`])), Ve(0.75, "#000000")), D6 = ae(ae({}, y.Light, s(Ri || (Ri = U([`
    background-color: `, `;
    border: 1px solid `, `;
  `])), l.white, l.gray.light2)), y.Dark, s(Ai || (Ai = U([`
    background-color: `, `;
    border: 1px solid `, `;
  `])), l.gray.dark3, l.gray.dark2)), V6 = s(Bi || (Bi = U([`
  padding: 0;
  margin: 0;
  border-radius: inherit;
  overflow-y: auto;
  scroll-behavior: smooth;
`]))), T6 = ["children", "open", "refEl", "usePortal", "portalClassName", "portalContainer", "scrollContainer", "footerSlot"], l1 = w.forwardRef(function(e, t) {
  var n = e.children, r = e.open, u = r !== void 0 && r, d = e.refEl, p = e.usePortal, v = e.portalClassName, g = e.portalContainer, m = e.scrollContainer, h = e.footerSlot, b = Qn(e, T6), E = Q().theme, k = Ff($f).state, L = En(function() {
    var Y, M;
    return (Y = (M = d.current) === null || M === void 0 ? void 0 : M.clientWidth) !== null && Y !== void 0 ? Y : 0;
  }, [d, u]), P = qf(d), R = en(P) ? "unset" : "".concat(Math.min(P, 256), "px");
  return w.createElement(Wf, { "data-testid": "lg-search-input-popover", spacing: he[2], active: u, align: "bottom", justify: "start", className: B(B6, D6[E], s(Di || (Di = U([`
            width: `, `px;
            min-width: `, `px;
          `])), L, L)), refEl: d, usePortal: p, portalClassName: p ? v : void 0, portalContainer: p ? g : null, scrollContainer: p ? m : null }, k === "loading" ? w.createElement(A6, null) : w.createElement(w.Fragment, null, w.createElement("ul", Rn({ role: "listbox", "aria-live": "polite", "aria-relevant": "additions removals", "aria-expanded": u, ref: t, className: B(V6, s(Vi || (Vi = U([`
                  max-height: `, `;
                `])), R)) }, b), w.Children.count(n) ? n : w.createElement(N6, null)), h));
});
l1.displayName = "SearchResultsMenu";
var vc, mc, bc, yc, wc, Oc, hn = function(e) {
  return "0 0 0 100px ".concat(e, " inset");
}, F6 = s(Ti || (Ti = U([`
  outline: none;
`]))), I6 = s(Fi || (Fi = U([`
  position: relative;
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  justify-items: center;
  border: 1px solid;
  border-radius: 6px;
  z-index: 0;
  transition: `, `ms ease-in-out;
  transition-property: border-color, box-shadow;
`])), Ye.default), _6 = ae(ae(ae(ae({}, ze.XSmall, s(Ii || (Ii = U([`
    font-size: `, `px;
    line-height: `, `px;
    height: 22px;
    grid-template-columns: 28px 1fr 36px;
  `])), A.body1.fontSize, A.body1.lineHeight)), ze.Small, s(_i || (_i = U([`
    font-size: `, `px;
    line-height: `, `px;
    height: 28px;
    grid-template-columns: 32px 1fr 36px;
  `])), A.body1.fontSize, A.body1.lineHeight)), ze.Default, s(Gi || (Gi = U([`
    font-size: `, `px;
    line-height: `, `px;
    height: 36px;
    grid-template-columns: 36px 1fr 36px;
  `])), A.body1.fontSize, A.body1.lineHeight)), ze.Large, s(Ui || (Ui = U([`
    font-size: `, `px;
    line-height: `, `px;
    height: 48px;
    grid-template-columns: 36px 1fr 44px;
  `])), A.large.fontSize, A.large.lineHeight)), G6 = ae(ae({}, y.Light, s(Wi || (Wi = U([`
    color: `, `;
    background: `, `;
    border-color: `, `;
  `])), l.black, l.white, l.gray.base)), y.Dark, s(Yi || (Yi = U([`
    color: `, `;
    background-color: `, `;
    border-color: `, `;
  `])), l.gray.light2, l.gray.dark4, l.gray.base)), U6 = ae(ae({}, y.Light, s(Xi || (Xi = U([`
    &:hover,
    &:active {
      &:not(:disabled):not(:focus-within) {
        box-shadow: `, `;
      }
    }
  `])), In.light.gray)), y.Dark, s(qi || (qi = U([`
    &:hover,
    &:active {
      &:not(:disabled):not(:focus-within) {
        box-shadow: `, `;
      }
    }
  `])), In.dark.gray)), W6 = ae(ae({}, y.Light, s(Ki || (Ki = U([`
    &:not(:disabled):focus-within {
      box-shadow: `, `;
      border-color: `, `;
    }
  `])), We.light.input, l.white)), y.Dark, s(Ji || (Ji = U([`
    &:not(:disabled):focus-within {
      box-shadow: `, `;
      border-color: `, `;
    }
  `])), We.dark.input, l.gray.dark4)), Y6 = ae(ae({}, y.Light, s(Qi || (Qi = U([`
    cursor: not-allowed;
    color: `, `;
    background-color: `, `;
    border-color: `, `;
  `])), l.gray.base, l.gray.light2, l.gray.light1)), y.Dark, s(ec || (ec = U([`
    cursor: not-allowed;
    color: `, `;
    background-color: `, `;
    border-color: `, `;
  `])), l.gray.dark2, l.gray.dark3, l.gray.dark2)), X6 = s(nc || (nc = U([`
  font-size: inherit;
  line-height: inherit;
  color: inherit;
  background-color: inherit;
  font-family: `, `;
  width: 100%;
  height: 1.5em;
  font-weight: `, `;
  z-index: 1;
  outline: none;
  border: none;
  padding: 0;

  &[aria-disabled='true'] {
    cursor: not-allowed;

    &:hover,
    &:active {
      box-shadow: none;
    }
  }

  &::placeholder {
    font-size: inherit;
    line-height: inherit;
  }
  &::-ms-clear,
  &::-ms-reveal {
    display: none;
    width: 0;
    height: 0;
  }
  &::-webkit-search-decoration,
  &::-webkit-search-cancel-button,
  &::-webkit-search-results-button,
  &::-webkit-search-results-decoration {
    display: none;
  }
`])), se.default, ne.regular), q6 = ae(ae({}, y.Light, s(tc || (tc = U([`
    &:-webkit-autofill {
      color: inherit;
      background: transparent;
      border: none;
      -webkit-text-fill-color: inherit;

      &[aria-disabled='false'] {
        box-shadow: `, `;

        &:focus {
          box-shadow: `, `,
            `, `;
        }

        &:hover:not(:focus) {
          box-shadow: `, `,
            `, `;
        }
      }
    }

    &::placeholder {
      color: `, `;
      font-weight: `, `;
    }

    &[aria-disabled='true'] {
      &::placeholder {
        color: `, `;
      }

      &:-webkit-autofill {
        &,
        &:hover,
        &:focus {
          appearance: none;
          border: 1px solid `, `;
          -webkit-text-fill-color: `, `;
          box-shadow: `, `;
        }
      }
    }
  `])), hn(l.white), hn(l.white), We.light.input, hn(l.white), In.light.gray, l.gray.base, ne.regular, l.gray.base, l.gray.base, l.gray.base, hn(l.gray.light2))), y.Dark, s(rc || (rc = U([`
    &:-webkit-autofill {
      color: inherit;
      background: transparent;
      border: none;
      -webkit-text-fill-color: `, `;
      &[aria-disabled='false'] {
        box-shadow: `, `;

        &:focus {
          box-shadow: `, `,
            `, `;
          border-color: `, `;
        }

        &:hover:not(:focus) {
          box-shadow: `, `,
            `, `;
        }
      }
    }

    &::placeholder {
      color: `, `;
      font-weight: `, `;
    }

    &[aria-disabled='true'] {
      &::placeholder {
        color: `, `;
      }

      &:-webkit-autofill {
        &,
        &:hover,
        &:focus {
          appearance: none;
          border: 1px solid `, `;
          -webkit-text-fill-color: `, `;
          box-shadow: `, `;
        }
      }
    }
  `])), l.gray.light3, hn(l.gray.dark4), hn(l.gray.dark4), We.dark.input, l.blue.light1, hn(l.gray.dark4), In.dark.gray, l.gray.dark1, ne.regular, l.gray.dark1, l.gray.dark1, l.gray.dark1, hn(l.gray.dark2))), K6 = ae(ae({}, y.Light, s(ac || (ac = U([`
    color: `, `;
  `])), l.gray.dark1)), y.Dark, s(oc || (oc = U([`
    color: `, `;
  `])), l.gray.light1)), J6 = ae(ae(ae(ae({}, ze.XSmall, s(lc || (lc = U([`
    margin-left: 2px;
  `])))), ze.Small, s(ic || (ic = U([`
    margin-left: 0px;
  `])))), ze.Default, s(cc || (cc = U([`
    margin-left: 8px;
  `])))), ze.Large, s(sc || (sc = U([`
    margin-left: 8px;
  `])))), Q6 = ae(ae({}, y.Light, s(uc || (uc = U([`
    color: `, `;
  `])), l.gray.base)), y.Dark, s(fc || (fc = U([`
    color: `, `;
  `])), l.gray.dark1)), eh = ae(ae(ae(ae({}, ze.XSmall, s(dc || (dc = U([`
    height: 22px;
    width: 22px;
  `])))), ze.Small, s(gc || (gc = U([`
    height: 28px;
    width: 28px;
  `])))), ze.Default, s(hc || (hc = U([`
    height: 28px;
    width: 28px;
  `])))), ze.Large, s(pc || (pc = U([`
    height: 28px;
    width: 28px;
  `])))), nh = { Unset: "unset", Loading: "loading" }, th = ["placeholder", "className", "darkMode", "size", "disabled", "children", "state", "value", "onChange", "onSubmit", "aria-label", "aria-labelledby"], rh = w.forwardRef(function(e, t) {
  var n = e.placeholder, r = n === void 0 ? "Search" : n, u = e.className, d = e.darkMode, p = e.size, v = p === void 0 ? ze.Default : p, g = e.disabled, m = e.children, h = e.state, b = h === void 0 ? nh.Unset : h, E = e.value, k = e.onChange, L = e.onSubmit, P = e["aria-label"], R = e["aria-labelledby"], Y = Qn(e, th), M = Q(d), a = M.theme, i = M.darkMode, o = at(Ue(!1), 2), f = o[0], j = o[1], x = at(Ue(0), 2), Z = x[0], N = x[1], O = function() {
    return j(!1);
  }, $ = function() {
    return j(!0);
  }, H = ln(null), z = ln(null), ie = ln(null), X = U3(t, null), ee = ln(null), re = W3({ prefix: "result" }), I = at(Ue(), 2), q = I[0], K = I[1], J = re("".concat(Z)), W = !en(m), un = Kf(E, k), Be = un.value, Je = un.handleChange, nn = _n(function(ue) {
    X.current && (X.current.value = ue, Je(Jf(new Event("change", { cancelable: !0, bubbles: !0 }), X.current)));
  }, [Je, X]), fn = _n(function() {
    var ue = 0, ve = w.Children.map(m, function je($e) {
      if (Gn($e, "SearchResult")) {
        var ce, Oe = (ue += 1) - 1, Se = qn($e);
        return w.cloneElement($e, Tn(Tn({}, $e.props), {}, { id: "result-".concat(Oe), key: "result-".concat(Oe), ref: (ce = $e.props.ref) !== null && ce !== void 0 ? ce : re == null ? void 0 : re("".concat(Oe)), highlighted: Oe === Z, onClick: function(Qe) {
          var De, gn;
          if ((De = (gn = $e.props).onClick) === null || De === void 0 || De.call(gn, Qe), nn(Se), Qe.detail >= 1 && H.current && X.current) {
            var rn, pn = new Event("submit", { cancelable: !0, bubbles: !0 });
            (rn = H.current) === null || rn === void 0 || rn.dispatchEvent(pn);
          }
        } }));
      }
      if (Gn($e, "SearchResultGroup")) {
        var xe = w.Children.map($e.props.children, je);
        if (xe && xe.length > 0)
          return w.cloneElement($e, Tn(Tn({}, $e.props), {}, { children: xe }));
      }
    });
    return { resultsCount: ue, updatedChildren: ve };
  }, [m, Z, X, re, nn]), tn = En(function() {
    return fn();
  }, [fn]), bn = tn.updatedChildren, dn = tn.resultsCount, _ = function(ue) {
    switch (ue) {
      case "first":
        N(0);
        break;
      case "last":
        N(dn);
        break;
      case "next":
        var ve = !en(Z) && Z + 1 < dn ? Z + 1 : 0;
        N(ve);
        break;
      case "prev":
        var je = !en(Z) && Z - 1 >= 0 ? Z - 1 : dn - 1;
        N(je);
    }
  };
  return Y3(J, ie, 12), X3(function() {
    O();
  }, [z, ie], f && W), w.createElement(q3, { darkMode: i }, w.createElement(Z6, { state: b, highlight: Z, resultDynamicRefs: re }, w.createElement("form", Rn({ role: "search", ref: H, className: B(F6, u), onSubmit: function(ue) {
    ue.preventDefault(), L == null || L(ue), W && (O(), nn(""));
  } }, Y), w.createElement("div", { ref: z, role: "searchbox", tabIndex: -1, onMouseDown: function(ue) {
    g && ue.preventDefault();
  }, onClick: function(ue) {
    (function(ve) {
      g ? (ve.preventDefault(), ve.stopPropagation()) : $();
    })(ue);
  }, onFocus: function(ue) {
    var ve, je = ue.target, $e = je === ee.current ? ee.current : (ve = X.current) !== null && ve !== void 0 ? ve : je;
    $e.focus(), K($e);
  }, onKeyDown: function(ue) {
    var ve, je, $e = (ve = ie.current) === null || ve === void 0 ? void 0 : ve.contains(document.activeElement);
    if ((!((je = z.current) === null || je === void 0) && je.contains(document.activeElement) || $e) && !g)
      switch (ue.key) {
        case Nn.Enter:
          var ce;
          J == null || (ce = J.current) === null || ce === void 0 || ce.click();
          break;
        case Nn.Escape:
          var Oe;
          O(), (Oe = X.current) === null || Oe === void 0 || Oe.focus();
          break;
        case Nn.ArrowDown:
          var Se;
          W && ((Se = X.current) === null || Se === void 0 || Se.focus(), $(), ue.preventDefault(), _("next"));
          break;
        case Nn.ArrowUp:
          var xe;
          W && ((xe = X.current) === null || xe === void 0 || xe.focus(), $(), ue.preventDefault(), _("prev"));
          break;
        case Nn.Tab:
          f && O();
          break;
        default:
          W && $();
      }
  }, className: B(I6, _6[v], G6[a], ae(ae(ae({}, W6[a], q === X.current), Y6[a], g), U6[a], !g)), "aria-label": R ? void 0 : P, "aria-labelledby": R }, w.createElement(J4, { className: B(K6[a], J6[v], ae({}, Q6[a], g)), role: "presentation" }), w.createElement("input", { type: "search", className: B(X6, q6[a]), value: Be, onChange: function(ue) {
    Je == null || Je(ue);
  }, placeholder: r, ref: X, readOnly: g, "aria-disabled": g }), Be && w.createElement(Uf, { ref: ee, type: "button", "aria-label": "Clear search", onClick: function(ue) {
    var ve;
    ue.stopPropagation(), nn(""), X == null || (ve = X.current) === null || ve === void 0 || ve.focus();
  }, className: eh[v], tabIndex: g ? -1 : 0, disabled: g }, w.createElement(ed, null))), W && w.createElement(l1, { open: f, refEl: z, ref: ie }, bn))));
});
rh.displayName = "SearchInput";
var xc, jc, $c, jn = Ae("search-result-title"), An = Ae("search-result-description"), ah = s(vc || (vc = U([`
  display: block;
  font-family: `, `;
  font-size: `, `px;
  line-height: `, `px;
  padding: `, "px ", `px;

  & .`, ` {
    font-weight: `, `;
  }
`])), se.default, A.body1.fontSize, he[3], he[1], he[3], jn, ne.bold), oh = ae(ae({}, y.Light, s(mc || (mc = U([`
    & .`, ` {
      color: `, `;
    }
    & .`, ` {
      color: `, `;
    }
  `])), jn, l.black, An, l.gray.dark1)), y.Dark, s(bc || (bc = U([`
    & .`, ` {
      color: `, `;
    }
    & .`, ` {
      color: `, `;
    }
  `])), jn, l.gray.light2, An, l.gray.light1)), lh = ae(ae({}, y.Light, s(yc || (yc = U([`
    & .`, ` {
      color: `, `;
    }
    & .`, ` {
      color: `, `;
    }
  `])), jn, l.gray.light1, An, l.gray.light1)), y.Dark, s(wc || (wc = U([`
    & .`, ` {
      color: `, `;
    }
    & .`, ` {
      color: `, `;
    }
  `])), jn, l.gray.dark1, An, l.gray.dark1)), ih = s(Oc || (Oc = U([`
  max-height: `, `px;
  overflow: hidden;
  text-overflow: ellipsis;
`])), 3 * he[3]), ch = ["as", "children", "description", "disabled", "className", "darkMode"], sh = Xe(function(e, t) {
  var n, r = e.as, u = r === void 0 ? "li" : r, d = e.children, p = e.description, v = e.disabled, g = e.className, m = e.darkMode, h = Qn(e, ch), b = Q(m).theme, E = qn(d), k = (n = h["aria-label"]) !== null && n !== void 0 ? n : h["aria-labelledby"] ? "" : E;
  return w.createElement(kn, Rn({}, h, { as: u, ref: t, className: B(ah, oh[b], ae({}, lh[b], v), g), disabled: v, "aria-labelledby": h["aria-labelledby"], "aria-label": k }), w.createElement("div", { className: jn }, d), p && w.createElement("div", { className: B(An, ih) }, p));
}, "SearchResult");
sh.displayName = "SearchResult";
s(xc || (xc = U([`
  padding-top: 12px;
  padding-bottom: 0;
`])));
ae(ae({}, y.Light, s(jc || (jc = U([`
    color: `, `;
  `])), l.gray.dark1)), y.Dark, s($c || ($c = U([`
    color: `, `;
  `])), l.gray.base));
function uh(e) {
  var t = function(n, r) {
    if (typeof n != "object" || !n)
      return n;
    var u = n[Symbol.toPrimitive];
    if (u !== void 0) {
      var d = u.call(n, r || "default");
      if (typeof d != "object")
        return d;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (r === "string" ? String : Number)(n);
  }(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function wn(e, t, n) {
  return (t = uh(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function ut() {
  return ut = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ut.apply(this, arguments);
}
function Ef(e, t) {
  if (e == null)
    return {};
  var n, r, u = function(p, v) {
    if (p == null)
      return {};
    var g, m, h = {}, b = Object.keys(p);
    for (m = 0; m < b.length; m++)
      g = b[m], v.indexOf(g) >= 0 || (h[g] = p[g]);
    return h;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(e);
    for (r = 0; r < d.length; r++)
      n = d[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (u[n] = e[n]);
  }
  return u;
}
var Ec, ft = { Small: "small", Default: "default", Large: "large", XLarge: "xlarge" }, fh = { small: 14, default: 16, large: 20, xlarge: 24 }, dh = ["className", "size", "fill", "title", "aria-labelledby", "aria-label", "role"];
function i1(e, t) {
  var n = function(r) {
    var u, d, p = r.className, v = r.size, g = v === void 0 ? ft.Default : v, m = r.fill, h = r.title, b = r["aria-labelledby"], E = r["aria-label"], k = r.role, L = k === void 0 ? "img" : k, P = Ef(r, dh), R = s(Ec || (u = [`
      color: `, `;
    `], d || (d = u.slice(0)), Ec = Object.freeze(Object.defineProperties(u, { raw: { value: Object.freeze(d) } }))), m), Y = typeof g == "number" ? g : fh[g];
    return L !== "img" && L !== "presentation" && console.warn("Please provide a valid role to this component. Valid options are 'img' and 'presentation'. If you'd like the Icon to be accessible to screen readers please use 'img', otherwise set the role to 'presentation'."), w.createElement(t, ut({ className: B(wn({}, R, m != null), p), height: Y, width: Y, role: L }, function(M, a, i) {
      var o, f = i["aria-label"], j = i["aria-labelledby"], x = i.title;
      switch (M) {
        case "img":
          return f || j || x ? wn(wn(wn({}, "aria-labelledby", j), "aria-label", f), "title", x) : { "aria-label": (o = a, "".concat(o.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
        case "presentation":
          return { "aria-hidden": !0, alt: "" };
      }
    }(L, e, wn(wn({ title: h }, "aria-label", E), "aria-labelledby", b)), P));
  };
  return n.displayName = e, n.isGlyph = !0, n.propTypes = { fill: fe.string, size: fe.oneOfType([fe.oneOf(Object.values(ft)), fe.number]), className: fe.string }, n;
}
var Cc, gh = ["glyph"];
function hh(e) {
  var t = function(n) {
    var r = n.glyph, u = Ef(n, gh), d = e[r];
    if (d)
      return w.createElement(d, u);
    var p = Object.keys(e).find(function(v) {
      return f1(v) === f1(r);
    });
    return console.error("Error in Icon", 'Could not find glyph named "'.concat(r, '" in the icon set.'), p && 'Did you mean "'.concat(p, '?"')), w.createElement(w.Fragment, null);
  };
  return t.displayName = "Icon", t.isGlyph = !0, t.propTypes = { glyph: fe.oneOf(Object.keys(e)).isRequired, size: fe.oneOfType([fe.oneOf(Object.values(ft)), fe.number]) }, t;
}
function dt() {
  return dt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, dt.apply(this, arguments);
}
var kc;
function gt() {
  return gt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, gt.apply(this, arguments);
}
var Mc;
function ht() {
  return ht = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ht.apply(this, arguments);
}
var Lc;
function pt() {
  return pt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, pt.apply(this, arguments);
}
var Zc;
function vt() {
  return vt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, vt.apply(this, arguments);
}
var Pc;
function mt() {
  return mt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, mt.apply(this, arguments);
}
var Sc;
function bt() {
  return bt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, bt.apply(this, arguments);
}
var Nc;
function yt() {
  return yt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, yt.apply(this, arguments);
}
var zc;
function wt() {
  return wt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, wt.apply(this, arguments);
}
var Hc;
function Ot() {
  return Ot = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ot.apply(this, arguments);
}
var Rc;
function xt() {
  return xt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, xt.apply(this, arguments);
}
var Ac;
function jt() {
  return jt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, jt.apply(this, arguments);
}
var Bc;
function $t() {
  return $t = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, $t.apply(this, arguments);
}
var Dc;
function Et() {
  return Et = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Et.apply(this, arguments);
}
var Vc, Tc;
function Ct() {
  return Ct = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ct.apply(this, arguments);
}
var Fc, Ic, _c;
function kt() {
  return kt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, kt.apply(this, arguments);
}
var Gc, Uc;
function Mt() {
  return Mt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Mt.apply(this, arguments);
}
var Wc, Yc;
function Lt() {
  return Lt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Lt.apply(this, arguments);
}
var Xc;
function Zt() {
  return Zt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Zt.apply(this, arguments);
}
var qc;
function Pt() {
  return Pt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Pt.apply(this, arguments);
}
var Kc;
function St() {
  return St = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, St.apply(this, arguments);
}
var Jc;
function Nt() {
  return Nt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Nt.apply(this, arguments);
}
var Qc;
function zt() {
  return zt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, zt.apply(this, arguments);
}
var es;
function Ht() {
  return Ht = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ht.apply(this, arguments);
}
var ns;
function Rt() {
  return Rt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Rt.apply(this, arguments);
}
var ts;
function At() {
  return At = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, At.apply(this, arguments);
}
var rs;
function Bt() {
  return Bt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Bt.apply(this, arguments);
}
var as;
function Dt() {
  return Dt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Dt.apply(this, arguments);
}
var os;
function Vt() {
  return Vt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Vt.apply(this, arguments);
}
var ls;
function Tt() {
  return Tt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Tt.apply(this, arguments);
}
var is;
function Ft() {
  return Ft = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ft.apply(this, arguments);
}
var cs, ss;
function It() {
  return It = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, It.apply(this, arguments);
}
var us, fs;
function _t() {
  return _t = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, _t.apply(this, arguments);
}
var ds;
function Gt() {
  return Gt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Gt.apply(this, arguments);
}
var gs;
function Ut() {
  return Ut = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ut.apply(this, arguments);
}
var hs, ps;
function Wt() {
  return Wt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Wt.apply(this, arguments);
}
var vs;
function Yt() {
  return Yt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Yt.apply(this, arguments);
}
var ms;
function Xt() {
  return Xt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Xt.apply(this, arguments);
}
var bs;
function qt() {
  return qt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, qt.apply(this, arguments);
}
var ys;
function Kt() {
  return Kt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Kt.apply(this, arguments);
}
var ws;
function Jt() {
  return Jt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Jt.apply(this, arguments);
}
var Os;
function Qt() {
  return Qt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Qt.apply(this, arguments);
}
var xs;
function er() {
  return er = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, er.apply(this, arguments);
}
var js, $s, Es;
function nr() {
  return nr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, nr.apply(this, arguments);
}
var Cs;
function tr() {
  return tr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, tr.apply(this, arguments);
}
var ks;
function rr() {
  return rr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, rr.apply(this, arguments);
}
var Ms;
function ar() {
  return ar = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ar.apply(this, arguments);
}
var Ls;
function or() {
  return or = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, or.apply(this, arguments);
}
var Zs;
function lr() {
  return lr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, lr.apply(this, arguments);
}
var Ps;
function ir() {
  return ir = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ir.apply(this, arguments);
}
var Ss;
function cr() {
  return cr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, cr.apply(this, arguments);
}
var Ns;
function sr() {
  return sr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, sr.apply(this, arguments);
}
var zs, Hs;
function ur() {
  return ur = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ur.apply(this, arguments);
}
var Rs;
function fr() {
  return fr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, fr.apply(this, arguments);
}
var As, Bs;
function dr() {
  return dr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, dr.apply(this, arguments);
}
var Ds;
function gr() {
  return gr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, gr.apply(this, arguments);
}
var Vs;
function hr() {
  return hr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, hr.apply(this, arguments);
}
var Ts, Fs;
function pr() {
  return pr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, pr.apply(this, arguments);
}
var Is;
function vr() {
  return vr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, vr.apply(this, arguments);
}
var _s;
function mr() {
  return mr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, mr.apply(this, arguments);
}
var Gs;
function br() {
  return br = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, br.apply(this, arguments);
}
var Us;
function yr() {
  return yr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, yr.apply(this, arguments);
}
var Ws;
function wr() {
  return wr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, wr.apply(this, arguments);
}
var Ys;
function Or() {
  return Or = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Or.apply(this, arguments);
}
var Xs, qs;
function xr() {
  return xr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, xr.apply(this, arguments);
}
var Ks;
function jr() {
  return jr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, jr.apply(this, arguments);
}
var Js;
function $r() {
  return $r = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, $r.apply(this, arguments);
}
var Qs, e2;
function Er() {
  return Er = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Er.apply(this, arguments);
}
var n2;
function Cr() {
  return Cr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Cr.apply(this, arguments);
}
var t2, r2;
function kr() {
  return kr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, kr.apply(this, arguments);
}
var a2;
function Mr() {
  return Mr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Mr.apply(this, arguments);
}
var o2;
function Lr() {
  return Lr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Lr.apply(this, arguments);
}
var l2, i2;
function Zr() {
  return Zr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Zr.apply(this, arguments);
}
var c2, s2;
function Pr() {
  return Pr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Pr.apply(this, arguments);
}
var u2;
function Sr() {
  return Sr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Sr.apply(this, arguments);
}
var f2, d2;
function Nr() {
  return Nr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Nr.apply(this, arguments);
}
var g2;
function zr() {
  return zr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, zr.apply(this, arguments);
}
var h2, p2;
function Hr() {
  return Hr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Hr.apply(this, arguments);
}
var v2;
function Rr() {
  return Rr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Rr.apply(this, arguments);
}
var m2;
function Ar() {
  return Ar = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ar.apply(this, arguments);
}
var b2, y2;
function Br() {
  return Br = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Br.apply(this, arguments);
}
var w2, O2;
function Dr() {
  return Dr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Dr.apply(this, arguments);
}
var x2;
function Vr() {
  return Vr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Vr.apply(this, arguments);
}
var j2;
function Tr() {
  return Tr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Tr.apply(this, arguments);
}
var $2;
function Fr() {
  return Fr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Fr.apply(this, arguments);
}
var E2;
function Ir() {
  return Ir = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ir.apply(this, arguments);
}
var C2;
function _r() {
  return _r = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, _r.apply(this, arguments);
}
var k2, M2;
function Gr() {
  return Gr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Gr.apply(this, arguments);
}
var L2;
function Ur() {
  return Ur = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ur.apply(this, arguments);
}
var Z2, P2;
function Wr() {
  return Wr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Wr.apply(this, arguments);
}
var S2, N2;
function Yr() {
  return Yr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Yr.apply(this, arguments);
}
var z2;
function Xr() {
  return Xr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Xr.apply(this, arguments);
}
var H2;
function qr() {
  return qr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, qr.apply(this, arguments);
}
var R2, A2;
function Kr() {
  return Kr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Kr.apply(this, arguments);
}
var B2, D2;
function Jr() {
  return Jr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Jr.apply(this, arguments);
}
var V2;
function Qr() {
  return Qr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Qr.apply(this, arguments);
}
var T2, F2;
function ea() {
  return ea = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ea.apply(this, arguments);
}
var I2;
function na() {
  return na = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, na.apply(this, arguments);
}
var _2, G2;
function ta() {
  return ta = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ta.apply(this, arguments);
}
var U2;
function ra() {
  return ra = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ra.apply(this, arguments);
}
var W2;
function aa() {
  return aa = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, aa.apply(this, arguments);
}
var Y2;
function oa() {
  return oa = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, oa.apply(this, arguments);
}
var X2;
function la() {
  return la = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, la.apply(this, arguments);
}
var q2;
function ia() {
  return ia = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ia.apply(this, arguments);
}
var K2, J2;
function ca() {
  return ca = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ca.apply(this, arguments);
}
var Q2;
function sa() {
  return sa = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, sa.apply(this, arguments);
}
var e5, n5;
function ua() {
  return ua = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ua.apply(this, arguments);
}
var t5, r5;
function fa() {
  return fa = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, fa.apply(this, arguments);
}
var a5;
function da() {
  return da = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, da.apply(this, arguments);
}
var o5;
function ga() {
  return ga = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ga.apply(this, arguments);
}
var l5;
function ha() {
  return ha = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ha.apply(this, arguments);
}
var i5;
function pa() {
  return pa = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, pa.apply(this, arguments);
}
var c5;
function va() {
  return va = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, va.apply(this, arguments);
}
var s5;
function ma() {
  return ma = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ma.apply(this, arguments);
}
var u5, f5;
function ba() {
  return ba = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ba.apply(this, arguments);
}
var d5, g5, h5;
function ya() {
  return ya = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ya.apply(this, arguments);
}
var p5, v5;
function wa() {
  return wa = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, wa.apply(this, arguments);
}
var m5;
function Oa() {
  return Oa = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Oa.apply(this, arguments);
}
var b5;
function xa() {
  return xa = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, xa.apply(this, arguments);
}
var y5;
function ja() {
  return ja = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ja.apply(this, arguments);
}
var w5;
function $a() {
  return $a = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, $a.apply(this, arguments);
}
var O5;
function Ea() {
  return Ea = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ea.apply(this, arguments);
}
var x5;
function Ca() {
  return Ca = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ca.apply(this, arguments);
}
var j5;
function ka() {
  return ka = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ka.apply(this, arguments);
}
var $5;
function Ma() {
  return Ma = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ma.apply(this, arguments);
}
var E5;
function La() {
  return La = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, La.apply(this, arguments);
}
var C5;
function Za() {
  return Za = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Za.apply(this, arguments);
}
var k5;
function Pa() {
  return Pa = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Pa.apply(this, arguments);
}
var M5;
function Sa() {
  return Sa = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Sa.apply(this, arguments);
}
var L5;
function Na() {
  return Na = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Na.apply(this, arguments);
}
var Z5;
function za() {
  return za = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, za.apply(this, arguments);
}
var P5;
function Ha() {
  return Ha = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ha.apply(this, arguments);
}
var S5;
function Ra() {
  return Ra = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ra.apply(this, arguments);
}
var N5;
function Aa() {
  return Aa = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Aa.apply(this, arguments);
}
var z5;
function Ba() {
  return Ba = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ba.apply(this, arguments);
}
var H5;
function Da() {
  return Da = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Da.apply(this, arguments);
}
var R5, A5, B5;
function Va() {
  return Va = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Va.apply(this, arguments);
}
var D5;
function Ta() {
  return Ta = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ta.apply(this, arguments);
}
var V5;
function Fa() {
  return Fa = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Fa.apply(this, arguments);
}
var T5;
function Ia() {
  return Ia = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ia.apply(this, arguments);
}
var F5;
function _a() {
  return _a = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, _a.apply(this, arguments);
}
var I5;
function Ga() {
  return Ga = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ga.apply(this, arguments);
}
var _5;
function Ua() {
  return Ua = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ua.apply(this, arguments);
}
var G5;
function Wa() {
  return Wa = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Wa.apply(this, arguments);
}
var U5;
function Ya() {
  return Ya = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ya.apply(this, arguments);
}
var W5;
function Xa() {
  return Xa = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Xa.apply(this, arguments);
}
var Y5;
function qa() {
  return qa = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, qa.apply(this, arguments);
}
var X5;
function Ka() {
  return Ka = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ka.apply(this, arguments);
}
var q5;
function Ja() {
  return Ja = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ja.apply(this, arguments);
}
var K5;
function Qa() {
  return Qa = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Qa.apply(this, arguments);
}
var J5, Q5;
function e1() {
  return e1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, e1.apply(this, arguments);
}
var eu;
function n1() {
  return n1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, n1.apply(this, arguments);
}
var nu;
function t1() {
  return t1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, t1.apply(this, arguments);
}
var tu = { ActivityFeed: function(e) {
  return c.createElement("svg", dt({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Cc || (Cc = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1 13V7h4.5A1.5 1.5 0 0 0 7 5.5V1h2a2 2 0 0 1 2 2v4.515a2.5 2.5 0 0 0-2.612 1.602l-1.06 2.808A2.501 2.501 0 0 0 5.59 15H3a2 2 0 0 1-2-2ZM4.914 1h.92v3.833a1 1 0 0 1-1 1H1v-.919a1 1 0 0 1 .293-.707L2.5 3l1.707-1.707A1 1 0 0 1 4.914 1ZM10.8 9.003a1 1 0 0 1 .904.784l.61 2.792.508-.714a1 1 0 0 1 .814-.42H15a1 1 0 0 1 0 2h-.848l-1.519 2.135a1 1 0 0 1-1.792-.367l-.371-1.701-.444 1.175a1 1 0 0 1-.935.646H8a1 1 0 1 1 0-2h.4l1.392-3.686a1 1 0 0 1 1.008-.644Z", clipRule: "evenodd" })));
}, AddFile: function(e) {
  return c.createElement("svg", gt({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), kc || (kc = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1 7v6a2 2 0 0 0 2 2h5.968a2.25 2.25 0 0 1 .794-4.238A2.251 2.251 0 0 1 11 8.984V3a2 2 0 0 0-2-2H7v4.5A1.5 1.5 0 0 1 5.5 7H1Zm8 6a1 1 0 0 0 1 1h1v1a1 1 0 1 0 2 0v-1h1a1 1 0 1 0 0-2h-1v-1a1 1 0 1 0-2 0v1h-1a1 1 0 0 0-1 1ZM5.833 1h-.919a1 1 0 0 0-.707.293L2.5 3 1.293 4.207A1 1 0 0 0 1 4.914v.92h3.833a1 1 0 0 0 1-1V1Z", clipRule: "evenodd" })));
}, AllProducts: function(e) {
  return c.createElement("svg", ht({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Mc || (Mc = c.createElement("path", { fill: "currentColor", d: "M2.5 3.5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1ZM6.5 3.5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1ZM11.5 2.5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1ZM2.5 7.5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1ZM7.5 6.5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1ZM10.5 7.5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1ZM3.5 10.5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1ZM6.5 11.5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1ZM11.5 10.5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1Z" })));
}, Apps: function(e) {
  return c.createElement("svg", pt({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Lc || (Lc = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7 3H3v4h4V3Zm0 6H3v4h4V9Zm2-6h4v4H9V3Zm4 6H9v4h4V9Z", clipRule: "evenodd" })));
}, Array: function(e) {
  return c.createElement("svg", vt({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Zc || (Zc = c.createElement("path", { fill: "currentColor", d: "M2.5 1a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H4V3h2.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-4ZM13.5 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H12V3H9.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h4Z" })));
}, ArrowDown: function(e) {
  return c.createElement("svg", mt({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Pc || (Pc = c.createElement("path", { fill: "currentColor", d: "M9.168 3v6.944l1.535-1.535a1 1 0 0 1 1.414 0l.239.24a1 1 0 0 1 0 1.414l-3.383 3.382c-.008.01-.017.018-.026.027l-.239.24a1 1 0 0 1-1.414 0L3.643 10.06a1 1 0 0 1 0-1.414l.239-.239a1 1 0 0 1 1.414 0L6.83 9.941V3a1 1 0 0 1 1-1h.338a1 1 0 0 1 1 1Z" })));
}, ArrowLeft: function(e) {
  return c.createElement("svg", bt({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Sc || (Sc = c.createElement("path", { fill: "currentColor", d: "M13 6.832H6.056L7.59 5.297a1 1 0 0 0 0-1.414l-.24-.239a1 1 0 0 0-1.414 0L2.555 7.027c-.01.008-.018.017-.027.026l-.24.239a1 1 0 0 0 0 1.414l3.652 3.651a1 1 0 0 0 1.414 0l.239-.239a1 1 0 0 0 0-1.414L6.059 9.17H13a1 1 0 0 0 1-1v-.338a1 1 0 0 0-1-1Z" })));
}, ArrowRight: function(e) {
  return c.createElement("svg", yt({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Nc || (Nc = c.createElement("path", { fill: "currentColor", d: "M3 6.832h6.944L8.41 5.297a1 1 0 0 1 0-1.414l.24-.239a1 1 0 0 1 1.414 0l3.382 3.383c.01.008.018.017.027.026l.24.239a1 1 0 0 1 0 1.414l-3.652 3.651a1 1 0 0 1-1.414 0l-.239-.239a1 1 0 0 1 0-1.414L9.941 9.17H3a1 1 0 0 1-1-1v-.338a1 1 0 0 1 1-1Z" })));
}, ArrowUp: function(e) {
  return c.createElement("svg", wt({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), zc || (zc = c.createElement("path", { fill: "currentColor", d: "M9.168 13V6.056l1.535 1.535a1 1 0 0 0 1.414 0l.239-.24a1 1 0 0 0 0-1.414L8.973 2.555a1.023 1.023 0 0 0-.026-.027l-.239-.24a1 1 0 0 0-1.414 0L3.643 5.94a1 1 0 0 0 0 1.414l.239.239a1 1 0 0 0 1.414 0L6.83 6.059V13a1 1 0 0 0 1 1h.338a1 1 0 0 0 1-1Z" })));
}, Beaker: function(e) {
  return c.createElement("svg", Ot({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Hc || (Hc = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M5.953 1.8c0-.28 0-.42.054-.527a.5.5 0 0 1 .219-.218C6.333 1 6.473 1 6.753 1h2.4c.28 0 .42 0 .527.054a.5.5 0 0 1 .218.219c.055.107.055.247.055.527v.4c0 .28 0 .42-.055.527a.5.5 0 0 1-.218.219C9.573 3 9.433 3 9.153 3h-2.4c-.28 0-.42 0-.527-.054a.5.5 0 0 1-.219-.219c-.054-.107-.054-.247-.054-.527v-.4Zm.056 2.47c-.056.108-.056.25-.056.535V6l-3.007 5.412c-.663 1.193-.994 1.79-.932 2.277a1.5 1.5 0 0 0 .6 1.02C3.01 15 3.693 15 5.057 15h5.791c1.365 0 2.047 0 2.444-.291a1.5 1.5 0 0 0 .6-1.02c.062-.488-.27-1.084-.932-2.277L9.953 6V4.805c0-.285 0-.427-.056-.535a.5.5 0 0 0-.214-.214C9.575 4 9.433 4 9.148 4h-2.39c-.285 0-.427 0-.536.056a.5.5 0 0 0-.213.214ZM9.333 9l-3.03.5-1.287 2.31c-.218.392-.327.588-.309.748a.5.5 0 0 0 .205.348c.13.094.355.094.802.094h4.48c.447 0 .67 0 .801-.094a.5.5 0 0 0 .205-.348c.019-.16-.09-.355-.307-.746L9.333 9Z", clipRule: "evenodd" })));
}, Bell: function(e) {
  return c.createElement("svg", xt({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Rc || (Rc = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12.625 6.138a4.656 4.656 0 0 0-3.268-3.925C9.228 1.52 8.67 1 8 1c-.67 0-1.228.52-1.357 1.213a4.656 4.656 0 0 0-3.268 3.925l-.452 3.963h.026a.95.95 0 0 0 0 1.899h10.102a.95.95 0 0 0 0-1.899h.026l-.452-3.963ZM8 15a2 2 0 0 1-2-2h4a2 2 0 0 1-2 2Z", clipRule: "evenodd" })));
}, Biometric: function(e) {
  return c.createElement("svg", jt({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Ac || (Ac = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7.5 1A5.5 5.5 0 0 0 2 6.5v3A5.5 5.5 0 0 0 7.5 15h1A5.5 5.5 0 0 0 14 9.5v-3A5.5 5.5 0 0 0 8.5 1h-1Zm1.074 6.75a.574.574 0 1 0-1.148 0v2.457a.574.574 0 0 0 1.148 0V7.75ZM8 5.338A2.412 2.412 0 0 0 5.588 7.75v2.566a.994.994 0 0 1-.291.704.574.574 0 1 0 .812.812c.402-.402.628-.947.628-1.516V7.75a1.264 1.264 0 1 1 2.527 0v2.648c0 .412-.233.79-.602.973a.574.574 0 0 0 .514 1.028 2.237 2.237 0 0 0 1.236-2V7.75A2.412 2.412 0 0 0 8 5.338ZM4.899 7.75A3.101 3.101 0 0 1 9.64 5.117a.574.574 0 1 0 .609-.974A4.25 4.25 0 0 0 3.75 7.75v2.297a.574.574 0 1 0 1.149 0V7.75Zm6.887-1.932a.574.574 0 1 0-1.023.522c.216.423.338.901.338 1.41v1.378a.574.574 0 1 0 1.149 0V7.75c0-.695-.167-1.352-.464-1.932Z", clipRule: "evenodd" })));
}, Boolean: function(e) {
  return c.createElement("svg", $t({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Bc || (Bc = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 2a6 6 0 1 1 0 12A6 6 0 0 1 8 2Zm4 6a4 4 0 0 1-4 4V4a4 4 0 0 1 4 4Z", clipRule: "evenodd" })));
}, Building: function(e) {
  return c.createElement("svg", Et({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Dc || (Dc = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1 2a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v13H6v-2H4v2H1v-4h4.5a.5.5 0 0 0 0-1H1V8h4.5a.5.5 0 0 0 0-1H1V5h4.5a.5.5 0 0 0 0-1H1V2Zm8 9h4.5a.5.5 0 0 0 0-1H9V8h4.5a.5.5 0 0 0 0-1H9V5a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v10h-2v-2h-2v2H9v-4Z", clipRule: "evenodd" })));
}, Bulb: function(e) {
  return c.createElement("svg", Ct({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Vc || (Vc = c.createElement("path", { fill: "currentColor", d: "M12.331 8.5a5 5 0 1 0-8.612.086L5.408 11.5a1 1 0 0 0 .866.499H6.5V6a1.5 1.5 0 1 1 3 0v6h.224a1 1 0 0 0 .863-.496L12.34 8.5h-.009Z" })), Tc || (Tc = c.createElement("path", { fill: "currentColor", d: "M7.5 6v6h1V6a.5.5 0 0 0-1 0ZM10 14v-1H6v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1Z" })));
}, Calendar: function(e) {
  return c.createElement("svg", kt({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Fc || (Fc = c.createElement("path", { fill: "currentColor", d: "M4 2a1 1 0 0 1 2 0v1a1 1 0 0 1-2 0V2Z" })), Ic || (Ic = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9 3H7a2 2 0 1 1-4 0 2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2 2 2 0 1 1-4 0Zm3 4H9v3h3V7Z", clipRule: "evenodd" })), _c || (_c = c.createElement("path", { fill: "currentColor", d: "M10 3a1 1 0 1 0 2 0V2a1 1 0 1 0-2 0v1Z" })));
}, Camera: function(e) {
  return c.createElement("svg", Mt({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Gc || (Gc = c.createElement("path", { fill: "currentColor", d: "M10.25 8.5a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z" })), Uc || (Uc = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M4.585 3.33a1.5 1.5 0 0 1 1.342-.83h4.146a1.5 1.5 0 0 1 1.342.83l.309.617a1 1 0 0 0 .894.553h.882A1.5 1.5 0 0 1 15 6v6a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 1 12V6a1.5 1.5 0 0 1 1.5-1.5h.882a1 1 0 0 0 .894-.553l.31-.618ZM11.5 8.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z", clipRule: "evenodd" })));
}, Cap: function(e) {
  return c.createElement("svg", Lt({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Wc || (Wc = c.createElement("path", { fill: "currentColor", d: "M2.97 8.008v2.3l.001.092-.002.262c0 1.926 2.535 2.838 5 2.838 2.466 0 5-.912 5-2.838 0-.085 0-.168-.002-.25.002-.035.002-.07.002-.105V8.001L8.706 9.787a2 2 0 0 1-1.554-.004L2.969 8.008Z" })), Yc || (Yc = c.createElement("path", { fill: "currentColor", d: "M7.565 2.583a1 1 0 0 1 .794-.002l6.35 2.732a.5.5 0 0 1-.004.92L8.35 8.896a1 1 0 0 1-.778-.001L1.305 6.233a.5.5 0 0 1-.005-.919l6.265-2.73ZM13.97 7.626v1.477a1 1 0 1 0 1 0V7.207l-1 .419Z" })));
}, CaretDown: function(e) {
  return c.createElement("svg", Zt({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Xc || (Xc = c.createElement("path", { fill: "currentColor", d: "M8.679 10.796a.554.554 0 0 1-.858 0L4.64 6.976C4.32 6.594 4.582 6 5.069 6h6.362c.487 0 .748.594.43.976l-3.182 3.82Z" })));
}, CaretLeft: function(e) {
  return c.createElement("svg", Pt({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), qc || (qc = c.createElement("path", { fill: "currentColor", d: "M5.204 8.679a.553.553 0 0 1 0-.858l3.82-3.181c.382-.319.976-.058.976.429v6.362c0 .487-.594.748-.976.43l-3.82-3.182Z" })));
}, CaretRight: function(e) {
  return c.createElement("svg", St({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Kc || (Kc = c.createElement("path", { fill: "currentColor", d: "M10.796 7.321a.554.554 0 0 1 0 .858l-3.82 3.181c-.382.319-.976.058-.976-.429V4.57c0-.487.594-.748.976-.43l3.82 3.182Z" })));
}, CaretUp: function(e) {
  return c.createElement("svg", Nt({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Jc || (Jc = c.createElement("path", { fill: "currentColor", d: "M7.321 5.204a.553.553 0 0 1 .858 0l3.181 3.82c.319.382.058.976-.429.976H4.57c-.487 0-.748-.594-.43-.976l3.182-3.82Z" })));
}, ChartFilled: function(e) {
  return c.createElement("svg", zt({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Qc || (Qc = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M3 2.5a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2H3Zm8.25 2a.75.75 0 0 0-.75.75v6.25H12V5.25a.75.75 0 0 0-.75-.75ZM7.5 7.25a.75.75 0 0 1 1.5 0v4.25H7.5V7.25ZM5.25 9a.75.75 0 0 0-.75.75v1.75H6V9.75A.75.75 0 0 0 5.25 9Z", clipRule: "evenodd" })));
}, Charts: function(e) {
  return c.createElement("svg", Ht({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), es || (es = c.createElement("path", { fill: "currentColor", d: "M11.5 13a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v10ZM7.5 14a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-1ZM2.5 14a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-1Z" })));
}, Checkmark: function(e) {
  return c.createElement("svg", Rt({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), ns || (ns = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "m6.306 9.05 5.455-5.455a1 1 0 0 1 1.414 0l.707.707a1 1 0 0 1 0 1.414l-7.067 7.068a1 1 0 0 1-1.5-.098l-3.049-3.97a1 1 0 0 1 .184-1.402l.595-.457a1.25 1.25 0 0 1 1.753.23L6.306 9.05Z", clipRule: "evenodd" })));
}, CheckmarkWithCircle: function(e) {
  return c.createElement("svg", At({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), ts || (ts = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Zm2.448-10.104a.997.997 0 1 1 1.508 1.306l-4.572 5.28a1 1 0 0 1-1.64-.07l-1.82-2.868a1 1 0 1 1 1.69-1.07l1.1 1.734 3.734-4.312Z", clipRule: "evenodd" })));
}, ChevronDown: function(e) {
  return c.createElement("svg", Bt({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), rs || (rs = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1.636 5.364a1 1 0 0 0 0 1.414l4.95 4.95.707.707a1 1 0 0 0 1.414 0l.707-.707 4.95-4.95a1 1 0 0 0 0-1.414l-.707-.707a1 1 0 0 0-1.414 0L8 8.899 3.757 4.657a1 1 0 0 0-1.414 0l-.707.707Z", clipRule: "evenodd" })));
}, ChevronLeft: function(e) {
  return c.createElement("svg", Dt({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), as || (as = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M10.778 1.636a1 1 0 0 0-1.414 0l-4.95 4.95-.707.707a1 1 0 0 0 0 1.414l.707.707 4.95 4.95a1 1 0 0 0 1.414 0l.707-.707a1 1 0 0 0 0-1.414L7.243 8l4.242-4.243a1 1 0 0 0 0-1.414l-.707-.707Z", clipRule: "evenodd" })));
}, ChevronRight: function(e) {
  return c.createElement("svg", Vt({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), os || (os = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M5.364 14.364a1 1 0 0 0 1.414 0l4.95-4.95.707-.707a1 1 0 0 0 0-1.414l-.707-.707-4.95-4.95a1 1 0 0 0-1.414 0l-.707.707a1 1 0 0 0 0 1.414L8.899 8l-4.242 4.243a1 1 0 0 0 0 1.414l.707.707Z", clipRule: "evenodd" })));
}, ChevronUp: function(e) {
  return c.createElement("svg", Tt({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), ls || (ls = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M14.364 10.778a1 1 0 0 0 0-1.414l-4.95-4.95-.707-.707a1 1 0 0 0-1.414 0l-.707.707-4.95 4.95a1 1 0 0 0 0 1.414l.707.707a1 1 0 0 0 1.414 0L8 7.243l4.243 4.242a1 1 0 0 0 1.414 0l.707-.707Z", clipRule: "evenodd" })));
}, Clock: function(e) {
  return c.createElement("svg", Ft({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), is || (is = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12Zm-.75-9.25a.75.75 0 0 1 1.5 0v3.16l1.744 1.526a.75.75 0 0 1-.988 1.128L7.511 8.818a.761.761 0 0 1-.19-.25.747.747 0 0 1-.071-.318v-3.5Z", clipRule: "evenodd" })));
}, ClockWithArrow: function(e) {
  return c.createElement("svg", It({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), cs || (cs = c.createElement("path", { fill: "currentColor", d: "M13 8a5 5 0 0 1-7.304 4.438c-.348-.18-.787-.13-1.038.172l-.33.398c-.276.33-.22.828.152 1.044a7 7 0 1 0-1.452-10.98L1.97 2.146a.584.584 0 0 0-.964.521l.455 3.252c.04.287.285.51.576.511H5.32a.58.58 0 0 0 .387-1.018l-1.168-1.02A5 5 0 0 1 13 8Z" })), ss || (ss = c.createElement("path", { fill: "currentColor", d: "M7.25 5.25a.75.75 0 0 1 1.5 0v2.668l1.68 1.524a.75.75 0 1 1-.988 1.129L7.507 8.815a.758.758 0 0 1-.257-.565v-3Z" })));
}, Clone: function(e) {
  return c.createElement("svg", _t({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), us || (us = c.createElement("path", { fill: "currentColor", d: "M5.5 12a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-5a2 2 0 0 0-2 2v4Z" })), fs || (fs = c.createElement("path", { fill: "currentColor", d: "M4.25 10H3.5a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2v.75h-2V4h-5v4h.75v2Z" })));
}, Cloud: function(e) {
  return c.createElement("svg", Gt({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), ds || (ds = c.createElement("path", { fill: "currentColor", d: "M12.571 8.143c0 1.775-.899 3.34-2.267 4.264l-.014.01a5.12 5.12 0 0 1-2.861.869H2.857a2.857 2.857 0 0 1-.545-5.663 5.144 5.144 0 0 1 10.26.52ZM13.821 8.143a6.38 6.38 0 0 1-2.358 4.96 3.429 3.429 0 1 0 2.17-6.506c.123.494.188 1.013.188 1.546Z" })));
}, Code: function(e) {
  return c.createElement("svg", Ut({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), gs || (gs = c.createElement("path", { fill: "currentColor", d: "M6.11 13.262a.5.5 0 0 0 .395.586l.737.143a.5.5 0 0 0 .585-.396L9.926 2.738a.5.5 0 0 0-.396-.586l-.737-.143a.5.5 0 0 0-.585.396L6.109 13.262ZM1.36 7.246 3.976 5.11a.507.507 0 0 1 .704.063l.64.752a.483.483 0 0 1-.064.69L3.562 7.998 5.256 9.38c.212.173.24.482.064.69l-.64.752a.507.507 0 0 1-.704.062L1.36 8.75A.971.971 0 0 1 1 7.998c0-.29.132-.566.36-.752ZM14.636 7.246 12.02 5.11a.507.507 0 0 0-.704.063l-.64.752a.483.483 0 0 0 .064.69l1.694 1.382L10.74 9.38a.483.483 0 0 0-.064.69l.64.752a.507.507 0 0 0 .704.062l2.616-2.134a.971.971 0 0 0 .36-.752.971.971 0 0 0-.36-.752Z" })));
}, CodeBlock: function(e) {
  return c.createElement("svg", Wt({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), hs || (hs = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M13 4H3v8h10V4ZM3 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H3Z", clipRule: "evenodd" })), ps || (ps = c.createElement("path", { fill: "currentColor", d: "M4.221 7.421 6.256 5.78a.398.398 0 0 1 .548.048l.498.578a.368.368 0 0 1-.05.53L5.934 8l1.318 1.063c.165.133.187.37.05.53l-.498.58a.398.398 0 0 1-.548.047L4.221 8.58A.744.744 0 0 1 3.941 8c0-.224.103-.436.28-.579ZM11.779 7.421 9.744 5.78a.398.398 0 0 0-.548.048l-.498.578a.368.368 0 0 0 .05.53L10.066 8 8.748 9.063a.368.368 0 0 0-.05.53l.498.58c.138.159.383.18.548.047l2.035-1.641a.744.744 0 0 0 .28-.579.744.744 0 0 0-.28-.579Z" })));
}, Colon: function(e) {
  return c.createElement("svg", Yt({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), vs || (vs = c.createElement("path", { fill: "currentColor", d: "M10 4.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM10 11.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" })));
}, Connect: function(e) {
  return c.createElement("svg", Xt({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), ms || (ms = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12.867 8.898a4.048 4.048 0 0 0 .687-4.8l1.275-1.275a.584.584 0 0 0 0-.826l-.826-.826a.584.584 0 0 0-.826 0l-1.29 1.29a4.048 4.048 0 0 0-4.734.722L5.277 5.058a.323.323 0 0 0-.041.035L3.182 7.148a4.048 4.048 0 0 0-.72 4.738l-1.29 1.29a.584.584 0 0 0 0 .827l.825.826a.584.584 0 0 0 .826 0l1.278-1.278a4.048 4.048 0 0 0 4.795-.689l1.876-1.875a.324.324 0 0 0 .041-.035l2.054-2.054ZM6.561 6.776 4.685 8.65a1.916 1.916 0 0 0 0 2.707c.747.746 1.961.747 2.707 0l2.055-2.054a.321.321 0 0 1 .04-.035l1.877-1.875a1.916 1.916 0 0 0 0-2.707 1.916 1.916 0 0 0-2.707 0L6.602 6.74a.32.32 0 0 1-.04.035Z", clipRule: "evenodd" })));
}, Copy: function(e) {
  return c.createElement("svg", qt({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), bs || (bs = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1 5.714v4.572C1 11.233 1.768 12 2.714 12H5.75V7.11c0-.566.227-1.108.63-1.504l2.294-2.252c.1-.099.21-.186.326-.262v-.378C9 1.768 8.232 1 7.286 1H5.8v3.429c0 .71-.576 1.285-1.286 1.285H1Zm8-.928L7.257 6.498A.857.857 0 0 0 7 7.11v.688h3.01a.857.857 0 0 0 .857-.858V4h-.717a.857.857 0 0 0-.6.246l-.55.54ZM4.867 1H4.15a.857.857 0 0 0-.601.246L1.257 3.498A.857.857 0 0 0 1 4.11v.688h3.01a.857.857 0 0 0 .857-.858V1ZM7 12V8.714H10.514c.71 0 1.286-.575 1.286-1.285V4h1.486C14.233 4 15 4.768 15 5.714v7.572c0 .947-.768 1.714-1.714 1.714H8.714A1.714 1.714 0 0 1 7 13.286V12Z", clipRule: "evenodd" })));
}, CreditCard: function(e) {
  return c.createElement("svg", Kt({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), ys || (ys = c.createElement("path", { fill: "currentColor", d: "M3 3a2 2 0 0 0-2 2h14a2 2 0 0 0-2-2H3ZM15 7H1v4a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7Z" })));
}, CurlyBraces: function(e) {
  return c.createElement("svg", Jt({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), ws || (ws = c.createElement("path", { fill: "currentColor", d: "M3 3.544a2.5 2.5 0 0 1 2.5-2.5h1a.5.5 0 0 1 .5.5v1.105a.353.353 0 0 1-.353.353h-.79A.858.858 0 0 0 5 3.86v2.802a1.5 1.5 0 0 1-.816 1.335A1.5 1.5 0 0 1 5 9.332v2.803c0 .473.384.857.858.857h.789c.195 0 .353.158.353.353v1.105a.5.5 0 0 1-.5.5h-1a2.5 2.5 0 0 1-2.5-2.5v-1.956a1.5 1.5 0 0 0-1.5-1.5.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5 1.5 1.5 0 0 0 1.5-1.5v-1.95ZM13 12.45a2.5 2.5 0 0 1-2.5 2.5h-1a.5.5 0 0 1-.5-.5v-1.105c0-.195.158-.353.353-.353h.79a.858.858 0 0 0 .857-.858V9.332a1.5 1.5 0 0 1 .816-1.335A1.5 1.5 0 0 1 11 6.662V3.859a.858.858 0 0 0-.858-.857h-.789A.353.353 0 0 1 9 2.65V1.544a.5.5 0 0 1 .5-.5h1a2.5 2.5 0 0 1 2.5 2.5V5.5A1.5 1.5 0 0 0 14.5 7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5 1.5 1.5 0 0 0-1.5 1.5v1.95Z" })));
}, Cursor: function(e) {
  return c.createElement("svg", Qt({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Os || (Os = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "m8.534 8.534.473-.27 2.389-1.366-6.748-2.25 2.25 6.748 1.366-2.389.27-.473ZM10 10l4.48-2.563c.734-.333.678-1.393-.086-1.648L3.169 2.047A.887.887 0 0 0 2.047 3.17l3.742 11.225c.255.764 1.315.82 1.648.086L10 10Z", clipRule: "evenodd" })));
}, Dashboard: function(e) {
  return c.createElement("svg", er({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), xs || (xs = c.createElement("path", { fill: "currentColor", d: "M2 2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-6ZM7 7.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1-.5-.5v-6ZM7 2.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1-.5-.5v-3ZM2 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-3Z" })));
}, Database: function(e) {
  return c.createElement("svg", nr({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), js || (js = c.createElement("path", { fill: "currentColor", d: "M13.5 4.452c0 .09 0 .177-.002.262l.002.094v.23c0 .3-.136.588-.433.87-.302.289-.75.548-1.305.765-1.11.434-2.541.656-3.762.656-1.22 0-2.652-.222-3.762-.656-.555-.217-1.003-.476-1.305-.764-.297-.283-.433-.571-.433-.872v-.229c0-.035 0-.07.002-.105a12.886 12.886 0 0 1-.002-.251C2.5 2.517 5.288 1.6 8 1.6s5.5.917 5.5 2.852Z" })), $s || ($s = c.createElement("path", { fill: "currentColor", d: "M2.5 6.747v1.957c0 .3.136.589.433.871.302.288.75.548 1.305.765 1.11.433 2.541.656 3.762.656 1.22 0 2.652-.223 3.762-.656.555-.217 1.003-.477 1.305-.765.297-.282.433-.57.433-.87V6.746c-.392.318-.88.575-1.405.78-1.236.483-2.784.719-4.095.719-1.31 0-2.859-.236-4.095-.72-.525-.204-1.013-.461-1.405-.779Z" })), Es || (Es = c.createElement("path", { fill: "currentColor", d: "M12.095 11.194c.525-.205 1.013-.462 1.405-.78v.811c0 .035 0 .07-.002.105l.002.251c0 1.936-2.788 2.852-5.5 2.852s-5.5-.916-5.5-2.852c0-.088 0-.176.002-.262a2.322 2.322 0 0 1-.002-.094v-.811c.392.318.88.575 1.405.78 1.236.483 2.784.718 4.095.718 1.31 0 2.859-.235 4.095-.719Z" })));
}, Diagram: function(e) {
  return c.createElement("svg", tr({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Cs || (Cs = c.createElement("path", { fill: "currentColor", d: "M6 2.75A.75.75 0 0 1 6.75 2h2.5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-.75.75H8.5v2h4.75a.75.75 0 0 1 .75.75V10h.25a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-.75.75h-2a.75.75 0 0 1-.75-.75v-1.5a.75.75 0 0 1 .75-.75H13V8H8.5v2H9a.75.75 0 0 1 .75.75v1.5A.75.75 0 0 1 9 13H7a.75.75 0 0 1-.75-.75v-1.5A.75.75 0 0 1 7 10h.5V8H3v2h.75a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-.75.75h-2a.75.75 0 0 1-.75-.75v-1.5a.75.75 0 0 1 .75-.75H2V7.75A.75.75 0 0 1 2.75 7H7.5V5h-.75A.75.75 0 0 1 6 4.25v-1.5Z" })));
}, Diagram2: function(e) {
  return c.createElement("svg", rr({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), ks || (ks = c.createElement("path", { fill: "currentColor", d: "M10.72 1c-.398 0-.72.336-.72.75V2H7.48a.49.49 0 0 0-.48.5V7H5v-.25C5 6.336 4.678 6 4.28 6H1.72c-.398 0-.72.336-.72.75v1.5c0 .414.322.75.72.75h2.56c.398 0 .72-.336.72-.75V8h2v4.5c0 .276.215.5.48.5H10v.25c0 .414.322.75.72.75h2.06c.398 0 .72-.336.72-.75v-1.5c0-.414-.322-.75-.72-.75h-2.06c-.398 0-.72.336-.72.75V12H8V8h2v.25c0 .414.322.75.72.75h2.06c.398 0 .72-.336.72-.75v-1.5c0-.414-.322-.75-.72-.75h-2.06c-.398 0-.72.336-.72.75V7H8V3h2v.25c0 .414.322.75.72.75h2.06c.398 0 .72-.336.72-.75v-1.5c0-.414-.322-.75-.72-.75h-2.06Z" })));
}, Diagram3: function(e) {
  return c.createElement("svg", ar({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 14, fill: "none", viewBox: "0 0 16 16" }, e), Ms || (Ms = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1.75 1a.75.75 0 0 0-.75.75v1.5c0 .414.336.75.75.75h2.5A.75.75 0 0 0 5 3.25v-1.5A.75.75 0 0 0 4.25 1h-2.5Zm9.25.75a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1-.75-.75v-1.5Zm0 9a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1-.75-.75v-1.5Zm-10 0a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1-.75-.75v-1.5ZM6 5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H6Z", clipRule: "evenodd" })));
}, Disconnect: function(e) {
  return c.createElement("svg", or({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Ls || (Ls = c.createElement("path", { fill: "currentColor", d: "M7.093 3.671a.317.317 0 0 1 0-.448L8.14 2.175a4.024 4.024 0 0 1 5.685 0 4.024 4.024 0 0 1 0 5.685l-1.048 1.047a.317.317 0 0 1-.448 0L11.28 7.86a.317.317 0 0 1 0-.449l1.048-1.047a1.906 1.906 0 0 0 0-2.693 1.906 1.906 0 0 0-2.693 0L8.59 4.718a.317.317 0 0 1-.449 0L7.093 3.671ZM1.293 1.293a1.001 1.001 0 0 1 1.416 0l11.998 11.998a1.001 1.001 0 0 1-1.416 1.416l-3.159-3.16-2.272 2.277a4.024 4.024 0 0 1-5.685 0 4.024 4.024 0 0 1 0-5.684l2.273-2.277L1.293 2.71a1.001 1.001 0 0 1 0-1.416Zm4.65 6.066L3.672 9.636a1.906 1.906 0 0 0 0 2.693c.743.742 1.95.742 2.693 0l2.272-2.277-2.692-2.693Z" })));
}, Download: function(e) {
  return c.createElement("svg", lr({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Zs || (Zs = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9.524 2.575v5.557h1.712c.706 0 1.033.783.5 1.196l-3.237 2.506a.832.832 0 0 1-.998 0L4.265 9.328c-.534-.413-.207-1.196.499-1.196h1.611V2.575a1.575 1.575 0 0 1 3.15 0ZM2.5 11h1.8l2.405 1.862a2.132 2.132 0 0 0 2.59 0L11.7 11h1.8a1.5 1.5 0 0 1 0 3h-11a1.5 1.5 0 0 1 0-3Z", clipRule: "evenodd" })));
}, Drag: function(e) {
  return c.createElement("svg", ir({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Ps || (Ps = c.createElement("path", { fill: "currentColor", d: "M7 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM11 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM7 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM11 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM11 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" })));
}, Edit: function(e) {
  return c.createElement("svg", cr({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Ss || (Ss = c.createElement("path", { fill: "currentColor", d: "M10.922.681a.963.963 0 0 1 1.362 0l1.363 1.363a.963.963 0 0 1 0 1.362L12.284 4.77 9.56 2.044 8.538 3.066l2.724 2.725-7.153 7.153-3.747 1.022 1.022-3.747L10.922.68Z" })));
}, Ellipsis: function(e) {
  return c.createElement("svg", sr({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Ns || (Ns = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M2.75 6a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5Zm5 0a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5Zm6.75 1.75a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0Z", clipRule: "evenodd" })));
}, Email: function(e) {
  return c.createElement("svg", ur({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), zs || (zs = c.createElement("path", { fill: "currentColor", d: "m2.494 4 4.714 5.05a1.068 1.068 0 0 0 1.584 0L13.505 4H2.494ZM1.133 4.256A2.12 2.12 0 0 0 1 5v6c0 .369.093.715.256 1.011L4.814 8.2l-3.68-3.944Z" })), Hs || (Hs = c.createElement("path", { fill: "currentColor", d: "M2.867 13c-.348 0-.674-.102-.953-.28l3.56-3.813 1.219 1.306a1.78 1.78 0 0 0 2.64 0l1.346-1.443 3.575 3.83c-.313.251-.7.4-1.12.4H2.866ZM14.84 11.813c.103-.248.16-.523.16-.813V5c0-.255-.045-.5-.126-.724l-3.535 3.787 3.5 3.75Z" })));
}, Escalation: function(e) {
  return c.createElement("svg", fr({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Rs || (Rs = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M13.361 4.423a.556.556 0 0 0-.26-.97L5.146 2.009a.556.556 0 0 0-.636.69l1.787 6.672a.556.556 0 0 0 .896.28l6.168-5.228ZM2.911 2.102a.556.556 0 0 0-.392.68l3.163 11.806a.556.556 0 1 0 1.074-.287L3.592 2.493a.556.556 0 0 0-.68-.392Z", clipRule: "evenodd" })));
}, Export: function(e) {
  return c.createElement("svg", dr({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), As || (As = c.createElement("path", { fill: "currentColor", d: "M14.623 5.186a.278.278 0 0 0 0-.385l-2.805-2.915a.277.277 0 0 0-.477.192v1.424A6.5 6.5 0 0 0 5 10v.1a1.5 1.5 0 0 0 3 0V10a3.5 3.5 0 0 1 3.34-3.496v1.405c0 .25.305.373.478.193l2.805-2.916Z" })), Bs || (Bs = c.createElement("path", { fill: "currentColor", d: "M6.5 3.879a.75.75 0 0 0-.75-.75H4a2 2 0 0 0-2 2v6.864a2 2 0 0 0 2 2h6.864a2 2 0 0 0 2-2V10.05a.75.75 0 0 0-1.5 0v1.943a.5.5 0 0 1-.5.5H4a.5.5 0 0 1-.5-.5V5.129a.5.5 0 0 1 .5-.5h1.75a.75.75 0 0 0 .75-.75Z" })));
}, Favorite: function(e) {
  return c.createElement("svg", gr({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Ds || (Ds = c.createElement("path", { fill: "currentColor", d: "M7.538 1.11a.5.5 0 0 1 .924 0l1.537 3.696a.5.5 0 0 0 .421.306l3.99.32a.5.5 0 0 1 .285.878l-3.04 2.604a.5.5 0 0 0-.16.496l.928 3.893a.5.5 0 0 1-.747.542L8.261 11.76a.5.5 0 0 0-.522 0l-3.415 2.086a.5.5 0 0 1-.747-.542l.928-3.893a.5.5 0 0 0-.16-.496L1.304 6.31a.5.5 0 0 1 .285-.878l3.99-.32A.5.5 0 0 0 6 4.806L7.538 1.11Z" })));
}, Federation: function(e) {
  return c.createElement("svg", hr({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Vs || (Vs = c.createElement("path", { fill: "currentColor", d: "M8 0c1.6 0 2.8 1.3 2.8 3 0 1.5-1 2.7-2.3 3v2.1l3.1 2.4c.4-.3 1-.5 1.5-.5 1.6 0 2.8 1.3 2.8 3s-1.3 3-2.8 3c-1.6 0-2.8-1.3-2.8-3 0-.7.2-1.3.6-1.8L8 9l-2.9 2.2c.4.5.6 1.1.6 1.8 0 1.7-1.3 3-2.8 3C1.4 16 0 14.7 0 13s1.3-3 2.8-3c.6 0 1.1.2 1.5.5l3.1-2.4V5.9C6.2 5.7 5.2 4.5 5.2 3c0-1.7 1.2-3 2.8-3Zm0 5c.8 0 1.9-.8 1.9-2C9.9 1.9 9 1 8 1c-1 0-1.9.9-1.9 2 0 1.2 1 2 1.9 2Zm-5.2 6c-1 0-1.9.9-1.9 2s.8 2 1.9 2c1.1 0 1.9-.9 1.9-2s-.8-2-1.9-2Zm10.4 0c-1 0-1.9.9-1.9 2s.8 2 1.9 2c1.1 0 1.9-.9 1.9-2s-.9-2-1.9-2Z" })));
}, File: function(e) {
  return c.createElement("svg", pr({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Ts || (Ts = c.createElement("path", { fill: "currentColor", d: "M3 13V7h4.5A1.5 1.5 0 0 0 9 5.5V1h2a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z" })), Fs || (Fs = c.createElement("path", { fill: "currentColor", d: "M7.833 1h-.919a1 1 0 0 0-.707.293L3.293 4.207A1 1 0 0 0 3 4.914v.92h3.833a1 1 0 0 0 1-1V1Z" })));
}, Filter: function(e) {
  return c.createElement("svg", vr({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Is || (Is = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "m6 6.148-3.8-3.94C1.797 1.79 2.044 1 2.576 1h10.848c.532 0 .779.79.377 1.208L10 6.148v5.625a.5.5 0 0 1-.17.376l-3 2.625a.5.5 0 0 1-.83-.376v-8.25Z", clipRule: "evenodd" })));
}, FullScreenEnter: function(e) {
  return c.createElement("svg", br({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Gs || (Gs = c.createElement("path", { fill: "currentColor", d: "M1.5 2a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-4ZM15 2.5a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-4ZM1.5 14a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-4ZM14.5 14a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h4Z" })));
}, FullScreenExit: function(e) {
  return c.createElement("svg", yr({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Us || (Us = c.createElement("path", { fill: "currentColor", d: "M10.5 7a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-4ZM6 9.5a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-4ZM10.5 9a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-4ZM5.5 7a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h4Z" })));
}, Folder: function(e) {
  return c.createElement("svg", mr({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), _s || (_s = c.createElement("path", { fill: "currentColor", d: "M2 2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H8a1 1 0 0 1-1-1 1 1 0 0 0-1-1H2Z" })));
}, Gauge: function(e) {
  return c.createElement("svg", wr({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Ws || (Ws = c.createElement("path", { fill: "currentColor", d: "M1.041 10.251c-.044.412.296.749.71.749h2.494c.414 0 .74-.34.843-.742A3.006 3.006 0 0 1 8.791 8.1l2.99-2.991a7 7 0 0 0-10.74 5.142ZM13.297 6.422l-2.842 2.842c.213.3.368.638.459.994.102.401.429.742.843.742h2.494c.414 0 .754-.337.71-.749a7.001 7.001 0 0 0-1.664-3.829Z" })));
}, GlobeAmericas: function(e) {
  return c.createElement("svg", Or({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Ys || (Ys = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M14 8A6 6 0 1 1 2 8a6 6 0 0 1 12 0Zm-5.301 4.699A4.73 4.73 0 0 1 5 11.683V10L3.257 8.257A4.75 4.75 0 0 1 8 3.25V4.5L6.5 6v1l-.5.5-.5-.5-1 1 .5.5h2.5L8 9v1l-1 1 1.699 1.699Zm4.047-4.496a4.73 4.73 0 0 0-.924-3.025L10.5 6.5V9h1.25l.996-.797Z", clipRule: "evenodd" })));
}, GovernmentBuilding: function(e) {
  return c.createElement("svg", xr({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Xs || (Xs = c.createElement("path", { fill: "currentColor", d: "M11 5V4a3 3 0 0 0-6 0v1h6Z" })), qs || (qs = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1.5 6a.5.5 0 0 0 0 1H2v6h-.5a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1H14V7h.5a.5.5 0 0 0 0-1h-13Zm3 2.5a.5.5 0 0 1 1 0v3a.5.5 0 0 1-1 0v-3ZM8 8a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 1 0v-3A.5.5 0 0 0 8 8Zm2.5.5a.5.5 0 0 1 1 0v3a.5.5 0 0 1-1 0v-3Z", clipRule: "evenodd" })));
}, Hash: function(e) {
  return c.createElement("svg", jr({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Ks || (Ks = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M10.616 1.5a.5.5 0 0 0-.492.413L9.668 4.5h-2.47l.426-2.413A.5.5 0 0 0 7.13 1.5H6.116a.5.5 0 0 0-.492.413L5.168 4.5H2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2.815l-.53 3H2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1.933l-.425 2.413A.5.5 0 0 0 4 14.5h1.016a.5.5 0 0 0 .492-.413l.456-2.587h2.47l-.426 2.413a.5.5 0 0 0 .492.587h1.016a.5.5 0 0 0 .492-.413l.456-2.587H13.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-2.683l.529-3H13.5A.5.5 0 0 0 14 6V5a.5.5 0 0 0-.5-.5h-1.802l.426-2.413a.5.5 0 0 0-.492-.587h-1.016Zm-4.3 8h2.47l.529-3h-2.47l-.528 3Z", clipRule: "evenodd" })));
}, Highlight: function(e) {
  return c.createElement("svg", $r({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Js || (Js = c.createElement("path", { fill: "currentColor", d: "M8.853 12.031A.1.1 0 0 1 8.926 12h5.824a.25.25 0 0 1 .25.25v1.5a.25.25 0 0 1-.25.25H7.231a.1.1 0 0 1-.072-.168l1.694-1.8ZM4.019 9.193l.375-.374L7.576 12l-.375.375a1 1 0 0 1-.779.29l-.574-.04a1 1 0 0 0-.778.29l-.141.14-1.591-1.59.141-.142a1 1 0 0 0 .29-.778l-.04-.573a1 1 0 0 1 .29-.779ZM11.433 1.779a1 1 0 0 1 1.415 0l1.767 1.768a1 1 0 0 1 0 1.414L8.28 11.296 5.098 8.114l6.335-6.335ZM2.632 12.167l1.593 1.593-.17.172a.25.25 0 0 1-.178.074H1.386a.25.25 0 0 1-.176-.428l1.422-1.41Z" })));
}, Home: function(e) {
  return c.createElement("svg", Er({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Qs || (Qs = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7.687 1.751a.5.5 0 0 1 .626 0l6.433 5.164a.5.5 0 0 1 .069.713l-.644.761a.5.5 0 0 1-.697.065L8.316 4.257a.5.5 0 0 0-.632 0L2.526 8.454a.5.5 0 0 1-.697-.065l-.644-.76a.5.5 0 0 1 .07-.714l6.432-5.164Z", clipRule: "evenodd" })), e2 || (e2 = c.createElement("path", { fill: "currentColor", d: "M7.688 5.25a.5.5 0 0 1 .624 0l4.5 3.6a.5.5 0 0 1 .188.39v4.26a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V9.24a.5.5 0 0 1 .188-.39l4.5-3.6Z" })));
}, HorizontalDrag: function(e) {
  return c.createElement("svg", Cr({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), n2 || (n2 = c.createElement("path", { fill: "currentColor", d: "M4 9a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM4 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM8 9a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM12 9a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM8 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM12 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z" })));
}, Import: function(e) {
  return c.createElement("svg", kr({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), t2 || (t2 = c.createElement("path", { fill: "currentColor", d: "M11.623 8.799a.278.278 0 0 0 0-.385L8.818 5.498a.277.277 0 0 0-.477.193v1.405A3.5 3.5 0 0 1 5 3.6v-.1a1.5 1.5 0 1 0-3 0v.1a6.5 6.5 0 0 0 6.34 6.498v1.424c0 .25.305.372.478.192L11.623 8.8Z" })), r2 || (r2 = c.createElement("path", { fill: "currentColor", d: "M3.95 11a.75.75 0 0 1 1.5 0v1.75a.5.5 0 0 0 .5.5h6.864a.5.5 0 0 0 .5-.5V5.886a.5.5 0 0 0-.5-.5h-1.943a.75.75 0 0 1 0-1.5h1.943a2 2 0 0 1 2 2v6.864a2 2 0 0 1-2 2H5.95a2 2 0 0 1-2-2V11Z" })));
}, ImportantWithCircle: function(e) {
  return c.createElement("svg", Mr({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), a2 || (a2 = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14ZM7 4.5a1 1 0 0 1 2 0v4a1 1 0 0 1-2 0v-4Zm2 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z", clipRule: "evenodd" })));
}, InfoWithCircle: function(e) {
  return c.createElement("svg", Lr({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), o2 || (o2 = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14ZM9 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM8 6a1 1 0 0 1 1 1v4h.5a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1H7V7h-.5a.5.5 0 0 1 0-1H8Z", clipRule: "evenodd" })));
}, InternalEmployee: function(e) {
  return c.createElement("svg", Zr({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), l2 || (l2 = c.createElement("path", { fill: "currentColor", d: "M6.5 8a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM4.343 8.45c-.414-.227-.944-.245-1.252.112A4.482 4.482 0 0 0 2 11.5V14h8.774l-.003-.05-.03-.022s-2.834-2.213-1.27-5.622c-.263-.055-.56.005-.814.144A4.48 4.48 0 0 1 6.5 9a4.48 4.48 0 0 1-2.157-.55Z" })), i2 || (i2 = c.createElement("path", { fill: "currentColor", d: "M12.746 7.003c-.36-.448-.672-.903-.736-.998a.016.016 0 0 0-.023 0c-.063.095-.373.55-.732.998-3.084 4.137.486 6.925.486 6.925l.03.021c.026.431.093 1.051.093 1.051h.266s.067-.617.093-1.05l.03-.025c.004.003 3.577-2.785.493-6.922ZM12 13.87s-.16-.144-.203-.217v-.007l.193-4.505c0-.014.02-.014.02 0l.193 4.505v.007a1.522 1.522 0 0 1-.203.217Z" })));
}, InviteUser: function(e) {
  return c.createElement("svg", Pr({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), c2 || (c2 = c.createElement("path", { fill: "currentColor", d: "M8.418 7.428a3.5 3.5 0 1 0-3.836-5.856 3.5 3.5 0 0 0 3.836 5.856ZM3.091 8.562c.308-.357.838-.339 1.252-.112.64.35 1.375.55 2.157.55s1.517-.2 2.157-.55c.414-.227.944-.245 1.252.112.11.128.214.263.31.403A1.996 1.996 0 0 0 9.5 10.5 2 2 0 0 0 8.177 14H2v-2.5c0-1.123.411-2.15 1.091-2.938Z" })), s2 || (s2 = c.createElement("path", { fill: "currentColor", d: "M10.5 10.5a.998.998 0 0 1 1-1 1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 1 1 0-2h1v-1Z" })));
}, Key: function(e) {
  return c.createElement("svg", Sr({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), u2 || (u2 = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M6.015 10.03c.652 0 1.267-.155 1.811-.43l1.512 1.51-.921.921a.669.669 0 0 0 0 .946l.827.827a.669.669 0 0 0 .946 0l.92-.92.75.749a1.254 1.254 0 0 0 1.773-1.773L9.599 7.827a4.015 4.015 0 1 0-3.584 2.204Zm-.753-3.513a1.255 1.255 0 1 0 0-2.51 1.255 1.255 0 0 0 0 2.51Z", clipRule: "evenodd" })));
}, Laptop: function(e) {
  return c.createElement("svg", Nr({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), f2 || (f2 = c.createElement("path", { fill: "currentColor", d: "M5 6a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5A.5.5 0 0 1 5 6ZM5.5 7.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Z" })), d2 || (d2 = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M3 2.5a1 1 0 0 0-1 1v7.813l-.29.49a.91.91 0 0 0-.068.1L1 13a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1l-.642-1.096a.901.901 0 0 0-.067-.1L14 11.313V3.5a1 1 0 0 0-1-1H3ZM12.5 4h-9v6.5h9V4Z", clipRule: "evenodd" })));
}, LightningBolt: function(e) {
  return c.createElement("svg", zr({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), g2 || (g2 = c.createElement("path", { fill: "currentColor", d: "M9.223 1.993c0-.497-.66-.68-.922-.256l-4.227 6.85a.493.493 0 0 0 .423.75h2.28v4.67c0 .497.66.68.921.257l4.228-6.852a.492.492 0 0 0-.424-.75h-2.28V1.993Z" })));
}, Link: function(e) {
  return c.createElement("svg", Hr({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), h2 || (h2 = c.createElement("path", { fill: "currentColor", d: "M6.039 9.953a3.596 3.596 0 0 1-.327-.38l1.45-1.445a1.553 1.553 0 0 0 2.496.423l2.885-2.87a1.57 1.57 0 0 0 .01-2.213 1.553 1.553 0 0 0-2.203-.01l-.379.377A.995.995 0 0 1 8.56 3.83a1.005 1.005 0 0 1 .006-1.418l.38-.377a3.542 3.542 0 0 1 5.024.023 3.58 3.58 0 0 1-.022 5.047l-2.884 2.871a3.542 3.542 0 0 1-5.025-.022Z" })), p2 || (p2 = c.createElement("path", { fill: "currentColor", d: "M9.961 6.047c.12.12.228.248.327.38l-1.45 1.445a1.553 1.553 0 0 0-2.496-.423l-2.885 2.87a1.57 1.57 0 0 0-.01 2.213 1.553 1.553 0 0 0 2.203.01l.379-.377a.995.995 0 0 1 1.411.006 1.005 1.005 0 0 1-.006 1.418l-.38.377a3.542 3.542 0 0 1-5.024-.023 3.58 3.58 0 0 1 .022-5.047l2.884-2.871a3.542 3.542 0 0 1 5.025.022Z" })));
}, List: function(e) {
  return c.createElement("svg", Rr({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), v2 || (v2 = c.createElement("path", { fill: "currentColor", d: "M3.125 2.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5ZM3.125 6.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5ZM1.875 12a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0ZM6.625 3a1 1 0 0 0 0 2h6.5a1 1 0 1 0 0-2h-6.5ZM5.625 8a1 1 0 0 1 1-1h6.5a1 1 0 1 1 0 2h-6.5a1 1 0 0 1-1-1ZM6.625 11a1 1 0 1 0 0 2h6.5a1 1 0 1 0 0-2h-6.5Z" })));
}, Lock: function(e) {
  return c.createElement("svg", Ar({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), m2 || (m2 = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M4 7V5a4 4 0 1 1 8 0v2a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1Zm2-2a2 2 0 1 1 4 0v2H6V5Zm2.587 5.81A.999.999 0 0 0 8 9a1 1 0 0 0-.58 1.815v1.852a.583.583 0 0 0 1.167 0V10.81Z", clipRule: "evenodd" })));
}, LogIn: function(e) {
  return c.createElement("svg", Br({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), b2 || (b2 = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1 3a1 1 0 0 1 1-1h4.25a.75.75 0 0 1 .75.75v.5a.75.75 0 0 1-.75.75H3v8h3.25a.75.75 0 0 1 .75.75v.5a.75.75 0 0 1-.75.75H2a1 1 0 0 1-1-1V3Z", clipRule: "evenodd" })), y2 || (y2 = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9.495 4.116 6.293 7.318a1 1 0 0 0 0 1.414l3.202 3.202a.75.75 0 0 0 1.06 0l.354-.353a.75.75 0 0 0 0-1.061L9.389 9h4.861a.75.75 0 0 0 .75-.75v-.5a.75.75 0 0 0-.75-.75H9.44l1.469-1.47a.75.75 0 0 0 0-1.06l-.354-.354a.75.75 0 0 0-1.06 0Z", clipRule: "evenodd" })));
}, LogOut: function(e) {
  return c.createElement("svg", Dr({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), w2 || (w2 = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1.5 3c0-.552.446-1 .995-1h4.23c.412 0 .746.336.746.75v.5c0 .414-.334.75-.746.75H3.49v8h3.235c.412 0 .746.336.746.75v.5c0 .414-.334.75-.746.75h-4.23a.998.998 0 0 1-.995-1V3Z", clipRule: "evenodd" })), O2 || (O2 = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "m11.022 11.909 3.187-3.202a1.003 1.003 0 0 0 0-1.414L11.022 4.09a.744.744 0 0 0-1.056 0l-.352.354a.753.753 0 0 0 0 1.06l1.513 1.52H6.29a.748.748 0 0 0-.746.75v.5c0 .414.334.75.746.75h4.788l-1.463 1.47a.753.753 0 0 0 0 1.06l.352.354a.744.744 0 0 0 1.056 0Z", clipRule: "evenodd" })));
}, MagnifyingGlass: function(e) {
  return c.createElement("svg", Vr({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), x2 || (x2 = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M2.323 9.819a5.302 5.302 0 0 0 6.463.805l4.144 4.144a1.3 1.3 0 1 0 1.838-1.838l-4.144-4.144a5.302 5.302 0 0 0-8.3-6.463 5.3 5.3 0 0 0 0 7.496ZM7.98 4.162A2.7 2.7 0 1 1 4.162 7.98 2.7 2.7 0 0 1 7.98 4.162Z", clipRule: "evenodd" })));
}, Megaphone: function(e) {
  return c.createElement("svg", Tr({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), j2 || (j2 = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "m6 3 5.725-1.636A1 1 0 0 1 13 2.326v7.348a1 1 0 0 1-1.275.962L6 9H3a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3Zm-.657 7H3v5h2.98a1 1 0 0 0 .918-1.396L5.343 10ZM16 6a2 2 0 0 1-2 2V4a2 2 0 0 1 2 2Z", clipRule: "evenodd" })));
}, Menu: function(e) {
  return c.createElement("svg", Fr({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), $2 || ($2 = c.createElement("path", { fill: "currentColor", d: "M2 4a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1ZM2 8a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1ZM3 11a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2H3Z" })));
}, Minus: function(e) {
  return c.createElement("svg", Ir({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), E2 || (E2 = c.createElement("path", { fill: "currentColor", d: "M3 6.5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H3Z" })));
}, Mobile: function(e) {
  return c.createElement("svg", _r({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), C2 || (C2 = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M11 3H5v10h6V3ZM5 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H5Z", clipRule: "evenodd" })));
}, MultiDirectionArrow: function(e) {
  return c.createElement("svg", Gr({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), k2 || (k2 = c.createElement("path", { fill: "currentColor", d: "M5 8.573v4.854c0 .53-.608.774-.928.374L2.13 11.374a.607.607 0 0 1 0-.748l1.943-2.427c.32-.4.928-.155.928.374Z" })), M2 || (M2 = c.createElement("path", { fill: "currentColor", d: "M5 10h7.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H5v-2ZM11 7.427V2.573c0-.53.608-.775.928-.374l1.943 2.427a.607.607 0 0 1 0 .748l-1.943 2.427c-.32.4-.928.155-.928-.374ZM3 4.5a.5.5 0 0 1 .5-.5H11v2H3.5a.5.5 0 0 1-.5-.5v-1Z" })));
}, MultiLayers: function(e) {
  return c.createElement("svg", Ur({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), L2 || (L2 = c.createElement("path", { fill: "currentColor", d: "m12.431 9.745-.26-.121.26-.122a1.99 1.99 0 0 0 .758-.597c.197-.252.311-.576.311-.9 0-.324-.114-.637-.311-.9a2.073 2.073 0 0 0-.758-.597l-.29-.142.217-.101c.301-.142.571-.344.758-.597.197-.253.311-.577.311-.9 0-.324-.114-.638-.311-.9a2.073 2.073 0 0 0-.758-.598L9.194 1.763A2.9 2.9 0 0 0 7.97 1.5c-.415 0-.84.08-1.225.263L3.57 3.27c-.301.142-.57.344-.758.597a1.483 1.483 0 0 0-.311.9c0 .324.114.638.311.901.197.253.457.455.758.597l.29.142-.217.1c-.301.142-.571.345-.758.598a1.483 1.483 0 0 0-.311.9c0 .324.114.637.311.9.197.253.457.456.758.597l.259.122-.26.121c-.3.142-.57.344-.757.597a1.484 1.484 0 0 0-.311.9c0 .324.114.638.311.9.197.254.457.456.758.598l3.165 1.497c.384.182.809.263 1.224.263.415 0 .84-.08 1.225-.263l3.165-1.497c.3-.142.57-.344.757-.597.197-.253.312-.577.312-.9 0-.324-.114-.638-.312-.901a2.073 2.073 0 0 0-.757-.597h.01Zm-4.39 3.248c-.207 0-.404-.04-.54-.112l-3.164-1.497c-.114-.05-.166-.111-.187-.132l.02-.02.167-.111 1.36-.637 1.13.536c.384.182.81.263 1.225.263.415 0 .84-.081 1.224-.263l1.132-.536 1.359.637c.114.05.166.111.187.131l-.021.02-.166.112-3.165 1.497a1.28 1.28 0 0 1-.54.112h-.02ZM4.14 8.005l.02-.02.166-.111 1.318-.628 1.1.516c.384.182.81.263 1.225.263.415 0 .84-.08 1.224-.263l1.173-.556 1.39.657c.115.051.167.112.187.132l-.02.02-.166.111-3.165 1.498a1.28 1.28 0 0 1-.54.111c-.208 0-.405-.04-.54-.111L4.347 8.126c-.114-.05-.166-.11-.187-.131l-.02.01Zm-.073-3.237.02-.02.167-.112L7.419 3.14a1.28 1.28 0 0 1 .54-.111c.207 0 .404.04.54.11l3.164 1.498c.114.05.166.111.187.132l-.02.02-.167.111-3.165 1.497a1.28 1.28 0 0 1-.54.112c-.207 0-.404-.04-.54-.112L4.255 4.9c-.114-.05-.166-.111-.187-.131Z" })));
}, NavCollapse: function(e) {
  return c.createElement("svg", Wr({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Z2 || (Z2 = c.createElement("path", { fill: "currentColor", d: "M11.39 4.818a.5.5 0 0 0-.708 0L7.854 7.646a.5.5 0 0 0 0 .708l2.828 2.828a.5.5 0 0 0 .707 0l.354-.354a.5.5 0 0 0 0-.707L9.62 8l2.122-2.121a.5.5 0 0 0 0-.707l-.354-.354Z" })), P2 || (P2 = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M4 1a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3H4Zm1 1.5H4A1.5 1.5 0 0 0 2.5 4v8A1.5 1.5 0 0 0 4 13.5h1v-11Zm1.5 0v11H12a1.5 1.5 0 0 0 1.5-1.5V4A1.5 1.5 0 0 0 12 2.5H6.5Z", clipRule: "evenodd" })));
}, NavExpand: function(e) {
  return c.createElement("svg", Yr({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), S2 || (S2 = c.createElement("path", { fill: "currentColor", d: "M4.61 4.818a.5.5 0 0 1 .708 0l2.828 2.828a.5.5 0 0 1 0 .708l-2.828 2.828a.5.5 0 0 1-.707 0l-.354-.354a.5.5 0 0 1 0-.707L6.38 8 4.257 5.879a.5.5 0 0 1 0-.707l.354-.354Z" })), N2 || (N2 = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12 1a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V4a3 3 0 0 1 3-3h8Zm-1 1.5h1A1.5 1.5 0 0 1 13.5 4v8a1.5 1.5 0 0 1-1.5 1.5h-1v-11Zm-1.5 0v11H4A1.5 1.5 0 0 1 2.5 12V4A1.5 1.5 0 0 1 4 2.5h5.5Z", clipRule: "evenodd" })));
}, NoFilter: function(e) {
  return c.createElement("svg", Xr({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), z2 || (z2 = c.createElement("path", { fill: "currentColor", d: "M2.606 1.204a1 1 0 0 0-1.313 1.503L7 8.414v5.984a.5.5 0 0 0 .83.376l2.949-2.58 2.512 2.511a1 1 0 0 0 1.414-1.414l-1.818-1.818-.006.006L2.606 1.204ZM10.573 7.15A.25.25 0 0 0 11 6.972v-.825l3.8-3.94C15.202 1.79 14.957 1 14.425 1H5.027a.25.25 0 0 0-.176.427l5.722 5.722Z" })));
}, NotAllowed: function(e) {
  return c.createElement("svg", qr({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), H2 || (H2 = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M11.75 8a3.75 3.75 0 0 1-5.485 3.326l5.06-5.06c.272.518.425 1.108.425 1.734ZM4.674 9.735l5.06-5.06a3.75 3.75 0 0 0-5.06 5.06ZM14 8A6 6 0 1 1 2 8a6 6 0 0 1 12 0Z", clipRule: "evenodd" })));
}, Note: function(e) {
  return c.createElement("svg", Kr({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), R2 || (R2 = c.createElement("path", { fill: "currentColor", d: "M4.5 6.25a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75ZM4.5 8.75A.75.75 0 0 1 5.25 8h1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75Z" })), A2 || (A2 = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "m15 10-4 4H3a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6Zm-2-6H3v8h7v-2a1 1 0 0 1 1-1h2V4Z", clipRule: "evenodd" })));
}, OpenNewTab: function(e) {
  return c.createElement("svg", Jr({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), B2 || (B2 = c.createElement("path", { fill: "currentColor", d: "M13.823 2.45a.278.278 0 0 0-.272-.273l-4.045-.079a.277.277 0 0 0-.201.474l1.08 1.08-2.45 2.452a1.395 1.395 0 0 0-.148.174L5.999 8.065a1.369 1.369 0 1 0 1.936 1.936l1.787-1.788c.061-.043.12-.093.174-.147l2.451-2.452 1.081 1.081a.277.277 0 0 0 .474-.201l-.079-4.045Z" })), D2 || (D2 = c.createElement("path", { fill: "currentColor", d: "M7.25 3.129a.75.75 0 0 1 0 1.5H4a.5.5 0 0 0-.5.5v6.864a.5.5 0 0 0 .5.5h6.864a.5.5 0 0 0 .5-.5V8.75a.75.75 0 0 1 1.5 0v3.243a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5.129a2 2 0 0 1 2-2h3.25Z" })));
}, Pause: function(e) {
  return c.createElement("svg", Qr({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), V2 || (V2 = c.createElement("path", { fill: "currentColor", d: "M4.5 2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-1ZM10.5 2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-1Z" })));
}, Person: function(e) {
  return c.createElement("svg", ea({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), T2 || (T2 = c.createElement("path", { fill: "currentColor", d: "M11.5 4.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z" })), F2 || (F2 = c.createElement("path", { fill: "currentColor", d: "M8 8c-.708 0-1.367-.21-1.918-.572A4.483 4.483 0 0 1 8 7c.686 0 1.336.154 1.918.428C9.368 7.79 8.708 8 8 8ZM4.591 8.562c.308-.357.838-.339 1.252-.112C6.483 8.8 7.218 9 8 9s1.517-.2 2.158-.55c.413-.227.943-.245 1.251.112A4.482 4.482 0 0 1 12.5 11.5V14h-9v-2.5c0-1.123.411-2.15 1.091-2.938Z" })));
}, PersonGroup: function(e) {
  return c.createElement("svg", na({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), I2 || (I2 = c.createElement("path", { fill: "currentColor", d: "M4.808 8.923a2.962 2.962 0 1 0 0-5.923 2.962 2.962 0 0 0 0 5.923ZM2.982 9.304c-.35-.192-.798-.207-1.059.095A3.793 3.793 0 0 0 1 11.885V14h7.615v-2.115c0-.95-.347-1.819-.923-2.486-.26-.302-.708-.287-1.059-.095a3.79 3.79 0 0 1-1.825.465 3.79 3.79 0 0 1-1.826-.465ZM9.615 11.885V13H15v-1.906c0-.734-.274-1.405-.727-1.92-.206-.234-.559-.222-.835-.074-.427.23-.917.36-1.438.36-.521 0-1.011-.13-1.438-.36-.276-.148-.63-.16-.835.073-.21.239-.38.51-.504.806.252.585.392 1.23.392 1.906ZM14.333 6.288c0 1.264-1.044 2.289-2.333 2.289-1.289 0-2.333-1.025-2.333-2.289C9.667 5.025 10.71 4 12 4c1.289 0 2.333 1.025 2.333 2.288Z" })));
}, PersonWithLock: function(e) {
  return c.createElement("svg", ta({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), _2 || (_2 = c.createElement("path", { fill: "currentColor", d: "M10 4.5A3.497 3.497 0 0 1 6.5 8a3.484 3.484 0 0 1-1.918-.572A3.5 3.5 0 1 1 10 4.5ZM4.343 8.45c-.414-.227-.944-.245-1.252.112A4.482 4.482 0 0 0 2 11.5V14h6v-2.5c0-.445.194-.845.502-1.12.033-.82.393-1.554.954-2.076-.259-.051-.55.01-.799.146A4.48 4.48 0 0 1 6.5 9a4.48 4.48 0 0 1-2.157-.55Z" })), G2 || (G2 = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9.5 10.5v.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5v-.5a2 2 0 1 0-4 0Zm2-1a1 1 0 0 0-1 1v.5h2v-.5a1 1 0 0 0-1-1Z", clipRule: "evenodd" })));
}, Pin: function(e) {
  return c.createElement("svg", ra({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), U2 || (U2 = c.createElement("path", { fill: "currentColor", d: "M10 8.5V3.3h.683a.65.65 0 1 0 0-1.3H5.317a.65.65 0 1 0 0 1.3H6v5.2L4.383 9.55a.843.843 0 0 0 .46 1.55h2.624v3.367a.533.533 0 0 0 1.066 0V11.1h2.624a.843.843 0 0 0 .46-1.55L10 8.5Z" })));
}, Play: function(e) {
  return c.createElement("svg", aa({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), W2 || (W2 = c.createElement("path", { fill: "currentColor", d: "M13.779 6.704a1.5 1.5 0 0 1 0 2.592l-7.523 4.388A1.5 1.5 0 0 1 4 12.388V3.612a1.5 1.5 0 0 1 2.256-1.296l7.523 4.388Z" })));
}, Plus: function(e) {
  return c.createElement("svg", oa({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Y2 || (Y2 = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7.5 2a1 1 0 0 0-1 1v3.5H3a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h3.5V13a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V9.5H13a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H9.5V3a1 1 0 0 0-1-1h-1Z", clipRule: "evenodd" })));
}, PlusWithCircle: function(e) {
  return c.createElement("svg", la({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), X2 || (X2 = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14ZM7 5a1 1 0 0 1 2 0v2h2a1 1 0 1 1 0 2H9v2a1 1 0 1 1-2 0V9H5a1 1 0 1 1 0-2h2V5Z", clipRule: "evenodd" })));
}, Primary: function(e) {
  return c.createElement("svg", ia({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), q2 || (q2 = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Zm3-8.307C11 5.172 9.918 4 8.433 4H6v8h1.495V9.386h.938C9.918 9.386 11 8.214 11 6.693Zm-1.454 0c0 .653-.453 1.16-1.134 1.16h-.917v-2.32h.917c.68 0 1.134.506 1.134 1.16Z", clipRule: "evenodd" })));
}, Project: function(e) {
  return c.createElement("svg", ca({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), K2 || (K2 = c.createElement("path", { fill: "currentColor", d: "M1 2a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-13A.5.5 0 0 1 1 4V2Z" })), J2 || (J2 = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M2.75 5.5a.75.75 0 0 0-.75.75v7.5c0 .414.336.75.75.75h10.5a.75.75 0 0 0 .75-.75v-7.5a.75.75 0 0 0-.75-.75H2.75ZM6.25 7a.5.5 0 0 0 0 1h3.5a.5.5 0 0 0 0-1h-3.5Z", clipRule: "evenodd" })));
}, QuestionMarkWithCircle: function(e) {
  return c.createElement("svg", sa({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Q2 || (Q2 = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14ZM6.932 5.612C7.054 5.298 7.425 5 7.942 5 8.615 5 9 5.478 9 5.875c0 .162-.057.33-.172.476a.985.985 0 0 1-.242.216l-.016.01a1.141 1.141 0 0 1-.098.054c-.59.286-1.53.967-1.53 2.119V9a1 1 0 0 0 2 0c0-.035.011-.12.138-.27a2.66 2.66 0 0 1 .587-.48 3 3 0 0 0 .726-.656A2.742 2.742 0 0 0 11 5.875C11 4.201 9.54 3 7.941 3c-1.275 0-2.43.745-2.873 1.888a1 1 0 1 0 1.864.724ZM8 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z", clipRule: "evenodd" })));
}, Read: function(e) {
  return c.createElement("svg", ua({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), e5 || (e5 = c.createElement("path", { fill: "currentColor", d: "M10.011 8.762V4.185h-1.39c-.574 0-.84-.645-.406-.985l2.63-2.063a.669.669 0 0 1 .81 0l2.63 2.063c.433.34.168.985-.405.985h-1.31v4.577c0 .716-.572 1.297-1.28 1.297-.706 0-1.279-.58-1.279-1.297ZM8.823 9.158c-.814.19-1.677.283-2.448.283-1.162 0-2.534-.212-3.63-.646-.465-.184-.897-.415-1.245-.7v1.758c0 .27.12.529.384.783.267.258.664.491 1.157.686.983.39 2.252.59 3.334.59 1.082 0 2.35-.2 3.334-.59.2-.079.383-.164.548-.254a2.53 2.53 0 0 1-1.434-1.91Z" })), n5 || (n5 = c.createElement("path", { fill: "currentColor", d: "M6.787 3.479a10.514 10.514 0 0 0-.412-.008c-2.404 0-4.875.823-4.875 2.562 0 .077 0 .152.002.225a2.117 2.117 0 0 0-.002.095v.206c0 .27.12.529.384.783.267.258.664.491 1.157.686.983.39 2.252.59 3.334.59.768 0 1.63-.101 2.418-.299V5.421H8.62c-.767 0-1.428-.45-1.706-1.125-.107-.26-.15-.54-.128-.817ZM11.25 11.39c-.348.284-.78.515-1.245.7-1.096.433-2.468.645-3.63.645s-2.534-.212-3.63-.646c-.465-.184-.897-.415-1.245-.7v.729c0 .028 0 .056.002.084l-.002.236C1.5 14.177 3.971 15 6.375 15s4.875-.823 4.875-2.562c0-.076 0-.152-.002-.226l.002-.094v-.729Z" })));
}, Recommended: function(e) {
  return c.createElement("svg", fa({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), t5 || (t5 = c.createElement("path", { fill: "currentColor", d: "m8.148 5.458-.944 1.968V9.59h2.099a.5.5 0 0 0 .491-.407l.223-1.182a.5.5 0 0 0-.491-.593h-.638a.623.623 0 0 1-.61-.636V5.708a.302.302 0 0 0-.13-.25Z" })), r5 || (r5 = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8.538 1.554a.75.75 0 0 0-1.076 0L6.4 2.648a.75.75 0 0 1-.615.224L4.27 2.716a.75.75 0 0 0-.824.692l-.11 1.52a.75.75 0 0 1-.328.567l-1.261.856a.75.75 0 0 0-.187 1.06l.893 1.235a.75.75 0 0 1 .113.644l-.416 1.467a.75.75 0 0 0 .538.932l1.478.373a.75.75 0 0 1 .501.42l.624 1.39a.75.75 0 0 0 1.011.369l1.372-.665a.75.75 0 0 1 .654 0l1.372.665a.75.75 0 0 0 1.011-.368l.624-1.391a.75.75 0 0 1 .5-.42l1.48-.373a.75.75 0 0 0 .537-.932l-.416-1.467a.75.75 0 0 1 .114-.644l.892-1.235a.75.75 0 0 0-.187-1.06l-1.261-.856a.75.75 0 0 1-.327-.566l-.11-1.52a.75.75 0 0 0-.825-.693l-1.517.156a.75.75 0 0 1-.614-.224L8.538 1.554Zm-1.064 3.28a.577.577 0 0 1 .518-.334c.639 0 1.157.54 1.157 1.208V6.5h.98c.549 0 .96.523.854 1.085l-.412 2.182a.881.881 0 0 1-.854.733H5.435c-.24 0-.435-.294-.435-.546V7.591c0-.251.195-.455.435-.455h.898c.013 0 .027 0 .04.002a.702.702 0 0 1 .03-.072l1.071-2.232Z", clipRule: "evenodd" })));
}, Redo: function(e) {
  return c.createElement("svg", da({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), a5 || (a5 = c.createElement("path", { fill: "currentColor", d: "M4.018 9.402c-.05.328-.313.598-.645.598h-.8c-.331 0-.603-.27-.57-.6a5.996 5.996 0 0 1 2.543-4.325A5.997 5.997 0 0 1 7.974 4h.028c2.699 0 4.95 1.718 5.467 4h1.414c.541 0 .792.672.383 1.026l-2.482 2.15a.585.585 0 0 1-.765 0l-2.482-2.15A.584.584 0 0 1 9.92 8h1.446c-.468-1.085-1.68-2-3.364-2a3.98 3.98 0 0 0-2.543.89 3.996 3.996 0 0 0-1.441 2.512Z" })));
}, Refresh: function(e) {
  return c.createElement("svg", ga({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), o5 || (o5 = c.createElement("path", { fill: "currentColor", d: "M8.033 2c2.699 0 4.95 1.718 5.467 4h1.414c.542 0 .792.672.383 1.026l-2.482 2.15a.584.584 0 0 1-.765 0l-2.482-2.15A.584.584 0 0 1 9.951 6h1.447c-.469-1.085-1.68-2-3.365-2-1.026 0-1.877.34-2.491.85-.243.202-.618.203-.817-.043l-.61-.754a.468.468 0 0 1 .044-.651C5.163 2.534 6.53 2 8.033 2ZM3.95 6.843a.584.584 0 0 0-.765 0L.703 8.992a.584.584 0 0 0 .383 1.026h1.418C3.03 12.291 5.275 14 7.967 14c1.505 0 2.87-.534 3.874-1.402a.468.468 0 0 0 .044-.65l-.61-.755c-.2-.246-.574-.245-.817-.043-.614.51-1.465.85-2.49.85-1.676 0-2.883-.904-3.358-1.982H6.05a.584.584 0 0 0 .383-1.026L3.95 6.842Z" })));
}, Relationship: function(e) {
  return c.createElement("svg", ha({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), l5 || (l5 = c.createElement("path", { fill: "currentColor", d: "M.5 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1H6a2.5 2.5 0 0 1 2.5 2.5v5A1.5 1.5 0 0 0 10 12h1.5v-1a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-1H10a2.5 2.5 0 0 1-2.5-2.5v-5A1.5 1.5 0 0 0 6 4H4.5v1a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V2Z" })));
}, ReplicaSet: function(e) {
  return c.createElement("svg", pa({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), i5 || (i5 = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9.39 7.713A3.488 3.488 0 0 1 8 8c-.494 0-.964-.102-1.39-.287L5.264 9.729a2.5 2.5 0 1 1-1.08-.634L5.57 7.02a3.5 3.5 0 1 1 4.86 0l1.385 2.076A2.501 2.501 0 0 1 15 11.5a2.5 2.5 0 1 1-4.265-1.77L9.391 7.712ZM9.75 4.5a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z", clipRule: "evenodd" })));
}, Resize: function(e) {
  return c.createElement("svg", va({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), c5 || (c5 = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M14.77 5.72a.75.75 0 0 1 0 1.06l-7.991 8a.749.749 0 1 1-1.06-1.06l7.992-8a.749.749 0 0 1 1.06 0ZM14.78 10.22a.75.75 0 0 1 0 1.06l-3.496 3.5a.749.749 0 1 1-1.06-1.06l3.497-3.5a.749.749 0 0 1 1.06 0Z", clipRule: "evenodd" })));
}, Return: function(e) {
  return c.createElement("svg", ma({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), s5 || (s5 = c.createElement("path", { fill: "currentColor", d: "M5 2a1 1 0 0 0 0 2h5a2.5 2.5 0 0 1 0 5H5.203l1.448-1.24a1 1 0 1 0-1.302-1.52l-3.5 3a1 1 0 0 0 0 1.52l3.5 3a1 1 0 0 0 1.302-1.52L5.203 11H10a4.5 4.5 0 1 0 0-9H5Z" })));
}, Save: function(e) {
  return c.createElement("svg", ba({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), u5 || (u5 = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M2 3.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C2.76 2 3.04 2 3.6 2h7.737c.245 0 .367 0 .482.028a1 1 0 0 1 .29.12c.1.061.187.148.36.32l1.062 1.063c.173.173.26.26.322.36.055.09.095.188.12.29.027.115.027.237.027.482V12.4c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437c-.2.102-.46.109-.954.109V9.284c0-.126 0-.25-.008-.353a1.01 1.01 0 0 0-.101-.385 1 1 0 0 0-.437-.437 1.01 1.01 0 0 0-.385-.1C11.465 8 11.342 8 11.216 8H4.784c-.126 0-.249 0-.353.008a1.01 1.01 0 0 0-.385.101 1 1 0 0 0-.437.437 1.01 1.01 0 0 0-.1.385c-.009.104-.009.227-.009.353V14c-.494 0-.753-.007-.954-.109a1 1 0 0 1-.437-.437C2 13.24 2 12.96 2 12.4V3.6Zm2-.1a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5H4Z", clipRule: "evenodd" })), f5 || (f5 = c.createElement("path", { fill: "currentColor", d: "M11.5 9.3V14h-7V9.3c0-.148 0-.23.005-.288v-.006h.007C4.571 9 4.652 9 4.8 9h6.4c.148 0 .23 0 .288.005h.006v.007c.006.059.006.14.006.288Z" })));
}, Serverless: function(e) {
  return c.createElement("svg", Oa({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), m5 || (m5 = c.createElement("path", { fill: "currentColor", d: "M2.132 10.849a5.5 5.5 0 1 1 8.4-6.571 4 4 0 0 1 4.398 6.444 1 1 0 0 1-.15.192l-1.77 1.898a1.995 1.995 0 0 1-1.51.688H7.792a2.5 2.5 0 1 1 0-2H11.5l1.166-1.25H8.5a3.75 3.75 0 0 0-6.368.599Z" })));
}, ShardedCluster: function(e) {
  return c.createElement("svg", ja({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), y5 || (y5 = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M13 2.75a1.75 1.75 0 0 1-2.123 1.71l-.619.866a3.497 3.497 0 0 1 1.186 2.049h1.17a1.75 1.75 0 1 1 0 1.25h-1.17a3.497 3.497 0 0 1-1.186 2.05l.619.865a1.75 1.75 0 1 1-1.046.686l-.662-.926a3.495 3.495 0 0 1-2.331.002l-.664.93a1.75 1.75 0 1 1-1.043-.69l.616-.863a3.497 3.497 0 0 1-1.191-2.054h-1.17a1.75 1.75 0 1 1 0-1.25h1.17c.147-.819.58-1.54 1.191-2.054l-.616-.863a1.75 1.75 0 1 1 1.043-.69l.664.93A3.494 3.494 0 0 1 8 4.5c.41 0 .803.07 1.17.2l.66-.926A1.75 1.75 0 1 1 13 2.75ZM9.75 8a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z", clipRule: "evenodd" })));
}, SearchIndex: function(e) {
  return c.createElement("svg", ya({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), d5 || (d5 = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8.816 12.754a2.786 2.786 0 0 0 3.396.424l1.622 1.622a.683.683 0 1 0 .966-.966l-1.622-1.622a2.786 2.786 0 1 0-4.362.542Zm2.972-2.972a1.419 1.419 0 1 1-2.006 2.006 1.419 1.419 0 0 1 2.006-2.006Z", clipRule: "evenodd" })), g5 || (g5 = c.createElement("path", { fill: "currentColor", d: "M12 3.667c0 .083 0 .165-.002.245L12 4v.214c0 .281-.124.55-.393.815-.275.27-.682.512-1.187.715-1.01.405-2.31.613-3.42.613-1.11 0-2.41-.208-3.42-.613-.505-.203-.912-.446-1.187-.715C2.123 4.765 2 4.495 2 4.214V4c0-.033 0-.066.002-.099A12.44 12.44 0 0 1 2 3.667C2 1.857 4.534 1 7 1s5 .857 5 2.667Z" })), h5 || (h5 = c.createElement("path", { fill: "currentColor", d: "M2 5.813v1.83c0 .28.124.55.393.815.275.269.682.511 1.187.714 1.01.406 2.31.614 3.42.614l.134-.001A3.785 3.785 0 0 1 12 7.2V5.812c-.357.297-.8.537-1.277.729-1.124.452-2.532.672-3.723.672-1.191 0-2.599-.22-3.723-.672C2.8 6.35 2.357 6.11 2 5.813ZM7 10.643h.003c-.03.816.201 1.64.696 2.334-.232.015-.466.023-.699.023-2.466 0-5-.857-5-2.667 0-.083 0-.165.002-.245A2.229 2.229 0 0 1 2 10v-.758c.357.297.8.537 1.277.729 1.124.451 2.532.672 3.723.672Z" })));
}, Secondary: function(e) {
  return c.createElement("svg", wa({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), p5 || (p5 = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 13.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11ZM8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Z", clipRule: "evenodd" })), v5 || (v5 = c.createElement("path", { fill: "currentColor", d: "M11 9.67C11 11.112 9.786 12 8.117 12 6.337 12 5.07 10.897 5 9.395h1.972c.07.674.594.996 1.2.996.594 0 .897-.245.897-.613 0-.399-.262-.598-.869-.767l-1.297-.367c-1.2-.337-1.751-1.257-1.751-2.376C5.152 4.95 6.2 4 7.924 4c1.517 0 2.676.889 2.786 2.421H8.807c-.097-.582-.497-.781-.91-.781-.483 0-.814.214-.814.582 0 .43.372.598.786.705l1.214.368C10.434 7.678 11 8.475 11 9.671Z" })));
}, Settings: function(e) {
  return c.createElement("svg", xa({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), b5 || (b5 = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M10.207 1.067a.75.75 0 0 0-.89.247l-.374.506a6.214 6.214 0 0 0-1.894.002l-.375-.506a.75.75 0 0 0-.89-.246l-1.126.467a.75.75 0 0 0-.454.804l.093.623c-.505.37-.958.82-1.338 1.34l-.623-.093a.75.75 0 0 0-.803.455l-.466 1.127a.75.75 0 0 0 .247.89l.506.374a6.214 6.214 0 0 0 .002 1.893l-.506.376a.75.75 0 0 0-.246.89l.467 1.126a.75.75 0 0 0 .804.454l.623-.093c.37.505.82.958 1.34 1.338l-.093.623a.75.75 0 0 0 .455.803l1.127.466a.75.75 0 0 0 .89-.247l.374-.506a6.218 6.218 0 0 0 1.894-.002l.375.506a.75.75 0 0 0 .89.246l1.126-.467a.75.75 0 0 0 .454-.804l-.093-.623c.505-.37.958-.82 1.338-1.34l.623.093a.75.75 0 0 0 .803-.455l.466-1.127a.75.75 0 0 0-.247-.89l-.506-.374a6.218 6.218 0 0 0-.002-1.894l.506-.375a.75.75 0 0 0 .246-.89l-.467-1.126a.75.75 0 0 0-.804-.454l-.623.093a6.214 6.214 0 0 0-1.34-1.338l.093-.623a.75.75 0 0 0-.455-.803l-1.127-.466Zm.334 7.984A2.75 2.75 0 1 1 5.46 6.949a2.75 2.75 0 0 1 5.082 2.102Z", clipRule: "evenodd" })));
}, Shell: function(e) {
  return c.createElement("svg", $a({ width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), w5 || (w5 = c.createElement("path", { fill: "currentColor", d: "m1.8 5.2 3.4 2.2-3.79 2.526a.5.5 0 0 0-.142.688l.557.86a.5.5 0 0 0 .697.145L7.5 8.3c.3-.2.5-.5.5-.8 0-.3-.2-.6-.4-.8L2.522 3.284a.5.5 0 0 0-.699.143l-.547.847a.5.5 0 0 0 .155.695L1.8 5.2ZM6.7 13a.5.5 0 0 0 .5.5h7.7a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H7.2a.5.5 0 0 0-.5.5v1Z" })));
}, SMS: function(e) {
  return c.createElement("svg", Ea({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), O5 || (O5 = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1 4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H7.755L4.23 14.831c-.488.392-1.23.058-1.23-.555V12a2 2 0 0 1-2-2V4Zm2 .75A.75.75 0 0 1 3.75 4h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 3 4.75Zm0 3A.75.75 0 0 1 3.75 7h5.5a.75.75 0 1 1 0 1.5h-5.5A.75.75 0 0 1 3 7.75Z", clipRule: "evenodd" })));
}, SortAscending: function(e) {
  return c.createElement("svg", Ca({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), x5 || (x5 = c.createElement("path", { fill: "currentColor", d: "M4.45 1.143a.584.584 0 0 0-.765 0L1.203 3.292a.584.584 0 0 0 .383 1.026h1.312v9.352a1.169 1.169 0 1 0 2.338 0V4.318H6.55a.584.584 0 0 0 .383-1.026L4.45 1.142ZM8 5a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2H8ZM7 9a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1ZM8 11a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2H8Z" })));
}, SortDescending: function(e) {
  return c.createElement("svg", ka({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), j5 || (j5 = c.createElement("path", { fill: "currentColor", d: "M4.45 14.696a.584.584 0 0 1-.765 0l-2.482-2.15a.584.584 0 0 1 .383-1.025h1.312V2.168a1.169 1.169 0 1 1 2.338 0v9.351H6.55c.541 0 .792.673.383 1.027L4.45 14.696ZM8 3a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2H8ZM7 7a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1ZM8 9a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2H8Z" })));
}, Sparkle: function(e) {
  return c.createElement("svg", Ma({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), $5 || ($5 = c.createElement("path", { fill: "currentColor", d: "m6.273 2.893-.998 2.995c-.1.3-.336.536-.636.637l-2.995.998a.503.503 0 0 0 0 .954l2.995.998c.3.1.536.336.636.637l.998 2.995a.503.503 0 0 0 .955 0l.998-2.995c.1-.3.336-.536.636-.637l2.995-.998a.503.503 0 0 0 0-.954l-2.995-.998c-.3-.1-.536-.336-.636-.637l-.998-2.995a.503.503 0 0 0-.955 0ZM12.547 1.172l-.231.693c-.1.3-.336.536-.636.636l-.694.231c-.229.077-.229.401 0 .477l.694.231c.3.1.536.336.636.637l.23.693c.077.229.402.229.478 0l.231-.693c.1-.3.336-.536.636-.637l.693-.23c.23-.077.23-.401 0-.478l-.693-.23c-.3-.1-.536-.337-.636-.637l-.231-.693a.251.251 0 0 0-.477 0ZM12.547 11.23l-.231.693c-.1.3-.336.536-.636.636l-.694.232c-.229.076-.229.4 0 .477l.694.23c.3.1.536.337.636.637l.23.693c.077.23.402.23.478 0l.231-.693c.1-.3.336-.536.636-.636l.693-.231c.23-.077.23-.401 0-.477l-.693-.232c-.3-.1-.536-.335-.636-.636l-.231-.693a.251.251 0 0 0-.477 0Z" })));
}, SplitHorizontal: function(e) {
  return c.createElement("svg", La({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 14, fill: "none", viewBox: "0 0 16 16" }, e), E5 || (E5 = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M15 11a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8Zm-2-4.5V3H3v3.5h10Zm-10 1V11h10V7.5H3Z", clipRule: "evenodd" })));
}, SplitVertical: function(e) {
  return c.createElement("svg", Za({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 14, fill: "none", viewBox: "0 0 16 16" }, e), C5 || (C5 = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M13 1a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10ZM7.5 3H3v8h4.5V3Zm1 8H13V3H8.5v8Z", clipRule: "evenodd" })));
}, Stitch: function(e) {
  return c.createElement("svg", Pa({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16" }, e), k5 || (k5 = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M0 0h16v16H0V0Zm14 4V2H2v2h12Zm0 10V5H2v9h12ZM8 6v7H6V6h2Zm5 0v4H9V6h4ZM5 8v5H3V8h2Zm8 3v2H9v-2h4Z" })));
}, String: function(e) {
  return c.createElement("svg", Sa({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), M5 || (M5 = c.createElement("path", { fill: "currentColor", d: "M10.69 14H5.31l-.15-.137v-.754l.15-.138h.602c.376 0 .753-.342.753-.685V3.5h-.903c-2.05 0-2.54.729-2.671 1.826l-.15.137h-.828L2 5.326l.282-3.189.15-.137h11.135l.15.137L14 5.326l-.113.137h-.827l-.15-.137c-.133-1.097-.622-1.826-2.672-1.826h-.903v8.786c0 .343.377.685.753.685h.602l.15.138v.754l-.15.137Z" })));
}, Support: function(e) {
  return c.createElement("svg", Na({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), L5 || (L5 = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M5 7a3 3 0 0 1 6 0v2.5c0 1.51-.957 2.798-2.298 3.288a1 1 0 1 0 .265.967 4.512 4.512 0 0 0 2.787-2.785c.08.02.161.03.246.03h.5a2.5 2.5 0 0 0 .406-4.967 5.002 5.002 0 0 0-9.813 0A2.5 2.5 0 0 0 3.5 11H4a1 1 0 0 0 1-1V7Z", clipRule: "evenodd" })));
}, Sweep: function(e) {
  return c.createElement("svg", za({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Z5 || (Z5 = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M3 14.465 4 12.734c.292.169.631.266.999.266h2v2H5a3.982 3.982 0 0 1-2-.535ZM9 15v-2h2c.368 0 .707-.097.999-.266L13 14.464A3.982 3.982 0 0 1 11 15H9Zm6-8h-2V5c0-.368-.097-.707-.266-.999L14.464 3c.341.588.536 1.271.536 2v2ZM7 1H5c-.729 0-1.412.195-2 .535L4 3.266C4.293 3.097 4.632 3 5 3h2V1ZM1 9h2v2c0 .368.097.707.266.999L1.536 13A3.982 3.982 0 0 1 1 11V9Zm0-2h2V5c0-.368.097-.707.266-.999L1.536 3A3.982 3.982 0 0 0 1 5v2Zm8-6v2h2c.368 0 .707.097.999.266L13 1.536A3.982 3.982 0 0 0 11 1H9Zm6 8h-2v2c0 .368-.097.707-.266.999L14.464 13c.341-.588.536-1.271.536-2V9Z", clipRule: "evenodd" })));
}, Table: function(e) {
  return c.createElement("svg", Ha({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), P5 || (P5 = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1 3.25C1 2.56 1.56 2 2.25 2h11.5c.69 0 1.25.56 1.25 1.25v9.5c0 .69-.56 1.25-1.25 1.25H2.25C1.56 14 1 13.44 1 12.75v-9.5Zm2 4.12V4h4.37v3.37H3Zm0 1.25V12h4.37V8.62H3ZM8.62 12H13V8.62H8.62V12ZM13 7.37V4H8.62v3.37H13Z", clipRule: "evenodd" })));
}, Tag: function(e) {
  return c.createElement("svg", Ra({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), S5 || (S5 = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "m9.707 14.293 4.586-4.586a1 1 0 0 0 0-1.414l-6-6A1 1 0 0 0 7.586 2H3a1 1 0 0 0-1 1v4.586a1 1 0 0 0 .293.707l6 6a1 1 0 0 0 1.414 0ZM5 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z", clipRule: "evenodd" })));
}, ThumbsDown: function(e) {
  return c.createElement("svg", Aa({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), N5 || (N5 = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8.019 15c.511 0 .98-.28 1.208-.724l2.501-4.837c.026-.05.05-.102.07-.155.03.003.06.004.092.004h2.094c.561 0 1.016-.441 1.016-.985V3.182C15 2.638 14.545 2 13.984 2H3.993C3.023 2 2.188 2.666 2 3.589L1.04 8.316c-.247 1.217.713 2.35 1.993 2.35H5.32v1.717C5.32 13.828 6.528 15 8.019 15Zm1.84-6.34-2.205 4.265a.642.642 0 0 1-.303-.542v-2.307c0-.762-.637-1.379-1.422-1.379H3.644a.5.5 0 0 1-.49-.6l.758-3.727a.5.5 0 0 1 .49-.4h5.456v4.69Z", clipRule: "evenodd" })));
}, ThumbsUp: function(e) {
  return c.createElement("svg", Ba({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), z5 || (z5 = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7.981 1c-.511 0-.98.28-1.208.724L4.272 6.56c-.026.05-.05.102-.07.155a1.06 1.06 0 0 0-.092-.004H2.016c-.561 0-1.016.441-1.016.985v5.121C1 13.362 1.455 14 2.016 14h9.991c.97 0 1.805-.665 1.993-1.589l.961-4.727c.248-1.217-.713-2.35-1.993-2.35H10.68V3.616C10.68 2.172 9.472 1 7.981 1Zm-1.84 6.34 2.205-4.265a.642.642 0 0 1 .303.542v2.307c0 .762.637 1.379 1.422 1.379h2.285a.5.5 0 0 1 .49.6l-.758 3.727a.5.5 0 0 1-.49.4H6.142V7.34Z", clipRule: "evenodd" })));
}, TimeSeries: function(e) {
  return c.createElement("svg", Da({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), H5 || (H5 = c.createElement("path", { fill: "currentColor", d: "M7.023 1.518c.513.024.957.363 1.12.853L9.38 6.108l1.56-2.092a1.24 1.24 0 0 1 1.872-.134l1.897 1.91c.388.39.388 1.023 0 1.413l-.377.354a.99.99 0 0 1-1.405 0l-.86-.89-2.122 2.847a1.239 1.239 0 0 1-2.172-.355L6.798 6.22 6.11 7.774c-.2.451-.644.742-1.135.742H1.994a.997.997 0 0 1-.994-1v-.5c0-.552.445-1 .994-1h2.174l1.66-3.758a1.242 1.242 0 0 1 1.195-.74ZM14 12a1 1 0 0 1 1 1v.5a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V13a1 1 0 0 1 1-1h12Z" })));
}, TimeSeriesCollection: function(e) {
  return c.createElement("svg", Va({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), R5 || (R5 = c.createElement("path", { fill: "currentColor", d: "M13.6 10.383H15c.6 0 1 .499 1 1.098 0 .598-.4.998-1 .998h-.9l-1.5 2.096c-.2.3-.6.499-1 .399-.4-.1-.7-.4-.8-.799l-.4-1.696-.4 1.197c-.1.3-.5.6-.9.6H8c-.6 0-1-.4-1-.999s.4-.998 1-.998h.4l1.4-3.693c.1-.4.6-.599 1-.599s.8.4.9.699l.6 2.794.5-.698c.2-.2.5-.4.8-.4Z" })), A5 || (A5 = c.createElement("path", { fill: "currentColor", d: "M1.929 1A.922.922 0 0 0 1 1.915v9.15c0 .505.416.915.929.915H5.84c.101-.173.225-.336.374-.485.322-.321.71-.526 1.118-.63l1.043-2.75c.208-.678.706-1.086 1.107-1.3A2.846 2.846 0 0 1 10.8 6.49c.682 0 1.214.323 1.531.591.318.269.635.66.792 1.131l.026.079.133.617a2.24 2.24 0 0 1 .318-.023h.4v-5.14a.922.922 0 0 0-.929-.915H7.5a.922.922 0 0 1-.929-.915A.922.922 0 0 0 5.643 1H1.929Z" })), B5 || (B5 = c.createElement("path", { fill: "currentColor", d: "M10.95 8.005a.699.699 0 0 0-.066-.012l.065.012Z" })));
}, Trash: function(e) {
  return c.createElement("svg", Ta({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), D5 || (D5 = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M5 2a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1h2a1 1 0 0 1 1 1v1H2V3a1 1 0 0 1 1-1h2Zm9 3H2l1.678 8.392A2 2 0 0 0 5.64 15h4.72a2 2 0 0 0 1.962-1.608L14 5Z", clipRule: "evenodd" })));
}, Undo: function(e) {
  return c.createElement("svg", Fa({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), V5 || (V5 = c.createElement("path", { fill: "currentColor", d: "M11.981 9.402c.05.328.313.598.645.598h.8c.331 0 .603-.27.57-.6a5.996 5.996 0 0 0-2.543-4.325A5.997 5.997 0 0 0 8.026 4h-.029C5.298 4 3.047 5.718 2.53 8H1.116a.584.584 0 0 0-.383 1.026l2.482 2.15c.22.19.545.19.765 0l2.482-2.15A.584.584 0 0 0 6.079 8H4.632c.47-1.085 1.68-2 3.365-2a3.98 3.98 0 0 1 2.543.89 3.996 3.996 0 0 1 1.441 2.512Z" })));
}, University: function(e) {
  return c.createElement("svg", Ia({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), T5 || (T5 = c.createElement("path", { fill: "currentColor", d: "M8.5 4.613c0-.383.191-.74.51-.953a6.87 6.87 0 0 1 2.145-.949l2.406-.601a.353.353 0 0 1 .439.342v7.88c0 .238 0 .357-.043.453a.5.5 0 0 1-.176.211c-.087.06-.204.081-.438.123l-3.9.71c-.324.058-.486.088-.612.042a.5.5 0 0 1-.264-.22c-.067-.116-.067-.28-.067-.61V4.613ZM2 2.452c0-.23.216-.398.439-.342l2.407.601a6.87 6.87 0 0 1 2.144.95c.319.211.51.569.51.952v6.428c0 .33 0 .494-.067.61a.5.5 0 0 1-.264.22c-.126.046-.288.016-.612-.043l-3.9-.709c-.234-.042-.35-.063-.438-.123a.5.5 0 0 1-.176-.21C2 10.688 2 10.57 2 10.331v-7.88ZM2.008 12.41a.5.5 0 0 1 .581-.402l5.143.935c.177.032.359.032.536 0l5.143-.935a.5.5 0 0 1 .178.984l-4.134.752c-.163.434-.753.756-1.455.756-.702 0-1.292-.322-1.455-.756l-4.134-.752a.5.5 0 0 1-.403-.581Z" })));
}, Unlock: function(e) {
  return c.createElement("svg", _a({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), F5 || (F5 = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M6.157 4.221A2 2 0 0 1 10 5v2H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1V5a4 4 0 0 0-7.822-1.182C3.982 4.45 4.538 5 5.2 5c.442 0 .785-.372.957-.779Zm2.43 6.589A.999.999 0 0 0 8 9a1 1 0 0 0-.58 1.815v1.852a.583.583 0 0 0 1.167 0V10.81Z", clipRule: "evenodd" })));
}, Unsorted: function(e) {
  return c.createElement("svg", Ga({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), I5 || (I5 = c.createElement("path", { fill: "currentColor", d: "M3.685 1.143c.22-.19.545-.19.765 0l2.482 2.149a.584.584 0 0 1-.383 1.026H5.236v7.364H6.55c.541 0 .792.672.383 1.026l-2.482 2.15a.584.584 0 0 1-.765 0l-2.482-2.15a.584.584 0 0 1 .383-1.026h1.312V4.318H1.586a.584.584 0 0 1-.383-1.026l2.482-2.15ZM8 8a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1ZM9 4a1 1 0 0 0 0 2h5a1 1 0 1 0 0-2H9ZM8 11a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Z" })));
}, UpDownCarets: function(e) {
  return c.createElement("svg", Ua({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16" }, e), _5 || (_5 = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7.527 1.21a.638.638 0 0 1 .948 0l3.327 3.563c.422.452.123 1.227-.475 1.227H4.673c-.599 0-.898-.775-.476-1.227l3.33-3.562Zm3.8 8.79c.598 0 .897.775.475 1.228l-3.327 3.56a.638.638 0 0 1-.948 0l-3.33-3.56C3.775 10.775 4.074 10 4.673 10h6.654Z" })));
}, Upload: function(e) {
  return c.createElement("svg", Wa({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), G5 || (G5 = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M11.297 11v.938a4 4 0 1 0-.764-7.66A5.501 5.501 0 0 0 0 6.5a5.5 5.5 0 0 0 5.797 5.492V11h-.403c-1.395 0-2.08-1.7-1.075-2.667L7.472 5.3a1.55 1.55 0 0 1 2.15 0l3.152 3.034C13.78 9.301 13.094 11 11.7 11h-.402ZM8.339 6.2a.3.3 0 0 1 .416 0l3.152 3.034a.3.3 0 0 1-.208.516h-1.652v3.75a1.5 1.5 0 0 1-3 0V9.75H5.394a.3.3 0 0 1-.208-.516L8.339 6.2Z", clipRule: "evenodd" })));
}, VerticalEllipsis: function(e) {
  return c.createElement("svg", Ya({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), U5 || (U5 = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9.5 2.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Zm0 5a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0ZM7.75 14.5a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z", clipRule: "evenodd" })));
}, Visibility: function(e) {
  return c.createElement("svg", Xa({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), W5 || (W5 = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 2.008c3.934 0 6.473 3.129 7.455 4.583l.043.064C15.713 6.97 16 7.391 16 8s-.287 1.03-.502 1.345l-.043.064c-.982 1.454-3.521 4.583-7.455 4.583S1.527 10.863.545 9.41l-.043-.064C.287 9.03 0 8.609 0 8s.287-1.03.502-1.345l.043-.064C1.527 5.137 4.066 2.008 8 2.008ZM9.13 4.13A5.147 5.147 0 0 0 8 4.005C5.75 4.005 3.927 5.794 3.927 8c0 2.206 1.824 3.995 4.073 3.995 2.25 0 4.073-1.789 4.073-3.995 0-2.206-1.824-3.995-4.073-3.995.378 0 .756.045 1.13.126ZM8 10.996c1.687 0 3.055-1.341 3.055-2.996S9.687 5.004 8 5.004 4.945 6.345 4.945 8 6.313 10.996 8 10.996Z", clipRule: "evenodd" })));
}, VisibilityOff: function(e) {
  return c.createElement("svg", qa({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), Y5 || (Y5 = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M14.601 1.266a1.03 1.03 0 0 0-1.433.049L1.704 13.486a.987.987 0 0 0 .062 1.407 1.03 1.03 0 0 0 1.433-.049l1.793-1.904A7.348 7.348 0 0 0 8 13.587c3.934 0 6.473-3.133 7.455-4.59l.043-.063c.215-.316.502-.737.502-1.347s-.287-1.03-.502-1.346l-.043-.065a12.85 12.85 0 0 0-1.949-2.275l1.157-1.228a.987.987 0 0 0-.062-1.407Zm-2.93 4.585-.764.81c.096.292.148.603.148.926 0 1.657-1.368 3-3.055 3-.246 0-.485-.028-.714-.082l-.763.81c.458.176.956.272 1.477.272 2.25 0 4.073-1.79 4.073-4 0-.622-.145-1.211-.403-1.736ZM8 1.587c.919 0 1.762.171 2.526.452L8.98 3.68A5.13 5.13 0 0 0 8 3.587c-2.25 0-4.073 1.79-4.073 4 0 .435.07.853.201 1.245l-1.985 2.107A13.06 13.06 0 0 1 .545 8.998l-.043-.064C.287 8.618 0 8.197 0 7.587s.287-1.03.502-1.346l.043-.065C1.527 4.72 4.066 1.587 8 1.587Zm0 2c.327 0 .654.034.978.095l-.016.017A4.155 4.155 0 0 0 8 3.587Zm0 1c.041 0 .083 0 .124.002L4.966 7.942a2.978 2.978 0 0 1-.02-.355c0-1.657 1.367-3 3.054-3Z", clipRule: "evenodd" })));
}, Warning: function(e) {
  return c.createElement("svg", Ka({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), X5 || (X5 = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8.864 1.514a.983.983 0 0 0-1.728 0L1.122 12.539A.987.987 0 0 0 1.986 14h12.028a.987.987 0 0 0 .864-1.461L8.864 1.514ZM7 5a1 1 0 0 1 2 0v4a1 1 0 0 1-2 0V5Zm2 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z", clipRule: "evenodd" })));
}, Wizard: function(e) {
  return c.createElement("svg", Ja({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), q5 || (q5 = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M13.327 3.277c.188-.38-.236-.8-.618-.613l-2.513 1.223a.461.461 0 0 1-.523-.095L7.603 1.74c-.314-.313-.829-.062-.75.365l.517 2.808a.421.421 0 0 1-.228.46L4.63 6.596c-.383.186-.277.761.154.839l2.832.513a.477.477 0 0 1 .382.379l.517 2.808c.079.427.659.532.846.153l1.234-2.492a.427.427 0 0 1 .464-.225l2.832.512c.43.078.683-.432.368-.744l-2.07-2.052a.452.452 0 0 1-.095-.519l1.233-2.491ZM7 10.5c.353-.35.312-.958-.091-1.359-.404-.4-1.017-.44-1.37-.09L1.84 12.713c-.353.35-.312.958.092 1.358.403.4 1.017.44 1.37.09L7 10.5Z", clipRule: "evenodd" })));
}, Wrench: function(e) {
  return c.createElement("svg", Qa({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), K5 || (K5 = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M10.625 9.75a4.374 4.374 0 0 0 4.206-5.584c-.085-.295-.449-.36-.665-.145l-2.1 2.1a.44.44 0 0 1-.184.11c-.078.024-.157-.013-.215-.07L9.84 4.332c-.058-.058-.095-.137-.071-.215a.44.44 0 0 1 .11-.184l2.1-2.1c.216-.216.147-.58-.145-.664a4.374 4.374 0 0 0-5.385 5.512.32.32 0 0 1-.077.32l-4.828 4.829a1.857 1.857 0 0 0 2.625 2.625l4.828-4.828a.32.32 0 0 1 .323-.075c.412.129.851.197 1.305.197ZM2.75 14.125a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75Z", clipRule: "evenodd" })));
}, Write: function(e) {
  return c.createElement("svg", e1({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), J5 || (J5 = c.createElement("path", { fill: "currentColor", d: "M8.71 3.75a9.487 9.487 0 0 0-2.335-.28c-2.404 0-4.875.824-4.875 2.563 0 .077 0 .152.002.225a2.117 2.117 0 0 0-.002.095v.206c0 .27.12.529.384.783.267.258.664.491 1.157.686.983.39 2.252.59 3.334.59.267 0 .546-.013.828-.037a1.76 1.76 0 0 1-.288-1.818 1.826 1.826 0 0 1 1.706-1.125h.09V3.75ZM8.068 9.305c-.578.091-1.158.136-1.693.136-1.162 0-2.534-.212-3.63-.646-.465-.184-.897-.415-1.245-.7v1.758c0 .27.12.529.384.783.267.258.664.491 1.157.686.983.39 2.252.59 3.334.59 1.082 0 2.35-.2 3.334-.59.22-.086.42-.18.598-.282a1.85 1.85 0 0 1-.209-.141l-2.03-1.594Z" })), Q5 || (Q5 = c.createElement("path", { fill: "currentColor", d: "M11.25 11.39c-.348.284-.78.515-1.245.7-1.096.433-2.468.645-3.63.645s-2.534-.212-3.63-.646c-.465-.184-.897-.415-1.245-.7v.729c0 .028 0 .056.002.084l-.002.236C1.5 14.177 3.971 15 6.375 15s4.875-.823 4.875-2.562c0-.076 0-.152-.002-.226l.002-.094v-.729ZM12.489 2.297v4.576h1.39c.574 0 .84.646.406.986l-2.63 2.063a.668.668 0 0 1-.81 0l-2.63-2.063c-.433-.34-.168-.986.406-.986H9.93V2.297C9.93 1.58 10.502 1 11.21 1c.706 0 1.279.58 1.279 1.297Z" })));
}, X: function(e) {
  return c.createElement("svg", n1({ xmlns: "http://www.w3.org/2000/svg", width: 17, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), eu || (eu = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12.203 3.404a1 1 0 0 0-1.414 0L8.314 5.879 5.839 3.404a1 1 0 0 0-1.414 0l-.707.707a1 1 0 0 0 0 1.414L6.192 8l-2.474 2.475a1 1 0 0 0 0 1.414l.707.707a1 1 0 0 0 1.414 0l2.475-2.475 2.475 2.475a1 1 0 0 0 1.414 0l.707-.707a1 1 0 0 0 0-1.414L10.435 8l2.475-2.475a1 1 0 0 0 0-1.414l-.707-.707Z", clipRule: "evenodd" })));
}, XWithCircle: function(e) {
  return c.createElement("svg", t1({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16" }, e), nu || (nu = c.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Zm1.414-9.828a1 1 0 1 1 1.414 1.414L9.414 8l1.414 1.414a1 1 0 1 1-1.414 1.414L8 9.414l-1.414 1.414a1 1 0 1 1-1.414-1.414L6.586 8 5.172 6.586a1 1 0 0 1 1.414-1.414L8 6.586l1.414-1.414Z", clipRule: "evenodd" })));
} }, ph = Object.keys(tu).reduce(function(e, t) {
  return e[t] = i1(t, tu[t]), e;
}, {});
hh(ph);
var Cf = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(w, _e, Ie);
  })(Te, function(n, r, u) {
    function d(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function p(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var i = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(o) {
        if (o !== "default") {
          var f = Object.getOwnPropertyDescriptor(a, o);
          Object.defineProperty(i, o, f.get ? f : { enumerable: !0, get: function() {
            return a[o];
          } });
        }
      }), i.default = a, Object.freeze(i);
    }
    var v = p(n), g = d(r);
    function m(a) {
      var i = function(o, f) {
        if (typeof o != "object" || !o)
          return o;
        var j = o[Symbol.toPrimitive];
        if (j !== void 0) {
          var x = j.call(o, f || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (f === "string" ? String : Number)(o);
      }(a, "string");
      return typeof i == "symbol" ? i : i + "";
    }
    function h(a, i, o) {
      return (i = m(i)) in a ? Object.defineProperty(a, i, { value: o, enumerable: !0, configurable: !0, writable: !0 }) : a[i] = o, a;
    }
    function b() {
      return b = Object.assign ? Object.assign.bind() : function(a) {
        for (var i = 1; i < arguments.length; i++) {
          var o = arguments[i];
          for (var f in o)
            Object.prototype.hasOwnProperty.call(o, f) && (a[f] = o[f]);
        }
        return a;
      }, b.apply(this, arguments);
    }
    function E(a, i) {
      if (a == null)
        return {};
      var o, f, j = function(Z, N) {
        if (Z == null)
          return {};
        var O, $, H = {}, z = Object.keys(Z);
        for ($ = 0; $ < z.length; $++)
          O = z[$], N.indexOf(O) >= 0 || (H[O] = Z[O]);
        return H;
      }(a, i);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (f = 0; f < x.length; f++)
          o = x[f], i.indexOf(o) >= 0 || Object.prototype.propertyIsEnumerable.call(a, o) && (j[o] = a[o]);
      }
      return j;
    }
    function k(a, i) {
      return i || (i = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(i) } }));
    }
    var L, P, R = { small: 14, default: 16, large: 20, xlarge: 24 }, Y = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], M = function(a) {
      var i = a.className, o = a.size, f = o === void 0 ? 16 : o, j = a.title, x = a["aria-label"], Z = a["aria-labelledby"], N = a.fill, O = a.role, $ = O === void 0 ? "img" : O, H = E(a, Y), z = u.css(L || (L = k([`
        color: `, `;
      `])), N), ie = u.css(P || (P = k([`
        flex-shrink: 0;
      `]))), X = function(ee, re, I) {
        var q, K = I["aria-label"], J = I["aria-labelledby"], W = I.title;
        switch (ee) {
          case "img":
            return K || J || W ? h(h(h({}, "aria-labelledby", J), "aria-label", K), "title", W) : { "aria-label": (q = re, "".concat(q.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }($, "ArrowLeft", h(h({ title: j }, "aria-label", x), "aria-labelledby", Z));
      return v.createElement("svg", b({ className: u.cx(h({}, z, N != null), ie, i), height: typeof f == "number" ? f : R[f], width: typeof f == "number" ? f : R[f], role: $ }, X, H, { viewBox: "0 0 16 16" }), v.createElement("path", { d: "M13 6.83212L6.05559 6.83212L7.59059 5.29711C7.98112 4.90659 7.98112 4.27342 7.59059 3.8829L7.35168 3.64398C6.96115 3.25346 6.32799 3.25345 5.93746 3.64398L2.55483 7.02661C2.5456 7.03518 2.5365 7.04395 2.52752 7.05292L2.2886 7.29184C1.89808 7.68237 1.89808 8.31553 2.2886 8.70605L5.93975 12.3572C6.33028 12.7477 6.96344 12.7477 7.35397 12.3572L7.59288 12.1183C7.98341 11.7278 7.98341 11.0946 7.59288 10.7041L6.0588 9.17L13 9.17C13.5523 9.17 14 8.72228 14 8.17V7.83212C14 7.27983 13.5523 6.83212 13 6.83212Z", fill: "currentColor" }));
    };
    return M.displayName = "ArrowLeft", M.isGlyph = !0, M.propTypes = { fill: g.default.string, size: g.default.oneOfType([g.default.number, g.default.string]), className: g.default.string }, M;
  });
})(Cf);
var vh = Cf.exports;
const mh = /* @__PURE__ */ Fe(vh);
var kf = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(w, _e, Ie);
  })(Te, function(n, r, u) {
    function d(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function p(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var i = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(o) {
        if (o !== "default") {
          var f = Object.getOwnPropertyDescriptor(a, o);
          Object.defineProperty(i, o, f.get ? f : { enumerable: !0, get: function() {
            return a[o];
          } });
        }
      }), i.default = a, Object.freeze(i);
    }
    var v = p(n), g = d(r);
    function m(a) {
      var i = function(o, f) {
        if (typeof o != "object" || !o)
          return o;
        var j = o[Symbol.toPrimitive];
        if (j !== void 0) {
          var x = j.call(o, f || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (f === "string" ? String : Number)(o);
      }(a, "string");
      return typeof i == "symbol" ? i : i + "";
    }
    function h(a, i, o) {
      return (i = m(i)) in a ? Object.defineProperty(a, i, { value: o, enumerable: !0, configurable: !0, writable: !0 }) : a[i] = o, a;
    }
    function b() {
      return b = Object.assign ? Object.assign.bind() : function(a) {
        for (var i = 1; i < arguments.length; i++) {
          var o = arguments[i];
          for (var f in o)
            Object.prototype.hasOwnProperty.call(o, f) && (a[f] = o[f]);
        }
        return a;
      }, b.apply(this, arguments);
    }
    function E(a, i) {
      if (a == null)
        return {};
      var o, f, j = function(Z, N) {
        if (Z == null)
          return {};
        var O, $, H = {}, z = Object.keys(Z);
        for ($ = 0; $ < z.length; $++)
          O = z[$], N.indexOf(O) >= 0 || (H[O] = Z[O]);
        return H;
      }(a, i);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (f = 0; f < x.length; f++)
          o = x[f], i.indexOf(o) >= 0 || Object.prototype.propertyIsEnumerable.call(a, o) && (j[o] = a[o]);
      }
      return j;
    }
    function k(a, i) {
      return i || (i = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(i) } }));
    }
    var L, P, R = { small: 14, default: 16, large: 20, xlarge: 24 }, Y = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], M = function(a) {
      var i = a.className, o = a.size, f = o === void 0 ? 16 : o, j = a.title, x = a["aria-label"], Z = a["aria-labelledby"], N = a.fill, O = a.role, $ = O === void 0 ? "img" : O, H = E(a, Y), z = u.css(L || (L = k([`
        color: `, `;
      `])), N), ie = u.css(P || (P = k([`
        flex-shrink: 0;
      `]))), X = function(ee, re, I) {
        var q, K = I["aria-label"], J = I["aria-labelledby"], W = I.title;
        switch (ee) {
          case "img":
            return K || J || W ? h(h(h({}, "aria-labelledby", J), "aria-label", K), "title", W) : { "aria-label": (q = re, "".concat(q.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }($, "ArrowRight", h(h({ title: j }, "aria-label", x), "aria-labelledby", Z));
      return v.createElement("svg", b({ className: u.cx(h({}, z, N != null), ie, i), height: typeof f == "number" ? f : R[f], width: typeof f == "number" ? f : R[f], role: $ }, X, H, { viewBox: "0 0 16 16" }), v.createElement("path", { d: "M3 6.83212L9.94442 6.83212L8.40941 5.29711C8.01888 4.90659 8.01889 4.27342 8.40941 3.8829L8.64833 3.64398C9.03885 3.25346 9.67201 3.25345 10.0625 3.64398L13.4452 7.02661C13.4544 7.03518 13.4635 7.04395 13.4725 7.05292L13.7114 7.29184C14.1019 7.68237 14.1019 8.31553 13.7114 8.70605L10.0602 12.3572C9.66972 12.7477 9.03656 12.7477 8.64603 12.3572L8.40712 12.1183C8.01659 11.7278 8.01659 11.0946 8.40712 10.7041L9.9412 9.17L3 9.17C2.44771 9.17 2 8.72228 2 8.17L2 7.83212C2 7.27983 2.44772 6.83212 3 6.83212Z", fill: "currentColor" }));
    };
    return M.displayName = "ArrowRight", M.isGlyph = !0, M.propTypes = { fill: g.default.string, size: g.default.oneOfType([g.default.number, g.default.string]), className: g.default.string }, M;
  });
})(kf);
var bh = kf.exports;
const yh = /* @__PURE__ */ Fe(bh);
var Mf = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(w, _e, Ie);
  })(Te, function(n, r, u) {
    function d(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    function p(a) {
      if (a && typeof a == "object" && "default" in a)
        return a;
      var i = /* @__PURE__ */ Object.create(null);
      return a && Object.keys(a).forEach(function(o) {
        if (o !== "default") {
          var f = Object.getOwnPropertyDescriptor(a, o);
          Object.defineProperty(i, o, f.get ? f : { enumerable: !0, get: function() {
            return a[o];
          } });
        }
      }), i.default = a, Object.freeze(i);
    }
    var v = p(n), g = d(r);
    function m(a) {
      var i = function(o, f) {
        if (typeof o != "object" || !o)
          return o;
        var j = o[Symbol.toPrimitive];
        if (j !== void 0) {
          var x = j.call(o, f || "default");
          if (typeof x != "object")
            return x;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (f === "string" ? String : Number)(o);
      }(a, "string");
      return typeof i == "symbol" ? i : i + "";
    }
    function h(a, i, o) {
      return (i = m(i)) in a ? Object.defineProperty(a, i, { value: o, enumerable: !0, configurable: !0, writable: !0 }) : a[i] = o, a;
    }
    function b() {
      return b = Object.assign ? Object.assign.bind() : function(a) {
        for (var i = 1; i < arguments.length; i++) {
          var o = arguments[i];
          for (var f in o)
            Object.prototype.hasOwnProperty.call(o, f) && (a[f] = o[f]);
        }
        return a;
      }, b.apply(this, arguments);
    }
    function E(a, i) {
      if (a == null)
        return {};
      var o, f, j = function(Z, N) {
        if (Z == null)
          return {};
        var O, $, H = {}, z = Object.keys(Z);
        for ($ = 0; $ < z.length; $++)
          O = z[$], N.indexOf(O) >= 0 || (H[O] = Z[O]);
        return H;
      }(a, i);
      if (Object.getOwnPropertySymbols) {
        var x = Object.getOwnPropertySymbols(a);
        for (f = 0; f < x.length; f++)
          o = x[f], i.indexOf(o) >= 0 || Object.prototype.propertyIsEnumerable.call(a, o) && (j[o] = a[o]);
      }
      return j;
    }
    function k(a, i) {
      return i || (i = a.slice(0)), Object.freeze(Object.defineProperties(a, { raw: { value: Object.freeze(i) } }));
    }
    var L, P, R = { small: 14, default: 16, large: 20, xlarge: 24 }, Y = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"], M = function(a) {
      var i = a.className, o = a.size, f = o === void 0 ? 16 : o, j = a.title, x = a["aria-label"], Z = a["aria-labelledby"], N = a.fill, O = a.role, $ = O === void 0 ? "img" : O, H = E(a, Y), z = u.css(L || (L = k([`
        color: `, `;
      `])), N), ie = u.css(P || (P = k([`
        flex-shrink: 0;
      `]))), X = function(ee, re, I) {
        var q, K = I["aria-label"], J = I["aria-labelledby"], W = I.title;
        switch (ee) {
          case "img":
            return K || J || W ? h(h(h({}, "aria-labelledby", J), "aria-label", K), "title", W) : { "aria-label": (q = re, "".concat(q.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon")) };
          case "presentation":
            return { "aria-hidden": !0, alt: "" };
        }
      }($, "OpenNewTab", h(h({ title: j }, "aria-label", x), "aria-labelledby", Z));
      return v.createElement("svg", b({ className: u.cx(h({}, z, N != null), ie, i), height: typeof f == "number" ? f : R[f], width: typeof f == "number" ? f : R[f], role: $ }, X, H, { viewBox: "0 0 16 16" }), v.createElement("path", { d: "M13.823 2.4491C13.8201 2.30008 13.6999 2.17994 13.5509 2.17704L9.5062 2.09836C9.25654 2.09351 9.12821 2.39519 9.30482 2.5718L10.3856 3.65257L7.93433 6.10383C7.87964 6.15852 7.83047 6.21665 7.78683 6.27752L5.99909 8.06525C5.46457 8.59977 5.46457 9.4664 5.99909 10.0009C6.53361 10.5354 7.40023 10.5354 7.93475 10.0009L9.72249 8.21317C9.78336 8.16953 9.84148 8.12037 9.89618 8.06567L12.3474 5.61441L13.4282 6.69518C13.6048 6.87179 13.9065 6.74347 13.9016 6.4938L13.823 2.4491Z", fill: "currentColor" }), v.createElement("path", { d: "M7.25 3.12893C7.66421 3.12893 8 3.46472 8 3.87893C8 4.29315 7.66421 4.62893 7.25 4.62893H4C3.72386 4.62893 3.5 4.85279 3.5 5.12893V11.9929C3.5 12.2691 3.72386 12.4929 4 12.4929H10.864C11.1401 12.4929 11.364 12.2691 11.364 11.9929V8.75C11.364 8.33579 11.6998 8 12.114 8C12.5282 8 12.864 8.33579 12.864 8.75V11.9929C12.864 13.0975 11.9686 13.9929 10.864 13.9929H4C2.89543 13.9929 2 13.0975 2 11.9929V5.12893C2 4.02436 2.89543 3.12893 4 3.12893H7.25Z", fill: "currentColor" }));
    };
    return M.displayName = "OpenNewTab", M.isGlyph = !0, M.propTypes = { fill: g.default.string, size: g.default.oneOfType([g.default.number, g.default.string]), className: g.default.string }, M;
  });
})(Mf);
var wh = Mf.exports;
const Oh = /* @__PURE__ */ Fe(wh);
function xh(e) {
  var t = function(n, r) {
    if (typeof n != "object" || !n)
      return n;
    var u = n[Symbol.toPrimitive];
    if (u !== void 0) {
      var d = u.call(n, r || "default");
      if (typeof d != "object")
        return d;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (r === "string" ? String : Number)(n);
  }(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function le(e, t, n) {
  return (t = xh(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Re() {
  return Re = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Re.apply(this, arguments);
}
function Ke(e, t) {
  if (e == null)
    return {};
  var n, r, u = function(p, v) {
    if (p == null)
      return {};
    var g, m, h = {}, b = Object.keys(p);
    for (m = 0; m < b.length; m++)
      g = b[m], v.indexOf(g) >= 0 || (h[g] = p[g]);
    return h;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(e);
    for (r = 0; r < d.length; r++)
      n = d[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (u[n] = e[n]);
  }
  return u;
}
function F(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
function jh(e, t) {
  return function(n) {
    if (Array.isArray(n))
      return n;
  }(e) || function(n, r) {
    var u = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
    if (u != null) {
      var d, p, v, g, m = [], h = !0, b = !1;
      try {
        if (v = (u = u.call(n)).next, r === 0) {
          if (Object(u) !== u)
            return;
          h = !1;
        } else
          for (; !(h = (d = v.call(u)).done) && (m.push(d.value), m.length !== r); h = !0)
            ;
      } catch (E) {
        b = !0, p = E;
      } finally {
        try {
          if (!h && u.return != null && (g = u.return(), Object(g) !== g))
            return;
        } finally {
          if (b)
            throw p;
        }
      }
      return m;
    }
  }(e, t) || function(n, r) {
    if (n) {
      if (typeof n == "string")
        return ru(n, r);
      var u = Object.prototype.toString.call(n).slice(8, -1);
      if (u === "Object" && n.constructor && (u = n.constructor.name), u === "Map" || u === "Set")
        return Array.from(n);
      if (u === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(u))
        return ru(n, r);
    }
  }(e, t) || function() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function ru(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var au, ou, lu, iu, cu, su, uu, fu, Zn = s(au || (au = F([`
  margin: unset;
  font-family: `, `;
  color: `, `;
`])), se.default, l.black), Lf = le(le({}, G.Body1, s(ou || (ou = F([`
    font-size: `, `px;
    line-height: `, `px;
  `])), A.body1.fontSize, A.body1.lineHeight)), G.Body2, s(lu || (lu = F([`
    font-size: `, `px;
    line-height: `, `px;
  `])), A.body2.fontSize, A.body2.lineHeight)), $h = le(le({}, G.Body1, s(iu || (iu = F([`
    font-size: `, `px;
    line-height: `, `px;
  `])), A.code1.fontSize, A.code1.lineHeight)), G.Body2, s(cu || (cu = F([`
    font-size: `, `px;
    line-height: `, `px;
  `])), A.code2.fontSize, A.code2.lineHeight)), et = le(le({}, y.Light, s(su || (su = F([`
    color: `, `;
  `])), l.black)), y.Dark, s(uu || (uu = F([`
    color: `, `;
  `])), l.gray.light2)), Pn = function(e) {
  var t = o1();
  return e ? e === 16 ? G.Body2 : G.Body1 : t === 16 ? G.Body2 : G.Body1;
}, Eh = ["baseFontSize", "darkMode", "className", "weight", "as"], Ch = be(function(e) {
  var t = e.baseFontSize, n = e.darkMode, r = e.className, u = e.weight, d = u === void 0 ? "regular" : u, p = e.as, v = p === void 0 ? "p" : p, g = Ke(e, Eh), m = Q(n).theme, h = Pn(t), b = ye(v).Component, E = s(fu || (fu = F([`
      font-weight: `, `;
      strong,
      b {
        font-weight: `, `;
      }
    `])), ne[d], ne.bold);
  return w.createElement(b, Re({ className: B(Zn, Lf[h], et[m], E, r) }, g));
});
Ch.displayName = "Body";
var du, gu, hu, pu, vu, mu, bu, yu, wu, Ou, kh = { label: "lg-label", description: "lg-description" };
s(du || (du = F([`
  font-family: `, `;
  font-weight: `, `;
  margin-top: 0;
  margin-bottom: 0;
`])), se.default, ne.regular);
le(le({}, y.Light, s(gu || (gu = F([`
    color: `, `;
  `])), l.gray.dark1)), y.Dark, s(hu || (hu = F([`
    color: `, `;
  `])), l.gray.light1));
le(le({}, y.Light, s(pu || (pu = F([`
    color: `, `;
  `])), l.gray.base)), y.Dark, s(vu || (vu = F([`
    color: `, `;
  `])), l.gray.dark1));
le(le({}, G.Body1, s(mu || (mu = F([`
    font-size: `, `px;
    line-height: `, `px;
  `])), A.body1.fontSize, A.body1.lineHeight)), G.Body2, s(bu || (bu = F([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), A.body2.fontSize));
var xu, ju, $u, Eu, Cu;
le(le({}, y.Light, s(yu || (yu = F([`
    color: `, `;
  `])), l.gray.dark1)), y.Dark, s(wu || (wu = F([`
    color: `, `;
  `])), l.gray.light1));
s(Ou || (Ou = F([`
  display: block;
  font-size: 11px;
  line-height: 16px;
  letter-spacing: 0.2px;
`])));
var ku, Mu, Lu, Zu, Pu, Su, Mh = s(xu || (xu = F([`
  font-family: `, `;
  font-weight: `, `;
  font-size: inherit;
  line-height: inherit;

  // Unsets browser default margins
  margin-block-start: 0;
  margin-block-end: 0;
`])), se.default, ne.regular), Lh = le(le({}, y.Light, s(ju || (ju = F([`
    color: `, `;
  `])), l.red.base)), y.Dark, s($u || ($u = F([`
    color: `, `;
  `])), l.red.light1)), Zh = le(le({}, G.Body1, s(Eu || (Eu = F([`
    font-size: `, `px;
    line-height: `, `px;
  `])), A.body1.fontSize, A.body1.lineHeight)), G.Body2, s(Cu || (Cu = F([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), A.body2.fontSize)), Ph = ["as", "darkMode", "children", "className"];
be(function(e) {
  var t = e.as, n = t === void 0 ? "p" : t, r = e.darkMode, u = e.children, d = e.className, p = Ke(e, Ph), v = Q(r).theme, g = Pn(), m = ye(n).Component;
  return w.createElement(m, Re({}, p, { className: B(Mh, Lh[v], Zh[g], d) }), u);
});
var Sh = s(ku || (ku = F([`
  font-weight: `, `;
  font-size: 48px;
  line-height: 62px;
  font-family: `, `;
`])), ne.regular, se.serif), Nh = le(le({}, y.Light, s(Mu || (Mu = F([`
    color: `, `;
  `])), l.green.dark2)), y.Dark, s(Lu || (Lu = F([`
    color: `, `;
  `])), l.gray.light2)), zh = ["darkMode", "className", "as"], Hh = be(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, u = r === void 0 ? "h1" : r, d = Ke(e, zh), p = Q(t).theme, v = ye(u).Component;
  return w.createElement(v, Re({ className: B(Zn, Sh, Nh[p], n) }, d));
});
Hh.displayName = "H1";
var Nu, Rh = s(Zu || (Zu = F([`
  font-size: 32px;
  line-height: 40px;
  font-weight: `, `;
  font-family: `, `;
`])), ne.regular, se.serif), Ah = le(le({}, y.Light, s(Pu || (Pu = F([`
    color: `, `;
  `])), l.green.dark2)), y.Dark, s(Su || (Su = F([`
    color: `, `;
  `])), l.gray.light2)), Bh = ["darkMode", "className", "as"], Dh = be(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, u = r === void 0 ? "h2" : r, d = Ke(e, Bh), p = Q(t).theme, v = ye(u).Component;
  return w.createElement(v, Re({ className: B(Zn, Rh, Ah[p], n) }, d));
});
Dh.displayName = "H2";
var zu, Hu, Ru, Au, Bu, Du, Vu, Tu, Fu, Iu, Vh = s(Nu || (Nu = F([`
  font-size: 24px;
  line-height: 32px;
  font-weight: `, `;
`])), ne.medium), Th = ["darkMode", "className", "as"], Fh = be(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, u = r === void 0 ? "h3" : r, d = Ke(e, Th), p = Q(t).theme, v = ye(u).Component;
  return w.createElement(v, Re({ className: B(Zn, Vh, et[p], n) }, d));
});
Fh.displayName = "H3";
var _u, Gu, Uu, $n = Ae(), Ih = s(zu || (zu = F([`
  display: inline;
  transition: all 0.15s ease-in-out;
  border-radius: 3px;
  font-family: `, `;
  line-height: 20px;

  .`, `:hover > & {
    text-decoration: none;
  }
`])), se.code, $n), _h = le(le({}, y.Light, s(Hu || (Hu = F([`
    background-color: `, `;
    border: 1px solid `, `;
    color: `, `;

    .`, `:hover > & {
      box-shadow: 0 0 0 3px `, `;
      border: 1px solid `, `;
    }
  `])), l.gray.light3, l.gray.light2, l.gray.dark3, $n, l.gray.light2, l.gray.light1)), y.Dark, s(Ru || (Ru = F([`
    background-color: transparent;
    border: 1px solid `, `;
    color: `, `;

    .`, `:hover > & {
      box-shadow: 0 0 0 3px `, `;
      border: 1px solid `, `;
    }
  `])), l.gray.dark2, l.gray.light1, $n, l.gray.dark2, l.gray.dark1)), Gh = le(le({}, y.Light, s(Au || (Au = F([`
    .`, `:focus-visible > & {
      box-shadow: `, `;
      border: 1px solid `, `;
    }
  `])), $n, We[y.Light].default, l.blue.base)), y.Dark, s(Bu || (Bu = F([`
    .`, `:focus-visible > & {
      box-shadow: `, `;
      border: 1px solid `, `;
    }
  `])), $n, We[y.Dark].default, l.blue.base)), Uh = le(le({}, y.Light, s(Du || (Du = F([`
    color: `, `;
  `])), l.blue.base)), y.Dark, s(Vu || (Vu = F([`
    color: `, `;
  `])), l.blue.light1)), Wh = s(Tu || (Tu = F([`
  text-decoration: none;
  margin: 0;
  padding: 0;
  line-height: 20px;

  &:focus {
    outline: none;
  }
`]))), Yh = s(Fu || (Fu = F([`
  white-space: nowrap;
`]))), Xh = s(Iu || (Iu = F([`
  white-space: normal;
`]))), qh = ["children", "className", "darkMode", "baseFontSize", "as"], Wu = Xe(function(e, t) {
  var n, r, u = e.children, d = e.className, p = e.darkMode, v = e.baseFontSize, g = e.as, m = Ke(e, qh), h = Q(p).theme, b = Pn(v), E = sn(g, m, "code").Component, k = ((n = typeof u == "string" && ((r = u.match(/(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g)) === null || r === void 0 ? void 0 : r.length)) !== null && n !== void 0 ? n : 0) <= 30 ? Yh : Xh, L = E !== "code", P = w.createElement("code", { ref: t, className: B($h[b], Ih, _h[h], Gh[h], k, le({}, Uh[h], L), d) }, u);
  return L ? w.createElement(E, Re({ className: B($n, Wh, d) }, m), P) : w.cloneElement(P, m);
});
Wu.displayName = "InlineCode", Wu.propTypes = { children: fe.node, className: fe.string, darkMode: fe.bool, baseFontSize: fe.oneOf(Object.values(G)) };
var Yu, Xu, qu, Ku, Ju, Qu, e3;
s(_u || (_u = F([`
  font-family: `, `;
  border: 1px solid;
  border-radius: 3px;
  padding-left: 5px;
  padding-right: 5px;
`])), se.code);
le(le({}, y.Light, s(Gu || (Gu = F([`
    color: `, `;
    border-color: `, `;
    background-color: `, `;
  `])), l.black, l.gray.dark3, l.white)), y.Dark, s(Uu || (Uu = F([`
    color: `, `;
    border-color: `, `;
    background-color: `, `;
  `])), l.gray.light2, l.gray.base, l.gray.dark3));
var n3, t3, r3, Kh = s(Yu || (Yu = F([`
  font-family: `, `;
  font-weight: `, `;
`])), se.default, ne.bold), Jh = le(le({}, y.Light, s(Xu || (Xu = F([`
    color: `, `;
  `])), l.black)), y.Dark, s(qu || (qu = F([`
    color: `, `;
  `])), l.gray.light2)), Qh = le(le({}, y.Light, s(Ku || (Ku = F([`
    color: `, `;
  `])), l.gray.base)), y.Dark, s(Ju || (Ju = F([`
    color: `, `;
  `])), l.gray.dark1)), e7 = le(le({}, G.Body1, s(Qu || (Qu = F([`
    font-size: `, `px;
    line-height: `, `px;
  `])), A.body1.fontSize, A.body1.lineHeight)), G.Body2, s(e3 || (e3 = F([`
    font-size: `, `px;
    line-height: 20px; // Hardcoding because it does not match body2 lineHeight
  `])), A.body2.fontSize)), n7 = ["baseFontSize", "darkMode", "className", "children", "disabled", "as", "data-lgid"], t7 = be(function(e) {
  var t = e.baseFontSize, n = e.darkMode, r = e.className, u = e.children, d = e.disabled, p = d !== void 0 && d, v = e.as, g = v === void 0 ? "label" : v, m = e["data-lgid"], h = m === void 0 ? kh.label : m, b = Ke(e, n7), E = Q(n).theme, k = Pn(t), L = ye(g).Component;
  return w.createElement(L, Re({ "data-lgid": h, className: B(Kh, Jh[E], e7[k], le({}, Qh[E], p), r) }, b), u);
});
t7.displayName = "Label";
var a3, o3, l3, i3, c3, s3, Xn = Ae(), Zf = s(n3 || (n3 = F([`
  font-family: `, `;
  display: inline;
  align-items: center;
  text-decoration: none;
  text-decoration-color: transparent;
  cursor: pointer;
  font-size: inherit;
  line-height: inherit;
  appearance: none;
  background: none;
  border: none;
  padding: 0;

  &:hover,
  &[data-hover='true'],
  &:focus,
  &[data-focus='true'] {
    text-decoration: underline;
    transition: text-decoration `, `ms ease-in-out;
    text-underline-offset: 4px;
    text-decoration-thickness: 2px;
  }

  &:focus {
    outline: none;
  }
`])), se.default, Ye.default), Pf = le(le({}, y.Light, s(t3 || (t3 = F([`
    color: `, `;
    font-weight: `, `;

    &:hover,
    &[data-hover='true'] {
      text-decoration-color: `, `;
    }

    &:focus,
    &[data-focus='true'] {
      text-decoration-color: `, `;
    }
  `])), l.blue.base, ne.regular, l.gray.light2, l.blue.base)), y.Dark, s(r3 || (r3 = F([`
    color: `, `;
    font-weight: `, `;

    &:hover,
    &[data-hover='true'] {
      text-decoration-color: `, `;
    }

    &:focus,
    &[data-focus='true'] {
      text-decoration-color: `, `;
    }
  `])), l.blue.light1, ne.bold, l.gray.dark2, l.blue.base)), Sf = function(e) {
  if (e)
    return Lf[e];
}, r7 = s(a3 || (a3 = F([`
  gap: `, `px;
  display: inline-flex;
`])), he[100]), a7 = ["children", "className", "baseFontSize", "darkMode", "as"];
Xe(function(e, t) {
  var n = e.children, r = e.className, u = e.baseFontSize, d = e.darkMode, p = e.as, v = Ke(e, a7), g = Q(d).theme, m = Pn(u), h = sn(p, v, "span").Component;
  return w.createElement(h, Re({ className: B(Xn, Zf, Sf(m), Pf[g], r7, r), ref: t }, v), w.createElement(mh, { role: "presentation" }), n);
});
var o7 = s(o3 || (o3 = F([`
  transform: translate3d(3px, 0, 0);
  top: 1px;
  position: relative;
`]))), l7 = s(l3 || (l3 = F([`
  opacity: 0;
  transform: translate3d(-3px, 0, 0);
  transition: 100ms ease-in;
  transition-property: opacity, transform;
  top: 1px;
  position: relative;

  .`, ":hover &, .", `[data-hover='true'] & {
    opacity: 1;
    transform: translate3d(3px, 0, 0);
  }
`])), Xn, Xn), i7 = s(i3 || (i3 = F([`
  position: relative;
  bottom: 2px;
  left: -1px;
  height: 12px;
`]))), c7 = "hover", s7 = "persist", u3 = "none", u7 = ["children", "className", "arrowAppearance", "hideExternalIcon", "baseFontSize", "darkMode", "as"];
Xe(function(e, t) {
  var n = e.children, r = e.className, u = e.arrowAppearance, d = u === void 0 ? u3 : u, p = e.hideExternalIcon, v = p !== void 0 && p, g = e.baseFontSize, m = e.darkMode, h = e.as, b = Ke(e, u7), E = jh(Ue(""), 2), k = E[0], L = E[1];
  Dn(function() {
    L(window.location.hostname);
  }, []);
  var P, R = Q(m).theme, Y = Pn(g), M = sn(h, b, "span").Component, a = En(function() {
    if (b.href !== void 0)
      return /^http(s)?:\/\//.test(b.href) ? new URL(b.href).hostname : k;
  }, [b, k]), i = { target: void 0, rel: void 0 };
  return b.target || b.rel ? (i.target = b.target, i.rel = b.rel) : M === "a" && (a === k ? i.target = "_self" : (i.target = "_blank", i.rel = "noopener noreferrer")), i.target !== "_blank" || v ? d !== u3 && (P = w.createElement(yh, { role: "presentation", size: 12, className: B(le(le({}, l7, d === c7), o7, d === s7)) })) : P = w.createElement(Oh, { role: "presentation", className: i7 }), w.createElement(M, Re({ className: B(Xn, Zf, Sf(Y), Pf[R], r), ref: t }, i, b), w.createElement("span", null, n), P);
});
var f7 = s(c3 || (c3 = F([`
  font-size: 12px;
  font-weight: `, `;
  text-transform: uppercase;
  line-height: 20px;
  letter-spacing: 0.4px;
`])), ne.bold), d7 = ["darkMode", "className", "as"], Nf = be(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, u = r === void 0 ? "div" : r, d = Ke(e, d7), p = Q(t).theme, v = ye(u).Component;
  return w.createElement(v, Re({ className: B(Zn, f7, et[p], n) }, d));
});
Nf.displayName = "Overline";
var g7 = s(s3 || (s3 = F([`
  font-size: 18px;
  line-height: 24px;
  font-weight: `, `;
`])), ne.bold), h7 = ["darkMode", "className", "as"], p7 = be(function(e) {
  var t = e.darkMode, n = e.className, r = e.as, u = r === void 0 ? "h6" : r, d = Ke(e, h7), p = Q(t).theme, v = ye(u).Component;
  return w.createElement(v, Re({ className: B(Zn, g7, et[p], n) }, d));
});
p7.displayName = "Subtitle";
var f3;
s(f3 || (f3 = F([`
  flex: 1;
  min-width: 0;
  max-width: 100%;

  white-space: inherit;
  overflow: inherit;
  text-overflow: inherit;
`])));
function d3(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(u) {
      return Object.getOwnPropertyDescriptor(e, u).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Fn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? d3(Object(n), !0).forEach(function(r) {
      we(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : d3(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function v7(e) {
  var t = function(n, r) {
    if (typeof n != "object" || !n)
      return n;
    var u = n[Symbol.toPrimitive];
    if (u !== void 0) {
      var d = u.call(n, r || "default");
      if (typeof d != "object")
        return d;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (r === "string" ? String : Number)(n);
  }(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function we(e, t, n) {
  return (t = v7(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function cn() {
  return cn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, cn.apply(this, arguments);
}
function c1(e, t) {
  if (e == null)
    return {};
  var n, r, u = function(p, v) {
    if (p == null)
      return {};
    var g, m, h = {}, b = Object.keys(p);
    for (m = 0; m < b.length; m++)
      g = b[m], v.indexOf(g) >= 0 || (h[g] = p[g]);
    return h;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(e);
    for (r = 0; r < d.length; r++)
      n = d[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (u[n] = e[n]);
  }
  return u;
}
function me(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
function zn(e, t) {
  return function(n) {
    if (Array.isArray(n))
      return n;
  }(e) || function(n, r) {
    var u = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
    if (u != null) {
      var d, p, v, g, m = [], h = !0, b = !1;
      try {
        if (v = (u = u.call(n)).next, r === 0) {
          if (Object(u) !== u)
            return;
          h = !1;
        } else
          for (; !(h = (d = v.call(u)).done) && (m.push(d.value), m.length !== r); h = !0)
            ;
      } catch (E) {
        b = !0, p = E;
      } finally {
        try {
          if (!h && u.return != null && (g = u.return(), Object(g) !== g))
            return;
        } finally {
          if (b)
            throw p;
        }
      }
      return m;
    }
  }(e, t) || function(n, r) {
    if (n) {
      if (typeof n == "string")
        return g3(n, r);
      var u = Object.prototype.toString.call(n).slice(8, -1);
      if (u === "Object" && n.constructor && (u = n.constructor.name), u === "Map" || u === "Set")
        return Array.from(n);
      if (u === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(u))
        return g3(n, r);
    }
  }(e, t) || function() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function g3(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var h3, p3, v3, m3, b3, y3, w3, O3, x3, j3, $3, E3, C3, k3, M3, L3, Z3, P3, S3, N3, z3, m7 = s(h3 || (h3 = me([`
  width: 100%;
  position: relative;
`]))), b7 = s(p3 || (p3 = me([`
  width: 100%;
  display: grid;
  grid-template-columns: auto 1fr auto;
  position: relative;
  border-radius: 8px;
  border: 1px solid `, `;
  z-index: 2;

  &:disabled {
    cursor: not-allowed;

    &:hover,
    &:active {
      box-shadow: none;
    }
  }
`])), l.gray.base), y7 = s(v3 || (v3 = me([`
  border-color: transparent;
`]))), w7 = we(we({}, y.Dark, s(m3 || (m3 = me([`
    background-color: `, `;
    color: `, `;
  `])), l.black, l.white)), y.Light, s(b3 || (b3 = me([`
    background-color: `, `;
    color: black;
  `])), l.white)), O7 = s(y3 || (y3 = me([`
  display: flex;
  gap: `, `px;
  align-items: center;
  align-self: top;
  height: 36px; // hard set to height of textarea
  padding: `, "px 0px ", "px ", `px;
  background-color: inherit;
  border-top-left-radius: inherit;
  border-bottom-left-radius: inherit;
`])), he[2], he[1], he[1], he[2]), x7 = s(w3 || (w3 = me([`
  display: flex;
  align-items: flex-end;
  gap: `, `px;
  padding: `, `px;
  background-color: inherit;
  border-top-right-radius: inherit;
  border-bottom-right-radius: inherit;
`])), he[2], he[1]), j7 = s(O3 || (O3 = me([`
  flex: 1;
  font-size: `, `px;
  font-family: `, `;
  font-weight: `, `;
  height: 36px;
  padding: `, `px;
  outline: none;
  border: none;
  transition: `, `ms ease-in-out;
  transition-property: border-color, box-shadow;
  overflow-y: scroll;
  resize: none; // to remove bottom right diagonal lines
  box-sizing: content-box;
  line-height: `, `px;
  max-height: 160px;
  background-color: inherit;
  color: inherit;
  margin: 0; // firefox creates margins on textareas - remove it for consistent sizing

  &:disabled {
    &::placeholder {
      color: inherit;
    }

    &:disabled:-webkit-autofill {
      &,
      &:hover,
      &:focus {
        appearance: none;
        -webkit-text-fill-color: `, `;
      }
    }
  }
`])), G.Body1, se.default, ne.regular, he[2], Ye.default, A.body1.lineHeight, l.gray.base), r1 = we(we({}, y.Dark, s(x3 || (x3 = me([`
    color: `, `;
    background-color: `, `;
    border-color: `, `;
  `])), l.gray.dark1, l.gray.dark3, l.gray.dark2)), y.Light, s(j3 || (j3 = me([`
    color: `, `;
    background-color: `, `;
    border-color: `, `;
  `])), l.gray.base, l.gray.light2, l.gray.light1)), $7 = we(we({}, y.Dark, s($3 || ($3 = me([`
    background-color: `, `;
    color: `, `;
    &:disabled {
      `, `
    }
  `])), l.black, l.white, r1[y.Dark])), y.Light, s(E3 || (E3 = me([`
    background-color: `, `;
    color: black;
    &:disabled {
      `, `
    }
    &::placeholder {
      color: `, `;
    }
  `])), l.white, r1[y.Light], l.gray.base)), E7 = s(C3 || (C3 = me([`
  border-radius: 8px;
`]))), C7 = s(k3 || (k3 = me([`
  box-shadow: `, `;
  border-color: transparent;
  transition: `, `ms ease-in-out;
  transition-property: border-color, box-shadow;
`])), We.light.input, Ye.default), k7 = s(M3 || (M3 = me([`
  &:before,
  &:after {
    content: '';
    position: absolute;
    top: -`, `px;
    left: -`, `px;
    width: calc(100% + `, `px);
    height: calc(100% + `, `px);
    border-radius: 12px;
    background-color: `, `;
    background-size: 400% 400%;
    background-position: 800% 800%; // set final state of animation
  }

  &:after {
    animation: 4s animateBg linear;
  }

  &:before {
    filter: blur(4px) opacity(0.6);
    animation: 4s animateBg, animateShadow linear infinite;
    opacity: 0;
  }

  @keyframes animateBg {
    0% {
      background-position: 400% 400%;
      background-image: linear-gradient(
        20deg,
        `, ` 0%,
        `, ` 30%,
        #00ede0 45%,
        #00ebc1 75%,
        #0498ec
      );
    }
    100% {
      background-position: 0% 0%;
      background-image: linear-gradient(
        20deg,
        `, ` 0%,
        `, ` 30%,
        #00ede0 45%,
        #00ebc1 75%,
        #0498ec
      );
    }
  }

  @keyframes animateShadow {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
`])), 4, 4, 8, 8, l.blue.light1, l.blue.light1, l.blue.light1, l.blue.light1, l.blue.light1), M7 = s(L3 || (L3 = me([`
  &:hover {
    box-shadow: none;
  }
`]))), H3 = function(e, t) {
  return e === y.Dark ? t ? l.gray.dark1 : l.gray.light1 : t ? l.gray.base : l.gray.dark1;
}, L7 = i1("Return", function(e) {
  return w.createElement("svg", cn({ width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, e), w.createElement("g", { id: "Return" }, w.createElement("path", { id: "Union", d: "M5 2C4.44772 2 4 2.44772 4 3C4 3.55228 4.44772 4 5 4H10C11.3807 4 12.5 5.11929 12.5 6.5C12.5 7.88071 11.3807 9 10 9H5.20328L6.65079 7.75927C7.07012 7.39985 7.11868 6.76855 6.75926 6.34923C6.39983 5.9299 5.76853 5.88134 5.34921 6.24076L1.84921 9.24076C1.62756 9.43074 1.5 9.70809 1.5 10C1.5 10.2919 1.62756 10.5693 1.84921 10.7593L5.34921 13.7593C5.76853 14.1187 6.39983 14.0701 6.75926 13.6508C7.11868 13.2315 7.07012 12.6002 6.65079 12.2408L5.20324 11H10C12.4853 11 14.5 8.98528 14.5 6.5C14.5 4.01472 12.4853 2 10 2H5Z", fill: "currentColor" })));
}), Z7 = i1("Sparkle", function(e) {
  return w.createElement("svg", cn({ width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, e), w.createElement("path", { d: "M6.27334 2.89343L5.27501 5.88842C5.1749 6.18877 4.93922 6.42445 4.63887 6.52456L1.64388 7.52289C1.18537 7.67573 1.18537 8.32427 1.64388 8.47711L4.63887 9.47544C4.93922 9.57555 5.1749 9.81123 5.27501 10.1116L6.27334 13.1066C6.42618 13.5651 7.07472 13.5651 7.22756 13.1066L8.22589 10.1116C8.326 9.81123 8.56168 9.57555 8.86203 9.47544L11.857 8.47711C12.3155 8.32427 12.3155 7.67573 11.857 7.52289L8.86203 6.52456C8.56168 6.42445 8.326 6.18877 8.22589 5.88842L7.22756 2.89343C7.07472 2.43492 6.42618 2.43492 6.27334 2.89343Z", fill: "currentColor" }), w.createElement("path", { d: "M12.5469 1.17194L12.3158 1.8651C12.2157 2.16545 11.98 2.40113 11.6797 2.50125L10.9865 2.7323C10.7573 2.80872 10.7573 3.13299 10.9865 3.20941L11.6797 3.44046C11.98 3.54058 12.2157 3.77626 12.3158 4.0766L12.5469 4.76977C12.6233 4.99902 12.9476 4.99902 13.024 4.76977L13.255 4.0766C13.3552 3.77626 13.5908 3.54058 13.8912 3.44046L14.5843 3.20941C14.8136 3.13299 14.8136 2.80872 14.5843 2.7323L13.8912 2.50125C13.5908 2.40113 13.3552 2.16545 13.255 1.8651L13.024 1.17194C12.9476 0.942687 12.6233 0.942687 12.5469 1.17194Z", fill: "currentColor" }), w.createElement("path", { d: "M12.5469 11.2302L12.3158 11.9234C12.2157 12.2237 11.98 12.4594 11.6797 12.5595L10.9865 12.7906C10.7573 12.867 10.7573 13.1913 10.9865 13.2677L11.6797 13.4988C11.98 13.5989 12.2157 13.8346 12.3158 14.1349L12.5469 14.8281C12.6233 15.0573 12.9476 15.0573 13.024 14.8281L13.255 14.1349C13.3552 13.8346 13.5908 13.5989 13.8912 13.4988L14.5843 13.2677C14.8136 13.1913 14.8136 12.867 14.5843 12.7906L13.8912 12.5595C13.5908 12.4594 13.3552 12.2237 13.255 11.9234L13.024 11.2302C12.9476 11.001 12.6233 11.001 12.5469 11.2302Z", fill: "currentColor" }));
}), P7 = ["className", "textareaProps", "onMessageSend", "onSubmit", "shouldRenderGradient", "badgeText", "darkMode", "disabled", "disableSend", "children", "dropdownFooterSlot", "dropdownProps"], zf = _3(function(e, t) {
  var n, r, u = e.className, d = e.textareaProps, p = e.onMessageSend, v = e.onSubmit, g = e.shouldRenderGradient, m = g === void 0 || g, h = e.badgeText, b = e.darkMode, E = e.disabled, k = e.disableSend, L = e.children, P = e.dropdownFooterSlot, R = e.dropdownProps, Y = c1(e, P7), M = U3(t, null), a = ln(null), i = ln(null), o = ln(null), f = W3({ prefix: "suggested-prompt" }), j = zn(Ue(!1), 2), x = j[0], Z = j[1], N = zn(Ue((n = d == null || (r = d.value) === null || r === void 0 ? void 0 : r.toString()) !== null && n !== void 0 ? n : ""), 2), O = N[0], $ = N[1], H = zn(Ue(!1), 2), z = H[0], ie = H[1], X = zn(Ue(void 0), 2), ee = X[0], re = X[1], I = f("".concat(ee)), q = zn(Ue(!1), 2), K = q[0], J = q[1], W = Q(b), un = W.darkMode, Be = W.theme, Je = Yf().containerWidth, nn = m && x && !E, fn = function() {
    return k || E || O === "";
  }, tn = !en(L), bn = _n(function() {
    var ce = 0, Oe = o4(L).map(function Se(xe) {
      if (Gn(xe, "SuggestedPrompt")) {
        var Qe, De = (ce += 1) - 1, gn = qn(xe);
        return w.cloneElement(xe, Fn(Fn({}, xe.props), {}, { id: "suggested-prompt-".concat(De), key: "suggested-prompt-".concat(De), ref: (Qe = xe.props.ref) !== null && Qe !== void 0 ? Qe : f == null ? void 0 : f("".concat(De)), highlighted: De === ee, onClick: function(pn) {
          var vn, yn;
          (vn = (yn = xe.props).onClick) === null || vn === void 0 || vn.call(yn, pn), $(gn);
          var Sn = setTimeout(function() {
            var an;
            M == null || (an = M.current) === null || an === void 0 || an.requestSubmit(), clearTimeout(Sn);
          });
          je();
        } }));
      }
      if (Gn(xe, "SuggestedPrompts")) {
        var rn = w.Children.map(xe.props.children, Se);
        if (rn && rn.length > 0)
          return w.cloneElement(xe, Fn(Fn({}, xe.props), {}, { children: rn }));
      }
    });
    return { resultsCount: ce, updatedChildren: Oe };
  }, [L, ee, o, f, $]), dn = En(function() {
    return bn();
  }, [bn]), _ = dn.updatedChildren, ue = dn.resultsCount;
  Dn(function() {
    var ce = Je !== void 0 && Je >= Bf.Mobile;
    ce !== K && J(ce);
  }, [Je]);
  var ve = function(ce) {
    switch (ce) {
      case "first":
        re(0);
        break;
      case "last":
        re(ue);
        break;
      case "next":
        var Oe = !en(ee) && ee + 1 < ue ? ee + 1 : 0;
        re(Oe);
        break;
      case "prev":
        var Se = !en(ee) && ee - 1 >= 0 ? ee - 1 : ue - 1;
        re(Se);
    }
  }, je = function() {
    ie(!1), re(void 0);
  }, $e = function() {
    return ie(!0);
  };
  return Y3(I, i, 12), X3(function() {
    je();
  }, [a, i], z && tn), w.createElement(q3, { darkMode: un }, w.createElement("form", cn({ className: B(m7, u), onSubmit: function(ce) {
    ce.preventDefault(), fn() || (p && O && (p(O, ce), $("")), v == null || v(ce));
  }, ref: M }, Y), w.createElement("div", { className: B(E7, we(we({}, k7, nn), C7, !nn && x && !E)), ref: a }, w.createElement("div", { className: B(b7, w7[Be], we(we({}, r1[Be], E), y7, x)) }, w.createElement("div", { className: O7 }, w.createElement(Z7, { fill: H3(Be, E) }), h && w.createElement(Xf, { variant: "blue" }, h)), w.createElement(w4, cn({ placeholder: "Type your message here", value: O, disabled: E }, d ?? {}, { className: B(j7, $7[Be], d == null ? void 0 : d.className), onKeyDown: function(ce) {
    var Oe, Se, xe = (Oe = i.current) === null || Oe === void 0 ? void 0 : Oe.contains(document.activeElement);
    if (!((Se = a.current) === null || Se === void 0) && Se.contains(document.activeElement) || xe)
      switch (ce.key) {
        case "Enter":
          var Qe, De;
          if (ce.preventDefault(), en(ee))
            if (ce.ctrlKey || ce.shiftKey) {
              if (ce.ctrlKey || ce.shiftKey) {
                var gn;
                (function(an, Hf) {
                  var Rf = an.value;
                  an.value = Hf;
                  var s1 = an == null ? void 0 : an._valueTracker;
                  s1 && s1.setValue(Rf), an.dispatchEvent(new Event("change", { bubbles: !0 }));
                })(o == null ? void 0 : o.current, O + `
`), $(O + `
`);
                var rn = new Event("change", { bubbles: !0 });
                (gn = o.current) === null || gn === void 0 || gn.dispatchEvent(rn);
              }
            } else
              (Qe = M.current) === null || Qe === void 0 || Qe.requestSubmit();
          else
            I == null || (De = I.current) === null || De === void 0 || De.click();
          break;
        case "Escape":
          var pn;
          je(), (pn = o.current) === null || pn === void 0 || pn.focus();
          break;
        case "ArrowDown":
          var vn;
          tn && ((vn = o.current) === null || vn === void 0 || vn.focus(), $e(), ce.preventDefault(), en(ee) ? re(0) : ve("next"));
          break;
        case "ArrowUp":
          var yn;
          tn && ((yn = o.current) === null || yn === void 0 || yn.focus(), $e(), ce.preventDefault(), en(ee) ? re(ue - 1) : ve("prev"));
          break;
        case "Tab":
          z && je();
          break;
        default:
          var Sn;
          d != null && d.onKeyDown && (d == null || (Sn = d.onKeyDown) === null || Sn === void 0 || Sn.call(d, ce)), je();
      }
  }, onChange: function(ce) {
    var Oe;
    $(ce.target.value), d != null && d.onChange && (d == null || (Oe = d.onChange) === null || Oe === void 0 || Oe.call(d, ce));
  }, onFocus: function(ce) {
    Z(!0), $e();
  }, onBlur: function(ce) {
    Z(!1);
  }, ref: o })), w.createElement("div", { className: x7 }, w.createElement(it, { size: "small", rightGlyph: w.createElement(L7, { fill: H3(Be, E) }), type: "submit", disabled: fn(), className: B(we({}, M7, fn())) }, K && "Enter")))), tn && w.createElement(l1, cn({ open: z, refEl: a, ref: i, footerSlot: P }, R), _)));
});
zf.displayName = "InputBar";
var R3, A3, B3, D3, V3, Bn = Ae("suggested-prompt"), S7 = s(Z3 || (Z3 = me([`
  display: block;
  font-family: `, `;
  font-size: `, `px;
  line-height: `, `px;
  padding: 12px 24px;
`])), se.default, A.body1.fontSize, he[3]), N7 = we(we({}, y.Light, s(P3 || (P3 = me([`
    & .`, ` {
      color: `, `;
    }
  `])), Bn, l.black)), y.Dark, s(S3 || (S3 = me([`
    & .`, ` {
      color: `, `;
    }
  `])), Bn, l.gray.light2)), z7 = we(we({}, y.Light, s(N3 || (N3 = me([`
    & .`, ` {
      color: `, `;
    }
  `])), Bn, l.gray.light1)), y.Dark, s(z3 || (z3 = me([`
    & .`, ` {
      color: `, `;
    }
  `])), Bn, l.gray.dark1)), H7 = ["as", "children", "disabled", "className", "darkMode"], R7 = Xe(function(e, t) {
  var n, r = e.as, u = r === void 0 ? "li" : r, d = e.children, p = e.disabled, v = e.className, g = e.darkMode, m = c1(e, H7), h = Q(g).theme, b = qn(d), E = (n = m["aria-label"]) !== null && n !== void 0 ? n : m["aria-labelledby"] ? "" : b;
  return w.createElement(kn, cn({}, m, { as: u, ref: t, className: B(S7, N7[h], we({}, z7[h], p), v), disabled: p, "aria-labelledby": m["aria-labelledby"], "aria-label": E }), w.createElement("div", { className: Bn }, d));
}, "SuggestedPrompt");
R7.displayName = "SuggestedPrompt";
var A7 = we(we({}, y.Light, s(R3 || (R3 = me([`
    & + & {
      border-top: 1px solid `, `;
    }
  `])), l.gray.light2)), y.Dark, s(A3 || (A3 = me([`
    & + & {
      border-top: 1px solid `, `;
    }
  `])), l.gray.dark2)), B7 = s(B3 || (B3 = me([`
  padding: 12px 24px;
  padding-bottom: 0;
`]))), D7 = we(we({}, y.Light, s(D3 || (D3 = me([`
    color: `, `;
  `])), l.gray.dark1)), y.Dark, s(V3 || (V3 = me([`
    color: `, `;
  `])), l.gray.base)), V7 = ["children", "label"], T7 = function(e) {
  var t = e.children, n = e.label, r = c1(e, V7), u = Qf(t, ["SuggestedPrompt", "SuggestedPrompts"]), d = Q().theme;
  return w.createElement("div", { className: A7[d] }, w.createElement(kn, cn({ "aria-label": n, isInteractive: !1, className: B7 }, r), w.createElement(Nf, { className: D7[d] }, n)), u);
};
T7.displayName = "SuggestedPrompts";
const a1 = {
  chatbot_input_error_border: nt`
    > div {
      > div {
        border-color: ${l.red.base} !important;
        border-width: 2px !important;
      }
    }
  `,
  suggested_prompts_menu: nt`
    [data-testid="lg-search-input-popover"] {
      z-index: 1;
    }
  `,
  character_count: ({
    darkMode: e,
    isError: t
  }) => nt`
    white-space: nowrap;
    color: ${t ? l.red.base : e ? l.gray.light2 : l.gray.dark2};
  `
}, Q7 = _3(
  function({ children: t, hasError: n, ...r }, u) {
    return /* @__PURE__ */ F3.jsx(
      zf,
      {
        ref: u,
        className: I3(
          a1.suggested_prompts_menu,
          n ?? !1 ? a1.chatbot_input_error_border : void 0
        ),
        shouldRenderGradient: !n,
        ...r,
        children: t
      }
    );
  }
);
function ep({
  current: e,
  max: t,
  darkMode: n,
  className: r
}) {
  return /* @__PURE__ */ F3.jsx(
    Df,
    {
      className: I3(
        a1.character_count({
          darkMode: n,
          isError: e > t
        }),
        r
      ),
      children: `${e} / ${t}`
    }
  );
}
function np() {
  const { awaitingReply: e, chatbotName: t } = e4();
  return e ? t ? `${t} is answering...` : "Answering..." : t ? `Ask ${t} a Question` : "Ask a Question";
}
const tp = "This is an experimental generative AI chatbot. All information should be verified prior to use.", rp = "Something went wrong. Try reloading the page and starting a new conversation.";
export {
  ep as C,
  Q7 as I,
  T7 as J,
  np as M,
  kn as U,
  st as W,
  R7 as Z,
  it as a,
  rp as d,
  Ee as k,
  tp as m,
  $g as r,
  D as x
};
